import {InputLabel, Table, TableCell, TableHead, TableRow, LinearProgress, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox, RadioGroup, Radio, Drawer, FormHelperText, ListSubheader, Switch} from "@material-ui/core"
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Stack from '@mui/material/Stack';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import Carousel from 'react-material-ui-carousel'
import {preventDoubleClick} from "./preventDC.js"
import { v4 as uuidv4 } from 'uuid';
import { fetchVisaData, fetchTokenData, updateTokenData, fetchToken, fetchflights, rzsearchhotelbyid, fetchQuotebyId, fetchTripbyId, fetchHotels, fetchdestHotelsbyQuoteid, fetchdestHotelsbyDest, fetchTours, fetchfarerule, fetchfarequote, fetchdestToursbyQuoteid, fetchdestToursbyDest, fetchDest, updatequoteData, fetchcurrency, fetchCurrencyData, fetchssr, updateCurrencyData, rzcpbooking, gmailSend, sendmailtoteam, fetchactiveFd, refreshTCToken, searchTCflight, fetchSuppliers, addQuery, gettouritinerary} from "../api/customerapi";
import { Dialog } from "@mui/material";
import axios from "axios"
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import {DateCalc2, airportlist, getairlinecode, airlinelist, getdaytext, childagearray, getSumByKey2, formatDate3, destAirport, identifydest, getmaillist, identifycolumn, identifycurr, identifycolumn2, fcheck, lcheck, destcode, getnationality, destAirport2, sortByKey, removeDuplicates2, groupBy, gettimediff, generateRandomAlphanumeric, addHoursToDate, samplelimitflight, samplelimit, identifycurrency} from "./date.js"
import DateCalc from "./date.js";
import { XMLParser } from "fast-xml-parser";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MyModal from "./modal.js"



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    sec1: {
      border:"2px solid black",
      backgroundColor: "#f0f0f0ff"
    },
     sec2: {
      border:"2px solid black",
      backgroundColor: "#fffcfcff"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField9: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(180),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField4: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      fontSize:14,
    },
    textField3: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      fontSize:20,
      fontStyle:"italic",
      fontFamily:"Helvetica",
      color: "red",
    },
    textField5: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      fontSize:20,
      fontStyle:"italic",
      fontFamily:"Helvetica",
      color: "yellow",
    },
    textField6: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    red: {
      color: "red",
      marginLeft: theme.spacing(3),
    },
    redlarge: {
      color: "red",
      marginLeft: theme.spacing(3),
      fontSize:28,
    },
    blue: {
      color: "blue",
      marginLeft: theme.spacing(3),
    },
    purple: {
      color: "purple",
      marginLeft: theme.spacing(3),
    },
    brown: {
      color: "brown",
      marginLeft: theme.spacing(3),
    },
    orange: {
      color: "orange",
      marginLeft: theme.spacing(3),
    },
    black: {
      color: "black",
      marginLeft: theme.spacing(3),
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        width: theme.spacing(220),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(20),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      button3: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(40),
        height: theme.spacing(3),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      row: {
        marginLeft: theme.spacing(1),
        marginTop: 0,
        
      },
      smallbutton: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(10),
        height: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      smallbutton3: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(25),
        height: theme.spacing(4),
      
      },
      input: {
        "&:invalid": {
          border: "red solid 2px"
        }
      },
      line: {
        
        width: "50%",
        
      },
  }));

  function Item(props)
  {
      return (
          <Paper>
              <div align="center">
              <br></br>
              <br></br>
              <img src={props.item.name} alt="Test" width="500" height="500"/>
              <p>{props.item.description}</p>
              </div>
              {/* <Button className="CheckButton">
                  Check it out!
              </Button> */}
          </Paper>
      )
  }

const Quotedataupdate = () => {
  const width = window.innerWidth - 100;
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const airlinelist2=airlinelist.sort()
    const classes = useStyles();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [Open4, setOpen4] = useState(false);
    const [Open14, setOpen14] = useState(false);
    const [Open3, setOpen3] = useState(false);
    const [Open5, setOpen5] = useState(false);
    const [Open6, setOpen6] = useState(false);
    const [Open7, setOpen7] = useState(false);
    const [Open8, setOpen8] = useState(false);
    const [Open9, setOpen9] = useState(false);
    const [Open10, setOpen10] = useState(false);
    const [Open11, setOpen11] = useState(false);
    const [Open12, setOpen12] = useState(false);
    const [Open15, setOpen15] = useState(false);
    const [fdtext, setfdtext] = useState(false);
    const [inbound, setinbound] = useState(false);
    const [inboundindex, setinboundindex] = useState(null);
    const [sendprofitchangemail, setsendprofitchangemail] = useState(false);
    const [itinerarytext, setitinerarytext] = useState(false);
    const [picsdata, setpicsdata] = useState(false);
    const [picsdata2, setpicsdata2] = useState(false);
    const [picsfilter, setpicsfilter] = useState([]);
    const [helptext, sethelptext] = useState([]);
    const [daydata, setdaydata]=useState([])
    const [visaData, setvisaData]=useState([])
    const [fsData, setfsData] = useState({});
    const [frData, setfrData] = useState(null);
    const [flightdetails, setflightdetails] = useState(null);
    const [flightdata, setflightdata]=useState([])
    const [hotellist, sethotellist]=useState([])
    const [cost, setcost]=useState([])
    const [hsData, sethsData]=useState({})
    const [hotelData, sethotelData] = useState([]);
    const [numberofrooms, setnumberofrooms]=useState(1)
    const [totalcost, settotalcost]=useState(0)
    const [quotevisaData, setquotevisaData]=useState([])
    const [partnerData, setpartnerData]=useState({query_notes:"", expected_price:0, partner_name:""})
    const [maxpass, setmaxpass]=useState([])
    const [totalflightcost, settotalflightcost]=useState(0)
    const [totalvisacost, settotalvisacost]=useState(0)
    const [totalvisasales, settotalvisasales]=useState(0)
    const [priceadd, setpriceadd]=useState(0)
    const [quoteData, setquoteData] =useState({
        favorite:false,
        website:false,
    })
    const [oldquoteData, setoldquoteData] =useState({
      favorite:false,
      website:false,
  })
    const [filterData, setfilterData] = useState({mealplan:""});
    const [responseData, setresponseData] = useState([{}]);
    const [responseData3, setresponseData3] = useState([{}]);
    const [currency, setcurrency]=useState({})
    const [fselection, setfselection]=useState(null)
    const [oldcurrency, setoldcurrency]=useState({})
    const [oldprice, setoldprice]=useState({})
    const [cities, setcities]=useState([])
    const [inventoryData, setinventoryData]=useState([])
    const [alllisttourData, setalllisttourData] =useState([{}])
    const [listtourData, setlisttourData] =useState([{}])
    const [listhotelData, setlisthotelData]=useState([{}])
    const [recohotellist, setrecohotellist] = useState([{}]);
    const [recohotellist2,setrecohotellist2] = useState([{
      category:"", hotellist:[]
    }]);
    const [info, setinfo] = useState("");
    const [info2, setinfo2] = useState("");
    const [info3, setinfo3] = useState("");
    const [status, setstatus] = useState("");
    const [identifier, setidentifier] = useState(false);
    const [allgood, setallgood] = useState(false);
    const [draweropen, setdraweropen] = useState(false);
    const [draweropen2, setdraweropen2] = useState(false);
    const [draweropen3, setdraweropen3] = useState(false);
    const [multidest, setmultidest] = useState(false);
    const [modalText, setmodalText] = useState("");
    const [ssrstatus, setssrstatus] = useState("Normal");
    const [tripData, settripData]=useState({})
    const [oldprofit, setoldprofit]=useState({})
    const [price, setprice]=useState({
        total:0,
        perperson:0,
        percwb:0,
        percnb:0,
        airfare:0,
        taxes:0,
        landprice:0,
        otheritems:0,
        tcs:0
    })
    const [costprice, setcostprice]=useState({
        total:0,
        profit:0,
        airfare:0,
        taxes:0,
        landprice:0,
        otheritems:0,
        profit_type:"Value"
    })
    const [searchResponse, setsearchResponse] = useState([]);
    const [searchResponse2, setsearchResponse2] = useState([]);
    const [filterData2, setfilterData2] = useState({});
    const [token, settoken] = useState("");
    const [control, setcontrol] = useState(false);
    const [ssrResponse, setssrResponse] = useState(false);
    const [sData, setsData] = useState(false);
    const [showModal, setshowModal] = useState(false);
    const [saveresults, setsaveresults] = useState("");
    const [resultpass, setresultpass] = useState([]);
    const [tcresultpass, settcresultpass] = useState([]);
    const [searchData, setsearchData]=useState({
      number_adults:2,
      number_child:0,
      number_infant:0,
      type:"Return",
      stops:"Any",
  })
  const [value, setValue] = useState(0);
  const [airportdata, setairportdata] = useState([]);
  const [couponData, setcouponData] = useState(0);
  const [childdata, setchilddata] = useState(0);
  const [confirmPromise, setConfirmPromise] = useState(null);
  const [finalcouponData, setfinalcouponData] = useState([]);
  const airportlist2=airportlist.sort((a, b) => (a.city > b.city) ? 1: -1);
  var fupsomeDate = new Date();
  //const { appData, loading } = useAppData();

  const closeModal=()=>setshowModal(false)

fupsomeDate.setDate(fupsomeDate.getDate());
const fupy = fupsomeDate.getFullYear();
const fupm =
  fupsomeDate.getMonth() + 1 < 10
    ? "0" + (fupsomeDate.getMonth() + 1)
    : fupsomeDate.getMonth() + 1;
const fupdt =
  fupsomeDate.getDate() < 10
    ? "0" + fupsomeDate.getDate()
    : fupsomeDate.getDate();
const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;

    const getQuote = async (id) => {
      try{
        const data = await fetchQuotebyId(id);
        console.log(data.data)
        getTrip(data.data.trip_id)
        setquoteData(data.data)
        setoldquoteData(data.data)
        setdaydata(data.data.day)
        
        if(flightdata.length==0){
            setflightdata(data.data.flight)
        }
        setoldprice(data.data.quote_price)
        setprice(data.data.quote_price)
        setcostprice(data.data.cost_price)      
        if(data.data.cost_price && data.data.quote_price && "landprice" in data.data.cost_price && "landprice" in data.data.quote_price){
          //console.log(data.data.quote_price.landprice, data.data.cost_price.landprice)
          var temp=(parseInt(data.data.quote_price.landprice)-parseInt(data.data.cost_price.landprice))/parseInt(data.data.cost_price.landprice)*100
          //console.log(temp)
          setoldprofit(temp)
        }
       if("costarr" in data.data){
        var cr=[]
        for(let i=0; i<data.data.costarr.length;i++){
          var temp={
            name:data.data.costarr[i].name,
            rate:data.data.costarr[i].rate,
            inventory:data.data.costarr[i].inventory,
            currency:data.data.costarr[i].currency,
            type:data.data.costarr[i].inv_type,
            room_type:"room_type" in data.data.costarr[i]?data.data.costarr[i].room_type:"",
          }
          cr.push(temp)
        }
        //sumcurrency2(cr, data.data.primary_destination)
        setcost(cr)
       }
       settotalcost(data.data.totalcost)
       settotalvisacost(data.data.totalvisacost)
       settotalflightcost(data.data.totalflightcost)
       settotalvisasales(data.data.totalvisasales)
       gethelptext(data.data.day)
      }catch(err){
        console.log(err)
      }
    }
    //console.log(alllisttourData)
    //console.log(quoteData)
    const getDest = async () => {
      try{
      //const data = await fetchDest();
      // const destdata=destinationlist.filter(dest=>dest.dest[0]==quoteData.primary_destination)
      // const infoarr=destdata[0].info.split("||")
      setinfo(destinationlist)
    }catch(err){
      console.log(err)
    }
    }

    const getFD=async(value)=>{
      const nd=value?value:quoteData.trip_start_date
      const fddata = await fetchactiveFd();
      console.log(fddata.data)
      const apt=destAirport2(quoteData.primary_destination)
      console.log(apt)
      var temp=[]
      if("lead_source_airport" in tripData && tripData.lead_source_airport !==""){
        temp=fddata.data.filter(f=>apt==f.destination_airport && f.source_airport==tripData.lead_source_airport)
      }else{
        temp=fddata.data.filter(f=>apt==f.destination_airport)
      }
      console.log(temp)
      if(temp.length>0){
      const oneplus=DateCalc2(nd, 1)
      const oneminus=DateCalc2(nd, -1)
      console.log(oneminus)
      for(let i=0;i<temp.length;i++){
      for(let j=0;j<temp[i].date_record.length;j++){
        if(new Date(temp[i].date_record[j].start_date).getTime()==new Date(nd).getTime() ||
        new Date(temp[i].date_record[j].start_date).getTime()==new Date(oneplus).getTime() ||
        new Date(temp[i].date_record[j].start_date).getTime()==new Date(oneminus).getTime()
      ){
        if(fdtext){
        setfdtext({
          text:fdtext.text+" || "+"FD available on " + temp[i].date_record[j].start_date.split("T").slice(0,1)+" from "+temp[i].source_airport+" of duration " + temp[i].duration+" at a price of " + temp[i].date_record[j].price+ " (including 20kg baggage per person)",
          onward:temp[i].onward_flight,
          return:"return_flight" in temp[i]?temp[i].return_flight:"",
        })
        }else{
          setfdtext({
            text:"FD available on " + temp[i].date_record[j].start_date.split("T").slice(0,1)+" from "+temp[i].source_airport+" of duration " + temp[i].duration+"N at a price of Rs." + temp[i].date_record[j].price+ " (including 20kg baggage per person)",
          onward:temp[i].onward_flight,
         return:"return_flight" in temp[i]?temp[i].return_flight:"",
          })
        }
        }
      }
    }
    }
  }

    const getTrip = async (id) => {
      try{
        const data = await fetchTripbyId(id);
        settripData(data.data)  
       
        if(data.data.secondary_destinations){
          setmultidest(true)
        }
        var someDate = data.data.trip_start_date
      ? new Date(data.data.trip_start_date).getTime()
      : 0;
    var mstoAdd = data.data.duration
      ? data.data.duration * 24 * 60 * 60 * 1000
      : 0;
    //console.log(someDate, mstoAdd);
    var returndate = new Date(someDate + mstoAdd).toISOString();

    setsearchData({
      number_adults: data.data.number_adults,
      number_child: data.data.number_child,
      number_infant:0,
      type: "Return",
      stops:"Any"
    })

    setairportdata([{ id: uuidv4(),  
      cabin_class:"Economy",
    departure_time:"All Day",
    arrival_time:"All Day",
    date:data.data.trip_start_date
    ? data.data.trip_start_date.slice(0, 10)
    : 0,
  source:destAirport2(data.data.lead_source_airport), dest:destAirport(data.data.primary_destination)}, 
    { id: uuidv4(),  cabin_class:"Economy",
    departure_time:"All Day",
    date:returndate.slice(0, 10),
    arrival_time:"All Day", source:destAirport(data.data.primary_destination), dest:destAirport2(data.data.lead_source_airport)}])
    getVisa(data.data.primary_destination, data.data.multi_destinations)
  }catch(err){
    console.log(err)
  }
    }

    const getVisa = async (dest, multi) => {
      //console.log(dest, multi)
      try{
      const data = await fetchVisaData();
      var finallist=[]
      if(multi=="Yes"){
        finallist=data.data
      }else{
        finallist=data.data.filter(item=> item.dest==dest || item.dest=="All")
      }
      //console.log(finallist)
      const temp=sortByKey(finallist, "id")
      //console.log(temp)
      setvisaData(temp)  
    }catch(err){
      console.log(err)
    }
  }

    const calccost=(str)=>{
      const temp=str.split("|")
      temp.map(s => s.trim());
      var numberArray = temp.map(Number)
      const sum = numberArray.reduce((partialSum, a) => partialSum + a, 0);
      return Math.round(sum*oldcurrency.usd_inr)
  
    }

    //console.log(fdtext)
    const handleClose4 = () => {
        setOpen4(false);
      };

      const handleClose14 = () => {
        setOpen14(false);
      };

      const handleClose3 = () => {
        setOpen3(false);
      };
    
      const handleClose5 = () => {
        setOpen5(false);
      };

      const handleClose8 = () => {
        setOpen8(false);
      };

      const handleClose6 = () => {
        setOpen6(false);
      };

      const handleClose7 = () => {
        setOpen7(false);
      };

      const handleClose9 = () => {
        setOpen9(false);
      };

      const handleClose10 = () => {
        setOpen10(false);
      };

      const handleClose11 = () => {
        setOpen11(false);
      };

      const handleClose15 = () => {
        setOpen15(false);
      };

      const dialogopen4 = async () => {
        setOpen4(true);
    
        //console.log(quotelist)
      };

      const handleClose12 = () => {
        setOpen12(false);
      };

      const dialogopen8 = async () => {
        setOpen8(true);
        let temp=tripData.number_adults+tripData.number_child
        if(temp<10){
          setmaxpass(childagearray(temp))
        }else{
          setmaxpass(childagearray(9))
        }
        
    
        //console.log(quotelist)
      };

      const dialogopen5 = async () => {
        setOpen7(true);
        let hotlist=[]
        console.log(daydata)
        for(let i=0; i<daydata.length; i++) {
          if(!hotlist.includes(daydata[i].hotel_name)){
            hotlist=[...hotlist,daydata[i].hotel_name]
          }else{
            // let ind=hotlist.indexOf(daydata[i].hotel_name)
            // console.log(ind)
            if(hotlist.length>0 && hotlist[hotlist.length-1]!==daydata[i].hotel_name){
              hotlist=[...hotlist,daydata[i].hotel_name]
            }
          }
          //console.log(hotlist)
          // if("hotel_name2" in daydata[i] && !hotlist.includes(daydata[i].hotel_name2)){
          //   hotlist=[...hotlist,daydata[i].hotel_name2]
          // }
          // if("hotel_name3" in daydata[i] && !hotlist.includes(daydata[i].hotel_name3)){
          //   hotlist=[...hotlist,daydata[i].hotel_name3]
          // }
        }
       sethotellist(hotlist) 
        //console.log(quotelist)
      };
     

      const dialogopen3 = async () => {
        setOpen3(true);
    
        //console.log(quotelist)
      };

    const getCities = async () => {
      try{
        const data = await fetchDest();
        //console.log(data.data);
        
        
        if(tripData.secondary_destinations){
            if(tripData.tertiary_destinations){
              const seccitylist= data.data.map(arr => arr.dest[0] == tripData.secondary_destinations ? [arr.cities] : [])
              const seccitylist2=seccitylist?.filter(arr => arr.length !==0 )
              const seccitylist3=seccitylist2[0]
              const citylist= data.data.map(arr => arr.dest[0] == quoteData.primary_destination ? [arr.cities] : [])
              const citylist2=citylist?.filter(arr => arr.length !==0 )
              const citylist3=citylist2[0]
              //console.log(seccitylist3)
              //console.log(citylist3)
              // if (seccitylist3.length > 0) {
              //     //cities.push(...seccitylist3[0])
              //     setcities([...seccitylist3[0], ...citylist3[0]])
              // }
              const tercitylist= data.data.map(arr => arr.dest[0] == tripData.tertiary_destinations ? [arr.cities] : [])
              const tercitylist2=tercitylist?.filter(arr => arr.length !==0 )
              const tercitylist3=tercitylist2[0]
              // const citylist4= data.data.map(arr => arr.dest[0] == quoteData.primary_destination ? [arr.cities] : [])
              // const citylist5=citylist4?.filter(arr => arr.length !==0 )
              // const citylist6=citylist5[0]
              console.log(tercitylist3)
              // console.log(citylist6)
              if (tercitylist3.length > 0) {
                  //cities.push(...seccitylist3[0])
                  setcities([...citylist3[0], ...tercitylist3[0], ...seccitylist3[0]])
              }
            }else{
            const seccitylist= data.data.map(arr => arr.dest[0] == tripData.secondary_destinations ? [arr.cities] : [])
            const seccitylist2=seccitylist?.filter(arr => arr.length !==0 )
            const seccitylist3=seccitylist2[0]
            const citylist= data.data.map(arr => arr.dest[0] == quoteData.primary_destination ? [arr.cities] : [])
            const citylist2=citylist?.filter(arr => arr.length !==0 )
            const citylist3=citylist2[0]
            //console.log(seccitylist3)
            if (seccitylist3.length > 0) {
                //cities.push(...seccitylist3[0])
                setcities([...seccitylist3[0], ...citylist3[0]])
            }
          }
        }else{
            const citylist= data.data.map(arr => arr.dest[0] == quoteData.primary_destination ? [arr.cities] : [])
            const citylist2=citylist?.filter(arr => arr.length !==0 )
            const citylist3=citylist2[0]
            setcities(citylist3 ? [...citylist3[0]] :[])
        }
      }catch(err){
        console.log(err)
      }
    }

    const getTours = async () => {
        const data = await fetchTours();
        const tourlist= data.data.filter(arr => arr.tour_destination == quoteData.primary_destination)
        setlisttourData(tourlist)
        if(tripData.secondary_destinations){
          if(tripData.tertiary_destinations){

          }else{
            const tourlist2= data.data.filter(arr => arr.tour_destination == tripData.secondary_destinations)
            setlisttourData([...tourlist,...tourlist2])
          }
        }
        //console.log(listtourData)
     
    }

    const getdestTours = async (quoteid) => {
      try{
                const data = await fetchdestToursbyQuoteid(quoteid);
        //const tourlist= data.data.filter(arr => arr.tour_destination == tripData.primary_destination)
        //console.log(data.data)
        let sortedTours = data.data.sort((a, b) => {
          if (a.tour_name < b.tour_name) {
              return -1;
          }
          if (a.tour_name > b.tour_name) {
              return 1;
          }
          return 0;
      });
      setalllisttourData(sortedTours)
      let sortedTours2=sortedTours.filter(tour=>!("tour_status" in tour) || !tour.tour_status)
        setlisttourData(sortedTours2)
        
        if(tripData.secondary_destinations){
          if(tripData.tertiary_destinations){
            const data2 = await fetchdestToursbyDest(tripData.secondary_destinations);
            const tourlist2= data2.data.filter(tour=>!("tour_status" in tour) || !tour.tour_status)
            //setlisttourData([...data.data,...tourlist2])
            const data2b = await fetchdestToursbyDest(tripData.tertiary_destinations);
            const tourlist2b= data2b.data.filter(tour=>!("tour_status" in tour) || !tour.tour_status)
            setlisttourData([...data.data,...tourlist2,...tourlist2b])
            setalllisttourData([...data.data,...data2.data, ...data2b.data])
          }
          else{
            const data2 = await fetchdestToursbyDest(tripData.secondary_destinations);
            const tourlist2= data2.data.filter(tour=>!("tour_status" in tour) || !tour.tour_status)
            setlisttourData([...data.data,...tourlist2])
            setalllisttourData([...data.data,...data2.data])
          }
        }
        //console.log(listtourData)
      }catch(err){
        console.log(err)
      }
    }

    const getHotels = async () => {
        const data = await fetchHotels();
        //console.log("123");
        const hotellist= data.data.filter(arr => arr.hotel_destination == quoteData.primary_destination)
        setlisthotelData(hotellist)
        if(tripData.secondary_destinations){
            const hotellist2= data.data.filter(arr => arr.hotel_destination == tripData.secondary_destinations)
            setlisthotelData([...hotellist,...hotellist2])
        }
        console.log(listhotelData)
        
      }

      const getdestHotels = async (quoteid) => {
        try{
        //console.log(tripid)
        const data = await fetchdestHotelsbyQuoteid(quoteid);
        let sortedHotels = data.data.sort((a, b) => {
          if (a.hotel_name < b.hotel_name) {
              return -1;
          }
          if (a.hotel_name > b.hotel_name) {
              return 1;
          }
          return 0;
      });;
        
      let recolist=data.data.filter(h=>h.hotel_reco_reason)
      let sortedHotels2 = recolist.sort((a, b) => {
        if (a.hotel_name < b.hotel_name) {
            return -1;
        }
        if (a.hotel_name > b.hotel_name) {
            return 1;
        }
        return 0;
    });;
      const result2=groupBy(recolist, v=>v.hotel_reco_reason.trim())
      let category=[]
      let hotelnames=[]
 
      //console.log(result2)
      
    for (let [key, value] of result2) {
      //console.log(key + " = " + value.length);
      const temp={
        category: key,
        hotellist: [...value],
      }
      hotelnames=[...hotelnames, temp]
      }
    
     //console.log(hotelnames)
      
     setrecohotellist2(hotelnames)
      
    setrecohotellist(sortedHotels2)
        //const hotellist= data.data.filter(arr => arr.hotel_destination == tripData.primary_destination)
        setlisthotelData(sortedHotels)
        if(tripData.secondary_destinations){
          if(tripData.tertiary_destinations){
            const data2 = await fetchdestHotelsbyDest(tripData.secondary_destinations);
            let sortedHotels2 = data2.data.sort((a, b) => {
              if (a.hotel_name < b.hotel_name) {
                  return -1;
              }
              if (a.hotel_name > b.hotel_name) {
                  return 1;
              }
              return 0;
          });;
          const data3 = await fetchdestHotelsbyDest(tripData.tertiary_destinations);
            let sortedHotels3 = data3.data.sort((a, b) => {
              if (a.hotel_name < b.hotel_name) {
                  return -1;
              }
              if (a.hotel_name > b.hotel_name) {
                  return 1;
              }
              return 0;
          });
            //const hotellist2= data2.data.filter(arr => arr.hotel_destination == tripData.secondary_destinations)
            setlisthotelData([...sortedHotels,...sortedHotels2,...sortedHotels3])
          }else{
            const data2 = await fetchdestHotelsbyDest(tripData.secondary_destinations);
            let sortedHotels2 = data2.data.sort((a, b) => {
              if (a.hotel_name < b.hotel_name) {
                  return -1;
              }
              if (a.hotel_name > b.hotel_name) {
                  return 1;
              }
              return 0;
          });;
            //const hotellist2= data2.data.filter(arr => arr.hotel_destination == tripData.secondary_destinations)
            setlisthotelData([...sortedHotels,...sortedHotels2])
        }
        }
        //console.log(listhotelData)
        
      }catch(err){
        console.log(err)
      }
      //setlisthotelData(sortedHotels)
      }

   const getCurrency=async()=>{
    try{
    const data= await fetchCurrencyData();
    //console.log(data.data)
    setoldcurrency(data.data[0])
    //console.log(data.data[0])
    if((new Date().getTime())-(new Date(data.data[0]?.date).getTime())>1000*60*60*24){
        console.log("Fetching data for cuurency")
        console.log((new Date().getTime())-(new Date(data.data[0]?.date).getTime()))
        const data2 = await fetchcurrency("USD");
        
        const data3 = await fetchcurrency("SGD");
       
        const data4 = await fetchcurrency("THB");
 
        const data5 = await fetchcurrency("AED");
        
        const data6 = await fetchcurrency("IDR");

        const data7 = await fetchcurrency("EUR");
        setoldcurrency({...oldcurrency, date:new Date(),usd_inr:data2.data.conversion_rates.INR, sgd_inr:data3.data.conversion_rates.INR, thb_inr:data4.data.conversion_rates.INR, aed_inr:data5.data.conversion_rates.INR, idr_inr:data6.data.conversion_rates.INR, eur_inr:data7.data.conversion_rates.INR})
        const tempcurrency={date:new Date(),usd_inr:data2.data.conversion_rates.INR, sgd_inr:data3.data.conversion_rates.INR, thb_inr:data4.data.conversion_rates.INR, aed_inr:data5.data.conversion_rates.INR, idr_inr:data6.data.conversion_rates.INR,  eur_inr:data7.data.conversion_rates.INR}
        // console.log(oldcurrency)
        //const tempcurrency={date:new Date(),usd_inr:data.data[0].usd_inr, sgd_inr:data.data[0].sgd_inr, thb_inr:data.data[0].thb_inr, aed_inr:data.data[0].aed_inr, idr_inr:data.data[0].idr_inr}
        const updatecurrenyResponse= await updateCurrencyData(data.data[0]._id, tempcurrency);
        
        if(updatecurrenyResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            
        }
        else{
            alert("Unable to refresh currency data");
            
        }
    }else{
        console.log("New data will be fetched after 24 hours")
    }
  }catch(err){
    console.log(err)
  }
   }

    useEffect(() => {
        getCurrency()
        getQuote(currentid)
        getTCToken()
        //getVisa()
        //getDest()
    }, [])

    useEffect(() => {
        
        getCities()
        getdestHotels(currentid)
        getdestTours(currentid)
        //getHotels()
        //getTours()
    }, [daydata])

    useEffect(() => {
        if (!loading) {
        getCities()
        getdestHotels(currentid)
        getdestTours(currentid)
        getFD()
        }
        
    }, [tripData])

   useEffect(() => {
      if (!loading) {
        // console.log("User:", cuser);
        // console.log("Role:", role);
        // console.log("Employees:", employeelist.length);
        // console.log("Destinations:", destinationlist.length);
        // console.log(destinationlist);
        getDest()
        getCities()
      }
    }, [loading, cuser, role, employeelist, destinationlist]);

  
    

    const addday =() =>{
        //console.log(cpdata)
        
        setdaydata(daydata.length==0? [{id:uuidv4()}]: [...daydata,{id:uuidv4(),date:defaultdate(daydata.length)}]) 
    }

    const removeday =() =>{
        //console.log(cpdata)
        setdaydata([...daydata].slice(0,daydata.length-1))
    }

    const addmid =(index) =>{

      var temp2=[...daydata]
      temp2.splice(index, 0, {id:uuidv4(), date:defaultdate(index)});
      for(let i=index+1; i<temp2.length; i++){
        temp2[i].date=defaultdate(i)
      }
      //console.log(temp2)
      setdaydata(temp2)
      //setdaydata(daydata.length==0? [{id:uuidv4()}]: [...daydata,{id:uuidv4()}]) 
  }

  const removemid =(index) =>{
    var temp2=[...daydata]
    temp2=temp2.filter(item=>item.id!==index.id)
    for(let i=index; i<temp2.length; i++){
      temp2[i].date=defaultdate(i)
    }
    //console.log(temp2)
    setdaydata(temp2)
      //setdaydata([...daydata].filter(item=>item.id!==index.id))
  }

    const addflight =() =>{
        //console.log(cpdata)
        
        setflightdata(flightdata.length==0? [{id:uuidv4()}]: [...flightdata,{id:uuidv4()}]) 
    }

    const removeflight =() =>{
        //console.log(cpdata)
        setflightdata([...flightdata].slice(0,flightdata.length-1))
    }

    const sourcedatechange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, source_date:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const destdatechange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, destination_date:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const sourcetimechange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, source_time:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const desttimechange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, destination_time:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const sourceaptchange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, source_airport:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const destaptchange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, destination_airport:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const airlinechange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, airline:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const stopchange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, stops:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const haltchange =(e,tid, id) =>{
  
        const newdata=flightdata[tid]
        //console.log(newdata)
        const newitem= {...newdata, halt:e.target.value}
        //console.log(newitem)
        flightdata[tid]=newitem
        setflightdata(flightdata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const daydatechange =(e,tid, id) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, date:e.target.value, hotel_benefit:getbenefit(daydata[tid].hotel_name, e.target.value)}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const daycitychange =(e,tid, id) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, city:e.target.value}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

    const dayhotelchange =(e,tid, id) =>{
      //console.log(e,tid, id)
        const newdata=daydata[tid]
        const category=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const hid=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const newitem= {...newdata, hotel_name:e.target.value, hotel_category: category[0].star_category, hotel_id:hid[0].hotel_id, booking_id:hid[0].booking_id, hotel_tripadvisor_link: hid[0].hotel_tripadvisor_link,
        city_center_area: hid[0].city_center_area, hotel_benefit:"",
        hotel_internal_notes:"hotel_internal_notes" in hid[0]?hid[0].hotel_internal_notes:"", hotel_reco: hid[0].hotel_reco
      }
        //console.log(newitem)
        daydata[tid]=newitem
        const temp=daydata.map(item => item.id == id ? newitem : item)
        gethelptext(temp)
        setdaydata(temp)
        //setdata([...data, data[tid]=newitem])
        //console.log(category)
    }

    const dayhotelchange2 =(e,tid, id) =>{
      //console.log(e,tid, id)
        const newdata=daydata[tid]
        const category=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const hid=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const newitem= {...newdata, hotel_name2:e.target.value, hotel_category2: category[0].star_category, hotel_id2:hid[0].hotel_id, hotel_reco: hid[0].hotel_reco}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(category)
    }
    const dayhotelchange3 =(e,tid, id) =>{
      //console.log(e,tid, id)
        const newdata=daydata[tid]
        const category=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const hid=listhotelData.filter(hotel => hotel.hotel_name == e.target.value)
        const newitem= {...newdata, hotel_name3:e.target.value, hotel_category3: category[0].star_category, hotel_id3:hid[0].hotel_id, hotel_reco: hid[0].hotel_reco}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(category)
    }

    const daytourchange =(e,tid, id) =>{
      console.log(e)
      //console.log(tid, id)
        const newdata=daydata[tid]
        const desc=alllisttourData.filter(tour => tour.tour_name == e.target.value ? tour.tour_description : "")
        const newitem= {...newdata, tour_name:e.target.value, 
          tour_description:desc[0] && "tour_description" in desc[0]?desc[0].tour_description:"", 
          tour_id:desc[0] && "tour_id" in desc[0]?desc[0].tour_id:"",  
          tour_description_transport:desc[0] && "tour_description_transport" in desc[0]?desc[0].tour_description_transport:null,
          tour_description_inclusions:desc[0] && "tour_description_inclusions" in desc[0]?desc[0].tour_description_inclusions:null,
          tour_description_additional:desc[0] && "tour_description_additional" in desc[0]?desc[0].tour_description_additional:null,
          tour_description_info:desc[0] && "tour_description_info" in desc[0]?desc[0].tour_description_info:null,
          file:desc[0] && "file" in desc[0]?desc[0].file:null,
          tour_internal_notes:desc[0] && "tour_internal_notes" in desc[0]?desc[0].tour_internal_notes:"",
          tour_advance_booking:desc[0] && "advance_booking" in desc[0]?desc[0].advance_booking:null,
        }
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //getdescvalue(tid)
        //setdata([...data, data[tid]=newitem])
        //console.log(daydata)
    }

    const daymealchange =(e,tid, id) =>{
  
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, meal_plan:e.target.value}
        //console.log(newitem)
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const daymealchange2 =(e,tid, id) =>{
  
      const newdata=daydata[tid]
      //console.log(newdata)
      const newitem= {...newdata, meal_plan2:e.target.value}
      //console.log(newitem)
      daydata[tid]=newitem
      setdaydata(daydata.map(item => item.id == id ? newitem : item))
      //setdata([...data, data[tid]=newitem])
      //console.log(cpdata)
  }
  const daymealchange3 =(e,tid, id) =>{
  
    const newdata=daydata[tid]
    //console.log(newdata)
    const newitem= {...newdata, meal_plan3:e.target.value}
    //console.log(newitem)
    daydata[tid]=newitem
    setdaydata(daydata.map(item => item.id == id ? newitem : item))
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
}

    const dayroomchange =(e,tid, id) =>{
        console.log(e, tid, id)
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, room_type:e.target.value}
        
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }
    const dayroomchange2 =(e,tid, id) =>{
  
      const newdata=daydata[tid]
      //console.log(newdata)
      const newitem= {...newdata, room_type2:e.target.value}
      
      daydata[tid]=newitem
      setdaydata(daydata.map(item => item.id == id ? newitem : item))
      //setdata([...data, data[tid]=newitem])
      //console.log(cpdata)
  }
  const dayroomchange3 =(e,tid, id) =>{
  
    const newdata=daydata[tid]
    //console.log(newdata)
    const newitem= {...newdata, room_type3:e.target.value}
    
    daydata[tid]=newitem
    setdaydata(daydata.map(item => item.id == id ? newitem : item))
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
}

const daynumberroomchange =(e,tid, id) =>{
       // console.log(e, tid, id)
        const newdata=daydata[tid]
        //console.log(newdata)
        const newitem= {...newdata, number_rooms:e.target.value}
        
        daydata[tid]=newitem
        setdaydata(daydata.map(item => item.id == id ? newitem : item))
        //setdata([...data, data[tid]=newitem])
        //console.log(cpdata)
    }

const askConfirmation = (text) => {
  if(text.includes("Significant")){
    console.log("Here")
    setsendprofitchangemail(true)
  }
  setshowModal(true);
  setmodalText(text)
  return new Promise((resolve) => {
    setConfirmPromise(() => resolve);
  });
};

const handleConfirm = () => {
  setshowModal(false);
  if (confirmPromise) {
    confirmPromise(true);
    setConfirmPromise(null);
  }
};

const handleCancel = () => {
  setshowModal(false);
  if (confirmPromise) {
    confirmPromise(false);
    setConfirmPromise(null);
  }
};

    const viewquote=async() =>{
        let flightcheck=fcheck(quoteData.primary_destination,quoteData.number_adults,quoteData.number_child, price)
        var flag=0
        //console.log(flightcheck)
        if(flightcheck){
          var text="Flight prices seem unreasonable. Kindly consult your TL"
          const result = await askConfirmation(text)
          if(result){
            flag=1
          }
        //  await promisedSetState({ modalText: "Flight prices seem unreasonable. Kindly consult your TL"});
        // await promisedSetState({ showModal: true });
          //setshowModal(flightcheck)
            //alert("Flight prices seem unreasonable. Kindly consult your TL")
            //setmodalText("Flight prices seem unreasonable. Kindly consult your TL")
            // 
        }
        let landcheck=lcheck(quoteData.primary_destination,quoteData.number_adults,quoteData.number_child, price)
        if(landcheck){
          var text2="Land prices seem unreasonable. Kindly consult your TL"
          const result = await askConfirmation(text2)
          if(result){
            flag=1
          }
          // setshowModal(true)
          // //alert("Land prices seem unreasonable. Kindly consult your TL")
          // setmodalText("Land prices seem unreasonable. Kindly consult your TL")
          // 
      }
      
       
        if(!flag){
        let result= window.confirm("Please check if tours are operating on the days you have alloted them. Check Info tab for more such details.\n\nDid you check all data (price, inclusions, cancellation data, travel date, favorite flag etc.) correctly?")
        if(result){
        window.location=("/viewquote/"+quoteData.quote_id)
        }
      }
    }

    const getER=async(e)=>{
        if(currency.currency_name=="USD"){
    
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.usd_inr+1)).toFixed(2)})
      }else if(currency.currency_name=="SGD"){
        
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.sgd_inr+1)).toFixed(2)})
      }else if(currency.currency_name=="AED"){
    
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.aed_inr+0.4)).toFixed(2)})
      }else if(currency.currency_name=="THB"){
    
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.thb_inr+0.1)).toFixed(2)})
      }else if(currency.currency_name=="IDR"){
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.idr_inr).toFixed(2))})
      }else if(currency.currency_name=="EUR"){
        setcurrency({...currency, newvalue:(currency.currency_value*(oldcurrency.eur_inr+1.5).toFixed(2))})
      }
      
    }

    function getInventoriesWithMixedCurrencies(cost) {
  const inventoryCurrencies = {};

  for (const item of cost) {
      if (item.inventory == null) continue;
      if (item.currency == null) continue;

    if (!inventoryCurrencies[item.inventory]) {
      inventoryCurrencies[item.inventory] = new Set();
    }

    inventoryCurrencies[item.inventory].add(item.currency);
  }

  return Object.keys(inventoryCurrencies).filter(
    inventory => inventoryCurrencies[inventory].size > 1
  );
}

    const checkfeasible=async()=>{
      let flag=0
      for(let i=0;i<daydata.length;i++){
        let tour=alllisttourData.filter(tour=>tour.tour_name==daydata[i].tour_name)
        console.log(tour)
        if(tour[0]){
        if("operating_days" in tour[0]){
          const day=new Date(daydata[i].date).getDay()
          const daytext=getdaytext(day).toLowerCase()
          //console.log(tour[0].operating_days[daytext])
          if(!tour[0].operating_days[daytext]){
            flag=1
            alert(daydata[i].tour_name+" not allowed on "+daytext)
          }
        }
        }else{
          alert("Tour name missing on day: "+(i+1))
          flag=1
        }
        const hotel=listhotelData.filter(hotel=>hotel.hotel_name==daydata[i].hotel_name)
        if(role!=="Admin" && hotel.length==0){
          alert("Hotel Name missing on certain days")
          flag=1
        }
        if(hotel.length>0){
        if("hotel_reco" in hotel[0]){
        if(hotel[0].hotel_reco=="Not Allowed"){
          flag =1
          alert("This hotel is not allowed to be quoted -"+daydata[i].hotel_name)
        }else if(hotel[0].hotel_reco=="Not Recommended"){
          var text="This is not a recommended hotel. Kindly consider changing the hotel: "+daydata[i].hotel_name
          const result = await askConfirmation(text)
          console.log(result)
          if(result){
            flag=1
          }else{
            
          }
          //alert("This is not a recommended hotel. Kindly consider changing the hotel: "+daydata[i].hotel_name)
          // setshowModal(true)
          // setmodalText("This is not a recommended hotel. Kindly consider changing the hotel: "+daydata[i].hotel_name)
        }
        }
        }
        //console.log(tour[0])
        if(tour[0]){
        if("availability" in tour[0]){
          //console.log(tour[0].tour_id)
         
          for(let j=0;j<tour[0].availability.length;j++){
            //console.log(new Date(tour[0].availability[j].start_date))
            //console.log(new Date(daydata[i].date))
            //console.log(new Date(tour[0].availability[j].end_date))
            if(new Date(daydata[i].date).getTime()>=new Date(tour[0].availability[j].start_date).getTime() && new Date(daydata[i].date).getTime()<new Date(tour[0].availability[j].end_date).getTime()){
              //console.log(tour[0].availability[j])
              if(tour[0].availability[j].status=="No"){
                //console.log(tour[0].availability[j].status)
                flag=1
                alert("Sightseeing not allowed on "+daydata[i].date)
              }
            }
          }
        }
      }
      }
      if(!(role =="Admin" || role =="Product" || role=="Operations" || role=="Operations-TL"  || role=="Support")){
        if(cost.length==0){
          alert("Get Cost not used. Please use get cost first")
          flag=1
        }
        if(!priceadd){
          alert("Get Cost not used properly. Use get cost properly first")
          flag=1
        }
      }
      //console.log(daydata.length, quoteData.duration)
      if(daydata.length-1 !==parseInt(quoteData.duration)){
        alert("Duration mismatch")
        flag=1
      }
      
      //console.log(flag)
      return flag
    }

    const pricecheck=async()=>{
      var flag=0
      var flag2=0
      if(quoteData.trip_start_date !==tripData.trip_start_date){
        alert("Trip start date does not match. Please change trip start date at trip level")
      }
      if(role=="Sales" || role=="TL"){
      if(costprice && price && "airfare" in costprice && "airfare" in price){
        if((price.airfare-costprice.airfare<0) || ((price.airfare-costprice.airfare)!==0 && ((price.airfare-costprice.airfare)/costprice.airfare)>0.05)){
          var text="Flight sales profit seems too high or too low. Kindly recheck"
          const result = await askConfirmation(text)
          //console.log(result)
          if(result){
            flag=1
          }
          //alert("Flight sales profit seems too high or too low. Kindly recheck")
        }
      }
      if(costprice && price && "otheritems" in costprice && "otheritems" in price){
        if((price.otheritems-costprice.otheritems<0) || ((price.otheritems-costprice.otheritems)!==0 && ((price.otheritems-costprice.otheritems)/costprice.otheritems)>0.20)){
          var text2="Other items sales profit seems too high or too low. Kindly recheck"
          const result = await askConfirmation(text2)
          //console.log(result)
          if(result){
            flag=1
          } 
          //alert("Other items sales profit seems too high or too low. Kindly recheck")
        }
      }
      if(costprice && price && "landprice" in costprice && "landprice" in price && allgood){
        if((price.landprice-costprice.landprice<0) || ((price.landprice-costprice.landprice)!==0 && ((price.landprice-costprice.landprice)/costprice.landprice)>0.5) || ((price.landprice-costprice.landprice)!==0 && ((price.landprice-costprice.landprice)/costprice.landprice)<0.08)){
          var text3="Land sales profit seems too high or too low. Kindly recheck"
          const result = await askConfirmation(text3)
          console.log(result)
          if(result){
            flag=1
          }
          //alert("Land sales profit seems too high or too low. Kindly recheck")
        }
        var newlandprofit=(price.landprice-costprice.landprice)/costprice.landprice*100
        if(newlandprofit-oldprofit>20 || oldprofit-newlandprofit>20){
          setsendprofitchangemail(true)
          flag2=1
          var text4="Significant difference in profit between old and new quote. Please check - Previous Profit: "+Math.round(oldprofit)+"%, Current profit: "+Math.round(newlandprofit)+"%"
          const result = await askConfirmation(text4)
          console.log(result)
          if(result){
            flag=1
          }
          //console.log(sendprofitchangemail)
          //alert("Significant difference in profit between old and new quote. Please check - Previous Profit: "+Math.round(oldprofit)+"%, Current profit: "+Math.round(newlandprofit)+"%")
          const finalarray={
            to:["abhishek.sharma@jetovacations.com", "amit.singh@jetovacations.com"],
            sub:"Signidicant profit change - "+quoteData.quote_id,
            body:"Please check the profit calcualtion of quote id "+quoteData.quote_id
          }
          const data=sendmailtoteam(finalarray)
          console.log(data)
         
        }
      }
      if(price && oldprice && price.total-oldprice.total>1.2*oldprice.total){
        if("airfare" in oldprice && "airfare" in price && price.airfare-oldprice.airfare==price.airfare){

        }else{
          alert("Significant increase in price. Please recheck")
        }
       
      }
      
      var currencycheck=getInventoriesWithMixedCurrencies(cost)
      if(currencycheck.length>0){
        console.log(currencycheck)
        alert("All rates of similar inventory should be of same currency. Currency mismatch. Cannot proceed")
        flag=1
      }
      var ql=true
      // if(tripData.quote.length>1){
      //   ql=false
      // }
      if(ql && (new Date().getTime()-new Date(quoteData.createdAt).getTime())/(1000*60*30)<1){
        const temp=total(price)
        console.log(Math.round((temp.total/(tripData.number_adults+tripData.number_child))/quoteData.duration))
              const checkvalue=Math.round((temp.total/(tripData.number_adults+tripData.number_child))/quoteData.duration)
              const limitwithflight=samplelimitflight(quoteData.primary_destination)
              const limitwithoutflight=samplelimit(quoteData.primary_destination)
            if((quoteData.sample_package=="Yes" && temp.airfare && Math.round((temp.total/(tripData.number_adults+tripData.number_child))/quoteData.duration)>limitwithflight) || 
            (quoteData.sample_package=="Yes" && !temp.airfare && Math.round((temp.total/(tripData.number_adults+tripData.number_child))/quoteData.duration)>limitwithoutflight)){
              
              alert("Sample quote is too costly. Cannot proceed "+checkvalue)
            flag=1
            }
         if(((price.landprice-costprice.landprice)/price.landprice)>0.20){
      alert("First Quote cannot have such a high margin. Correct and try again")
      flag=1
    }
      }
      // if(quoteData.primary_destination=="Indonesia" && "airfare" in price && (price.airfare/(quoteData.number_adults+quoteData.number_child))>35000){
       
      }
      console.log(flag, flag2)  
      return {main:flag, side:flag2}
    }
    //console.log(cost)
    const classifyedit=()=>{
      console.log(daydata)
      console.log(oldquoteData.day)
      var arr="edit_category" in quoteData && quoteData.edit_category.length>0?[...quoteData.edit_category]:[]
      var temp=[]

      if(oldquoteData.day[0].date !== daydata[0].date){
        console.log("1")
        temp=[...temp, "Date change"]
      }

      if(oldquoteData.day.length !== daydata.length){
        console.log("2")
        temp=[...temp, "Duration change"]
      }else{
        console.log("Here")
        for(let i=0; i<oldquoteData.day.length; i++){
          console.log(daydata[i].tour_id, oldquoteData.day[i].tour_id)
          console.log(daydata[i].hotel_id, oldquoteData.day[i].hotel_id)
          if(oldquoteData.day[i].hotel_name !== daydata[i].hotel_name){
            console.log("3")
            temp=[...temp, "Hotel change"]
          }
          if(oldquoteData.day[i].tour_name !== daydata[i].tour_name){
            console.log("4")
            temp=[...temp, "Tour change"]
          }
        }
      }

      temp=removeDuplicates2(temp)

      if(!(temp.includes("Hotel change") || temp.includes("Tour change"))){
        if(oldquoteData.quote_price.airfare !== price.airfare){
          console.log("5")
          temp=[...temp, "Flightprice change"]
        }
  
        if(oldquoteData.quote_price.landprice !== price.landprice){
          console.log("6")
          temp=[...temp, "Landprice change"]
        }
      }

      

      

      arr=[...arr, temp]
      console.log(arr)
      return arr
    }


    const handleSubmit =async (e) => {
      try{
        e.preventDefault();
        var l=0
        var x=await checkfeasible()
        console.log(x)
        var y=await pricecheck()
        console.log(y)
        if(!x && !y.main){
          const classification=classifyedit()
          if(tripData.trip_channel=="TripCrafters"){
            alert("Please keep low profits. Competition expected")
          }

          if(quoteData.trip_status=="Converted"){
            const ml=getmaillist(tripData, employeelist, 2)
            var input=window.prompt("Write below what you changed for easy reference? Hotel, itinerary, customer notes etc.")
            let from="care@jetovacations.com"
            let to=["operations@jetovacations.com", ...ml]
            let subject="Converted quote edited "+quoteData.trip_id
            let body="Quote id "+quoteData.quote_id+" edited by "+cuser+" || "+input
            console.log(body)
            
            gmailSend(from, to, subject, body)
          }
          for(let i=0;i<daydata.length; i++){
            if(getbenefit(daydata[i].hotel_name, daydata[i].date)){
              daydata[i].hotel_benefit=getbenefit(daydata[i].hotel_name, daydata[i].date)
              if(daydata[i].hotel_category==5){
                l=1
              }
            }
          }
        var finalprice={}
        if(quoteData.quote_discount && quoteData.quote_discount_type){
          finalprice={...price, taxes:Math.round((parseInt(price.landprice)-quoteData.quote_discount)*0.05), 
            tcs: gettcs(),
            tcs2: gettcs2(),
            tcs3: gettcs3(),
            taxes2:parseInt(price?.landprice2?(price.landprice2-quoteData.quote_discount)*0.05:0),
            taxes3:parseInt(price?.landprice3?(price.landprice3-quoteData.quote_discount)*0.05:0),
            total:parseInt(price.airfare)+parseInt(price.landprice)+parseInt(price.otheritems)+(parseInt(price.landprice)-quoteData.quote_discount)*0.05,
            total2:parseInt(price.airfare)+(price?.landprice2?(parseInt(price.landprice2)-quoteData.quote_discount):0)+parseInt(price.otheritems)+(price?.landprice2?(parseInt(price.landprice2)-quoteData.quote_discount)*0.05:0),
            total3:parseInt(price.airfare)+(price?.landprice3?(parseInt(price.landprice3)-quoteData.quote_discount):0)+parseInt(price.otheritems)+(price?.landprice3?(parseInt(price.landprice3)-quoteData.quote_discount)*0.05:0),
          }
        }else{
          finalprice={...price, taxes:Math.round(parseInt(price.landprice)*0.05), 
            tcs: gettcs(),
            tcs2: gettcs2(),
            tcs3: gettcs3(),
            taxes2:parseInt(price?.landprice2?price.landprice2*0.05:0),
            taxes3:parseInt(price?.landprice3?price.landprice3*0.05:0),
            total:parseInt(price.airfare)+parseInt(price.landprice)+parseInt(price.otheritems)+parseInt(price.landprice)*0.05,
            total2:parseInt(price.airfare)+parseInt(price?.landprice2?price.landprice2:0)+parseInt(price.otheritems)+parseInt(price?.landprice2?price.landprice2*0.05:0),
            total3:parseInt(price.airfare)+parseInt(price?.landprice3?price.landprice3:0)+parseInt(price.otheritems)+parseInt(price?.landprice3?price.landprice3*0.05:0),
          }
        }
          
        const finalcostprice={...costprice, 
          taxes:parseInt(price.landprice)*0.05,
          taxes2:parseInt(price?.landprice2?price.landprice2*0.05:0),
          taxes3:parseInt(price?.landprice3?price.landprice3*0.05:0),
          total:(costprice?.profit_type=="Value"?(parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes)+parseInt(costprice?.profit)):
          (((parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes))*(1+(costprice?.profit)/100)))
          ),
          total2:(costprice?.profit_type=="Value"?(parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes2)+parseInt(costprice?.profit)):
          (((parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes2))*(1+(costprice?.profit)/100)))
          )-parseInt(costprice?.landprice)+parseInt(costprice?.landprice2),
          total3:(costprice?.profit_type=="Value"?(parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes3)+parseInt(costprice?.profit)):
          (((parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes3))*(1+(costprice?.profit)/100)))
          )-parseInt(costprice?.landprice)+parseInt(costprice?.landprice3),
          
        }
        var x=("edit_count" in quoteData)?quoteData.edit_count:1;
        if(("edit_count" in quoteData)){
          if(((new Date().getTime()-new Date(quoteData.updatedAt).getTime())/(1000*60*5))>1){
            //console.log(((new Date().getTime()-new Date(quoteData.updatedAt).getTime())/(1000*60*5)))
            x++
            //setquoteData({...quoteData,edit_count:x})
          }
        }
        var costarr=[]
        for(let i=0;i<cost.length;i++){
          var temp={
            name:cost[i].name,
            rate:cost[i].rate,
            inv_type:cost[i].type,
            currency:cost[i].currency,
            inventory:cost[i].inventory,
            room_type:cost[i].room_type,
          }
          costarr.push(temp)
        }

        const finalquoteData= {...quoteData, flight: flightdata, day:daydata,  quote_price:finalprice,trip_status:tripData.trip_status, costarr:costarr,
          totalcost:totalcost,
          totalflightcost:totalflightcost,
          totalvisacost:totalvisacost,
          totalvisasales:totalvisasales,
            inclusions_arr:quoteData.inclusions ? quoteData.inclusions.split("||") :[], 
            exclusions_arr:quoteData.exclusions ? quoteData.exclusions.split("||"): [],
            updatedAt:new Date(), 
            tnc_arr:quoteData.tnc ? quoteData.tnc.split("||"): [], 
            cust_notes_arr:quoteData.cust_notes ? quoteData.cust_notes.split("||"): [],
            cost_price:finalcostprice,
            edit_count:x,
            trip_details:tripData._id,
            edit_category:classification,
            luxury:l,
            cancellation_policy_arr:quoteData.cancellation_policy ? quoteData.cancellation_policy.split("||") : []};
           
        // const addhotelResponse= await addHotel(finalhotelData);
        //console.log(sData);
        console.log(finalquoteData);
        // console.log(sendprofitchangemail)
        // if(y.side || sendprofitchangemail){
        //   const finalarray={
        //       to:["debayan.ghosh@jetovacations.com", "abhishek.sharma@jetovacations.com", "amit.singh@jetovacations.com"],
        //       sub:"Signidicant profit change - "+quoteData.quote_id,
        //       body:"Please check the profit calcualtion of quote id "+quoteData.quote_id
        //     }
        //     const data=await sendmailtoteam(finalarray)
        //     console.log("Done")
        // }

        const updateQuoteResponse= await updatequoteData(quoteData._id,finalquoteData);
        
        if(updateQuoteResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Quote updated for trip with trip id "+updateQuoteResponse.data.trip_id+" with quote id: "+updateQuoteResponse.data.quote_id);
            window.location = ("/quotedataentry/"+updateQuoteResponse.data.quote_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      } 
      
    }catch(err){
      console.log(err)
    }
    }
    
      
    const flightsearchapi = async (fsData) => {
        setOpen4(false);
        setOpen5(true);
        setfrData(null)
        if(fsData.type=="One-way"){
          if(fsData.source && fsData.dest && fsData.dot && fsData.number_adults) {
            const options = {
              method: "GET",
              url: "https://skyscanner44.p.rapidapi.com/search",
              params: {
                //adults: String(fsData.number_adults),
                adults:'1',
                origin: fsData.source,
                destination: fsData.dest,
                departureDate: fsData.dot,
                currency: "INR",
              },
              headers: {
                "X-RapidAPI-Key": "cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1",
                "X-RapidAPI-Host": "skyscanner44.p.rapidapi.com",
              },
            };
        
            console.log(options)
             await axios.request(options).then(function (response) {
                //const responseData = response.data
                setfrData(response.data)
              console.log(response.data);
              }).catch(function (error) {
              console.error(error);
              });
          }else{
            alert("Please enter all data-source, dest, pax, date of travel correctly")
          }
        }else if(fsData.type=="Return"){
          if(fsData.source && fsData.dest && fsData.dot && fsData.dor && fsData.number_adults) {
            const options = {
              method: "GET",
              url: "https://skyscanner44.p.rapidapi.com/search",
              params: {
                //adults: String(fsData.number_adults),
                adults:'1',
                origin: fsData.source,
                destination: fsData.dest,
                departureDate: fsData.dot,
                returnDate: fsData.dor,
                currency: "INR",
              },
              headers: {
                "X-RapidAPI-Key": "cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1",
                "X-RapidAPI-Host": "skyscanner44.p.rapidapi.com",
              },
            };
        
            //console.log(options)
              axios.request(options).then(function (response) {
                //const responseData = response.data
                
              //time diff calculation
                if(response.data && response.data.itineraries && response.data.itineraries.buckets){
                    for(let i=0;i<response.data.itineraries.buckets.length;i++){
                        if(response.data.itineraries.buckets[i].items){
                            for(let j=0;j<response.data.itineraries.buckets[i].items.length;j++){
                                if(response.data.itineraries.buckets[i].items[j].legs){
                                    for(let m=0;m<response.data.itineraries.buckets[i].items[j].legs.length;m++){
                                        if(response.data.itineraries.buckets[i].items[j].legs[m].segments && response.data.itineraries.buckets[i].items[j].legs[m].segments.length>1){
                                            for(let k=1;k<response.data.itineraries.buckets[i].items[j].legs[m].segments.length;k++){
                                                const timediff=(new Date(response.data.itineraries.buckets[i].items[j].legs[m].segments[k].departure).getTime()-new Date(response.data.itineraries.buckets[i].items[j].legs[m].segments[k-1].arrival).getTime())/(1000* 60)
                                                console.log(timediff)
                                                const timediffhr=Math.floor(timediff/60)
                                                const timediffmin=Math.floor(timediff%60)
                                                const finaltimediff=timediffhr+" hrs " + timediffmin+" mins"
                                                response.data.itineraries.buckets[i].items[j].legs[m].segments[k].timediff=finaltimediff
                                            }
                                    }
                                }
                                }
                            }
                        }
                    }
                }
              setfrData(response.data)
              console.log(response.data);

              }).catch(function (error) {
              console.error(error);
              });
          }else{
            alert("Please enter all data-source, dest, pax, date of travel correctly")
          }
        }
        
      
    
      };

      const flightsearchapi2= async (fsData) => {
        setOpen4(false);
        setOpen6(true);
        setfrData(null)
        if(fsData.type=="One-way"){
          if(fsData.source && fsData.dest && fsData.dot && fsData.number_adults) {
            const options = {
              method: 'GET',
              url: 'https://skyscanner50.p.rapidapi.com/api/v1/searchFlights',
              params: {
                origin: fsData.source,
                destination: fsData.dest,
                date: fsData.dot,
                
                adults: '1',
                currency: 'INR',
               
              },
              headers: {
                'X-RapidAPI-Key': 'cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1',
                'X-RapidAPI-Host': 'skyscanner50.p.rapidapi.com'
              }
            };
           
        
            //console.log(options)
             await axios.request(options).then(function (response) {
                //const responseData = response.data
                setfrData(response.data)
              //console.log(response.data);
              }).catch(function (error) {
              console.error(error);
              });
          }else{
            alert("Please enter all data-source, dest, pax, date of travel correctly")
          }
        }else if(fsData.type=="Return"){
          if(fsData.source && fsData.dest && fsData.dot && fsData.dor && fsData.number_adults) {
            const options = {
              method: 'GET',
              url: 'https://skyscanner50.p.rapidapi.com/api/v1/searchFlights',
              params: {
                origin: fsData.source,
                destination: fsData.dest,
                date: fsData.dot,
                returnDate: fsData.dor,
                adults: '1',
                currency: 'INR',
               
              },
              headers: {
                'X-RapidAPI-Key': 'cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1',
                'X-RapidAPI-Host': 'skyscanner50.p.rapidapi.com'
              }
            };
        
            //console.log(options)
              axios.request(options).then(function (response) {
              
              setfrData(response.data)
              //console.log(response.data);

              }).catch(function (error) {
              console.error(error);
              });
          }else{
            alert("Please enter all data-source, dest, pax, date of travel correctly")
          }
        }
        
      
    
      };

      const getdetails=async()=>{
  if(fsData.type=="One-way"){
    if(fsData.source && fsData.dest && fsData.dot && fsData.number_adults) {
      const str='[{"origin":"'+fsData.source+'","destination":"'+fsData.dest+'","date":"'+fsData.dot+'"}]'
      const options = {
        method: 'GET',
        url: 'https://skyscanner50.p.rapidapi.com/api/v1/getFlightDetails',
        params: {
          itineraryId: fselection.id,
          legs: str,
          adults: '1',
          currency: 'INR',
          countryCode: 'IN',
          market: 'en-GB'
        },
        headers: {
          'X-RapidAPI-Key': 'cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1',
          'X-RapidAPI-Host': 'skyscanner50.p.rapidapi.com'
        }
      };
     
  
      //console.log(options)
       await axios.request(options).then(function (response) {
          //const responseData = response.data
          setflightdetails(response.data.data)
        console.log(response.data);
        }).catch(function (error) {
        console.error(error);
        });
    }else{
      alert("Please enter all data-source, dest, pax, date of travel correctly")
    }
  }else if(fsData.type=="Return"){
    if(fsData.source && fsData.dest && fsData.dot && fsData.dor && fsData.number_adults) {
      //console.log(fsData)
      const str='[{"origin":"'+fsData.source+'","destination":"'+fsData.dest+'","date":"'+fsData.dot+'"},{"date":"'+fsData.dor+'","destination":"'+fsData.source+'","origin":"'+fsData.dest+'"}]'
      const options = {
        method: 'GET',
        url: 'https://skyscanner50.p.rapidapi.com/api/v1/getFlightDetails',
        params: {
          itineraryId: fselection.id,
          //legs: `[{"origin":"DEL","destination":"DPS","date":"2023-01-15"},{"date":"2023-01-21","destination":"DEL","origin":"DPS"}]`,
          //legs: `[{"origin":${fsData.source},"destination":${fsData.dest},"date":${fsData.dot}}, {"date":${fsData.dor},"destination":${fsData.source},"origin":${fsData.dest}}]`,
          legs:str,
          adults: '1',
          currency: 'INR',
          countryCode: 'IN',
          market: 'en-GB'
        },
        headers: {
          'X-RapidAPI-Key': 'cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1',
          'X-RapidAPI-Host': 'skyscanner50.p.rapidapi.com'
        }
      };
  
      //console.log(options)
        axios.request(options).then(function (response) {
       
        setflightdetails(response.data.data)
        //console.log(response.data);

        }).catch(function (error) {
        console.error(error);
        });
    }else{
      alert("Please enter all data-source, dest, pax, date of travel correctly")
    }
  }
  
  
  
      }

      const handlechange = (e) => {
        //console.log(e.target.value)
        for(let i=0;i<frData.itineraries.buckets.length;i++){
            for(let j=0;j<frData.itineraries.buckets[i].items.length;j++){
                if(frData.itineraries.buckets[i].items[j].id==e.target.value){
                    //console.log(frData.itineraries.buckets[i].items[j])
                    setfselection({item:frData.itineraries.buckets[i].items[j]});
                    break;
                }
            }
        }
        //setfselection(e.target.value);
        //console.log(fselection)
        
      };

      const handlechange2 = (e) => {
        setflightdetails(null)
        for(let i=0;i<frData.data.length;i++){
           
                if(frData.data[i].id==e.target.value){
                    //console.log(frData.itineraries.buckets[i].items[j])
                    setfselection(frData.data[i]);
                    break;
                }
            
        }
        //setfselection(e.target.value);
        //console.log(fselection)
        
      };

      const addflighttoquote=()=>{
        setflightdata([])
      }

      const addflighttoquote2=()=>{
        // const empty=[]
        // setflightdata(empty)
        if(fselection){
        for(let i=0; i<fselection.item.legs.length;i++){
            for(let j=0; j<fselection.item.legs[i].segments.length;j++){
                const tempobj={
                    destination_date:String(fselection.item.legs[i].segments[j].arrival.split("T").slice(0,1)),
                    source_airport:fselection.item.legs[i].segments[j].origin.parent.name,
                    source_airport_code:fselection.item.legs[i].segments[j].origin.flightPlaceId,
                    destination_time:String(fselection.item.legs[i].segments[j].arrival.split("T").slice(1,2)),
                    destination_airport:fselection.item.legs[i].segments[j].destination.parent.name,
                    destination_airport_code:fselection.item.legs[i].segments[j].destination.flightPlaceId,
                    source_time:String(fselection.item.legs[i].segments[j].departure.split("T").slice(1,2)),
                    source_date:String(fselection.item.legs[i].segments[j].departure.split("T").slice(0,1)),
                    airline:fselection.item.legs[i].segments[j].marketingCarrier.name,
                    duration:fselection.item.legs[i].segments[j].durationInMinutes,
                    leg_id:i,
                    segment_id:j,
                    timediff:fselection.item.legs[i].segments[j].timediff?fselection.item.legs[i].segments[j].timediff:""
                }
                flightdata.push(tempobj)
                setflightdata(flightdata)
            }
        }
        //console.log(fselection.item.price.raw)
        // console.log(fsData.number_adults)
        // console.log(fsData.number_child)
        setcostprice({...costprice, airfare:fselection.item.price.raw*(fsData.number_adults+fsData.number_child)})
        setprice({...price, airfare:((fselection.item.price.raw*(fsData.number_adults+fsData.number_child))*1.025).toFixed(0)})
        // console.log(costprice)
        // console.log(flightdata)
        handleClose5()
        }
      }

      const addflighttoquote3=()=>{
        const obj=[]//console.log(fselection)
        //setflightdata(obj)
        if(fselection){
          if(flightdetails){

            for(let i=0; i<flightdetails.legs.length;i++){
               for(let j=0; j<flightdetails.legs[i].segments.length;j++){
                      const tempobj={
                          destination_date:String(flightdetails.legs[i].segments[j].arrival.split("T").slice(0,1)),
                          source_airport:flightdetails.legs[i].segments[j].origin.name,
                          source_airport_code:flightdetails.legs[i].segments[j].origin.displayCode,
                          destination_time:String(flightdetails.legs[i].segments[j].arrival.split("T").slice(1,2)),
                          destination_airport:flightdetails.legs[i].segments[j].destination.name,
                          destination_airport_code:flightdetails.legs[i].segments[j].destination.displayCode,
                          source_time:String(flightdetails.legs[i].segments[j].departure.split("T").slice(1,2)),
                          source_date:String(flightdetails.legs[i].segments[j].departure.split("T").slice(0,1)),
                          airline:flightdetails.legs[i].segments[j].marketingCarrier.name,
                          duration:flightdetails.legs[i].segments[j].duration,
                          leg_id:i,
                          segment_id:j,
                          timediff:flightdetails.legs[i].hasOwnProperty("layovers")?(flightdetails.legs[i].layovers[j]?flightdetails.legs[i].layovers[j].duration:0):0,
                      }
                      obj.push(tempobj)
                    }
              }

          }else{
        for(let i=0; i<fselection.legs.length;i++){
        //     for(let j=0; j<fselection.item.legs[i].segments.length;j++){
                const tempobj={
                    destination_date:String(fselection.legs[i].arrival.split("T").slice(0,1)),
                    source_airport:fselection.legs[i].origin.name,
                    source_airport_code:fselection.legs[i].origin.display_code,
                    destination_time:String(fselection.legs[i].arrival.split("T").slice(1,2)),
                    destination_airport:fselection.legs[i].destination.name,
                    destination_airport_code:fselection.legs[i].destination.display_code,
                    source_time:String(fselection.legs[i].departure.split("T").slice(1,2)),
                    source_date:String(fselection.legs[i].departure.split("T").slice(0,1)),
                    airline:fselection.legs[i].carriers[0].name,
                    duration:fselection.legs[i].duration,
                    leg_id:i,
                    stops:fselection.legs[i].stop_count?fselection.legs[i].stop_count:0,
                    //timediff:fselection.item.legs[i].segments[j].timediff?fselection.item.legs[i].segments[j].timediff:""
                }
                obj.push(tempobj)

        }
      }
        // //console.log(fselection.item.price.raw)
        // // console.log(fsData.number_adults)
        setflightdata(obj)
        setcostprice({...costprice, airfare:fselection.price.amount*(fsData.number_adults+fsData.number_child)})
        setprice({...price, airfare:((fselection.price.amount*(fsData.number_adults+fsData.number_child))*1.025).toFixed(0)})
        // // console.log(costprice)
        // // console.log(flightdata)
        handleClose6()
        }
      }
      const gettcs = () => {
        var t = identifydest(quoteData.primary_destination);
        //console.log("here")
        var convdate=DateCalc(0)
        if (t) {
          if(tripData.trip_status=="Converted"){
            convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
        }else if(tripData.trip_status=="Closed"){
          convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
        }
        //console.log(convdate)
          if(new Date(convdate).getTime()>=new Date("2026-04-01").getTime()){
        if(quoteData.quote_discount){
            return price?Math.round(((price.landprice-quoteData.quote_discount)*1.05)*0.02):0
          }
          else{
            return price?Math.round((price.landprice*1.05)*0.02):0
          }
      }else
        if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
          return 0
        }else{
          if(quoteData.quote_discount){
            return price?Math.round(((price.landprice-quoteData.quote_discount)*1.05)*0.05):0
          }
          else{
            return price?Math.round((price.landprice*1.05)*0.05):0
          }
          
        }
    
          //setprice({...price,tcs:price.landprice*0.05})
          
        } else {
          //console.log("DEF")
          //setprice({...price,tcs:0})
          return 0;
        }
      };
    
      const gettcs2 = () => {
        var t = identifydest(quoteData.primary_destination);
        var convdate=DateCalc(0)
        if (t) {
          if(tripData.trip_status=="Converted"){
            convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
        }else if(tripData.trip_status=="Closed"){
          convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
        }
         if(new Date(convdate).getTime()>=new Date("2026-04-01").getTime()){
        if(quoteData.quote_discount){
            return price?Math.round(((price.landprice2-quoteData.quote_discount)*1.05)*0.02):0
          }
          else{
            return price?Math.round((price.landprice2*1.05)*0.02):0
          }
      }else
        if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
          return 0
        }else{
          if(quoteData.quote_discount){
            return price?Math.round(((price.landprice2-quoteData.quote_discount)*1.05)*0.05):0
          }
          else{
            return price?Math.round((price.landprice2*1.05)*0.05):0
          }
          
        }
          
        } else {
          //console.log("DEF")
          //setprice({...price,tcs:0})
          return 0;
        }
      };
    
      const gettcs3 = () => {
        var t = identifydest(quoteData.primary_destination);
        var convdate=DateCalc(0)
        if (t) {
          if(tripData.trip_status=="Converted"){
            convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
        }else if(tripData.trip_status=="Closed"){
          convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
        }
         if(new Date(convdate).getTime()>=new Date("2026-04-01").getTime()){
        if(quoteData.quote_discount){
            return price?Math.round(((price.landprice3-quoteData.quote_discount)*1.05)*0.02):0
          }
          else{
            return price?Math.round((price.landprice3*1.05)*0.02):0
          }
      }else
        if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
          return 0
        }else{
          if(quoteData.quote_discount){
            return price?Math.round(((price.landprice3-quoteData.quote_discount)*1.05)*0.05):0
          }
          else{
            return price?Math.round((price.landprice3*1.05)*0.05):0
          }
        }
          
        } else {
          //console.log("DEF")
          //setprice({...price,tcs:0})
          return 0;
        }
      };

      const drawer=async()=>{
        getDest()
        setdraweropen(true)
      }



const drawer2close=() => {
  setdraweropen2(false)
  setcost([])
  settotalcost(0)
}

const drawer3close=() => {
  setdraweropen3(false)
  
}

const checkcurr=(currency2, sum)=>{

  if(currency2==1){
    sum=Math.round(sum*(oldcurrency.usd_inr+1.5))
  }else if(currency2==2){
    sum=Math.round(sum*(oldcurrency.sgd_inr+1.5))
  }else if(currency2==3){
    sum=Math.round(sum*(oldcurrency.thb_inr+0.2))
  }else if(currency2==4){
    sum=Math.round(sum*(oldcurrency.eur_inr+1.5))
  }
  return sum
}

const checkdates=()=>{
  if(quoteData.trip_start_date!==daydata[0].date){
    changestartdate(quoteData.trip_start_date)
    getTourCost()
  }else{
    getTourCost()
  }
}



const getTourCost = () => {
  setdraweropen3(true)
  settotalvisacost(parseInt(0))
  settotalvisasales(parseInt(0))
  settotalflightcost(parseInt(0))
  setcostprice({...costprice, airfare:0})
  var sum=0
  var x=0
  var arr=[]
  //let xx=prompt("Enter category of tour prices: 1 for normal, 2 for mid and 3 for high season")
  //if(xx==1 || xx==2 || xx==3){
    
 
  var z= identifycolumn2(quoteData.number_adults, quoteData.number_child)
  //console.log(listtourData)
  for(let i=0; i<daydata.length; i++) {
    var y=alllisttourData.filter(tour=>tour.tour_city==daydata[i].city && tour.tour_name==daydata[i].tour_name)
    //console.log(y)
    let xx=getratecategory(daydata[i])
    //console.log(xx)
    if(multidest){
      var curr=y.length>0?identifycurr(y[0].tour_destination):0
      if(xx==1){
       // console.log(y)
        const x2=(y.length>0 && "normal" in y[0] && z && z in y[0].normal)?y[0].normal[z]:-1
       // console.log(x2)
        x=checkcurr(curr, x2)
        //console.log(x)
        sum=sum+x
        arr.push({
          name:daydata[i].tour_name,
          rate:x,
          type:"CRM",
          inventory:"Tour",
          currency:"INR",
        })
        //console.log(sum, arr)
      }else if(xx==2){
        const x3=(y.length>0 && "mid" in y[0]) && (z in y[0].mid)?y[0].mid[z]:0
        x=checkcurr(curr, x3)
        sum=sum+x
        arr.push({
          name:daydata[i].tour_name,
          rate:x,
          type:"CRM",
          inventory:"Tour",
          currency:"INR",
        })
      }else if(xx==3){
        const x4=(y.length>0 && "high" in y[0]) && (z in y[0].high)?y[0].high[z]:0
        x=checkcurr(curr, x4)
        sum=sum+x
        arr.push({
          name:daydata[i].tour_name,
          rate:x,
          type:"CRM",
          inventory:"Tour",
          currency:"INR",
        })
      }
    }else{
      //console.log("Here")
      if(xx==1){
        x=(y.length>0 && "normal" in y[0] && z && z in y[0].normal)?y[0].normal[z]:-1
        sum=sum+x
        arr.push({
          name:daydata[i].tour_name,
          rate:x,
          type:"CRM",
          inventory:"Tour",
          currency:"CUR",
        })
        //console.log(arr, sum)
      }else if(xx==2){
        x=(y.length>0 && "mid" in y[0]) && (z in y[0].mid)?y[0].mid[z]:0
        sum=sum+x
        arr.push({
          name:daydata[i].tour_name,
          rate:x,
          type:"CRM",
          inventory:"Tour",
          currency:"CUR",
        })
      }else if(xx==3){
        x=(y.length>0 && "high" in y[0]) && (z in y[0].high)?y[0].high[z]:0
        sum=sum+x
        arr.push({
          name:daydata[i].tour_name,
          rate:x,
          type:"CRM",
          inventory:"Tour",
          currency:"CUR",
        })
      }
    }
  }
  
  console.log(sum)
  if(multidest){
  getHotelCost2(sum, arr)
  }else{
    getHotelCost(sum, arr)
  }
// }else{
//   alert("Please enter correct value 1, 2 or 3")
// }
}

const getHotelCost2 = (sum, arr) => {
  // const currency2=identifycurr(quoteData.primary_destination)
  var x=0
  let yz=[]
  let z=prompt("Enter # of rooms required:")
  setnumberofrooms(z)
  for(let i=0;i<z;i++){
    let y=prompt("Enter room category for room number "+(i+1)+":  1 for base and 2 for base with extra bed")
    yz.push(y)
  }
  
  for(let i=0; i<daydata.length-1; i++) {
    let flag=0
    const selecthotel=listhotelData.filter(hotel=>hotel.hotel_name==daydata[i].hotel_name)
    const curr=identifycurr(selecthotel[0].hotel_destination)
    if(selecthotel.length>0 &&("rate" in selecthotel[0]) && selecthotel[0].rate.length>0){
      //console.log(sum)
      for(let j=0; j<selecthotel[0].rate.length; j++){
        if(new Date(daydata[i].date).getTime()>=new Date(selecthotel[0].rate[j].start_date).getTime() && new Date(daydata[i].date).getTime()<=new Date(selecthotel[0].rate[j].end_date).getTime()){
          let tempsum=0
          for(let k=0;k<yz.length;k++){
            if(yz[k]==1){
              x=checkcurr(curr, selecthotel[0].rate[j].base_price)
              tempsum=tempsum+x
              sum=sum+x
            }else{
              x= checkcurr(curr,selecthotel[0].rate[j].base_extrabed_price)
              tempsum=tempsum+x
              sum=sum+x
            }
           
          }
          arr.push({
            name:selecthotel[0]?selecthotel[0].hotel_name:"",
            rate:tempsum,
            type:"CRM",
            inventory:"Hotel",
            currency:"INR",
            room_type:""
          })
        

          flag=0
          break
        }else{
          //console.log(i)
          //console.log(flag)
          flag=1
          //console.log(flag)
      }
      }
    }else{
      console.log("Rate not found "+selecthotel[0]?selecthotel[0]:"" && "hotel_name" in selecthotel[0]?selecthotel[0].hotel_name:"")
      arr.push({
        name:selecthotel[0]?selecthotel[0].hotel_name:"",
        rate:-1,
        type:"CRM",
        inventory:"Hotel",
        currency:"INR",
        room_type:""
      })
      
    }
    if(flag==1){
      arr.push({
        name:selecthotel[0]?selecthotel[0].hotel_name:"",
        rate:-1,
        type:"CRM",
        inventory:"Hotel",
        currency:"INR",
        room_type:"",
      })
      //console.log(i)
    }
  }
  // arr.push({
  //   name:"Total (in currency)",
  //   rate:sum,
  //   type:"Total"
  // })
  //console.log(sum)
  //console.log(arr)
  // if(currency2==1){
  //   sum=Math.round(sum*(oldcurrency.usd_inr+1.5))
  // }else if(currency2==2){
  //   sum=Math.round(sum*(oldcurrency.sgd_inr+1.5))
  // }else if(currency2==3){
  //   sum=Math.round(sum*(oldcurrency.thb_inr+0.2))
  // }
  
  setcost(arr)
  //settotalcost(sum)
  sumcurrency(arr)
  checkallgood()
  
}

const getHotelCost = (sum, arr) => {
  const currency2=identifycurr(quoteData.primary_destination)
  var x=0
  let yz=[]
  let z=prompt("Enter # of rooms required:")
  setnumberofrooms(z)
  for(let i=0;i<z;i++){
    let y=prompt("Enter room category for room number "+(i+1)+":  1 for base and 2 for base with extra bed")
    yz.push(y)
  }
  
  for(let i=0; i<daydata.length-1; i++) {
    let flag=0
    const selecthotel=listhotelData.filter(hotel=>hotel.hotel_name==daydata[i].hotel_name)
    //console.log(selecthotel[0])
    if(selecthotel.length>0 &&("rate" in selecthotel[0]) && selecthotel[0].rate.length>0){
      //console.log(daydata[i].hotel_name)
      for(let j=0; j<selecthotel[0].rate.length; j++){
        if(new Date(daydata[i].date).getTime()>=new Date(selecthotel[0].rate[j].start_date).getTime() && new Date(daydata[i].date).getTime()<=new Date(selecthotel[0].rate[j].end_date).getTime()){
          let tempsum=0
          for(let k=0;k<yz.length;k++){
            if(yz[k]==1){
              x=selecthotel[0].rate[j].base_price
              tempsum=tempsum+x
              sum=sum+x
            }else{
              x= selecthotel[0].rate[j].base_extrabed_price
              tempsum=tempsum+x
              sum=sum+x
            }
           
          }
          arr.push({
            name:selecthotel[0]?selecthotel[0].hotel_name:"",
            rate:tempsum,
            type:"CRM",
            inventory:"Hotel",
            currency:"CUR",
            room_type:"",
          })
        

          flag=0
          break
        }else{
          //console.log(i)
          //console.log(flag)
          flag=1
          //console.log(flag)
      }
      }
    }else{
      console.log("Rate not found "+selecthotel[0]?selecthotel[0]:"" && "hotel_name" in selecthotel[0]?selecthotel[0].hotel_name:"")
      arr.push({
        name:selecthotel[0]?selecthotel[0].hotel_name:"",
        rate:-1,
        type:"CRM",
        inventory:"Hotel",
        currency:"CUR",
        room_type:"",
      })
      
    }
    if(flag==1){
      arr.push({
        name:selecthotel[0]?selecthotel[0].hotel_name:"",
        rate:-1,
        type:"CRM",
        inventory:"Hotel",
        currency:"CUR",
        room_type:"",
      })
      //console.log(i)
    }
  }
  arr.push({
    name:"Total (in currency)",
    rate:sum,
    inventory:"Total",
    type:"Total",
    
  })
  //console.log(sum)
  //console.log(arr)
  if(currency2==1){
    sum=Math.round(sum*(oldcurrency.usd_inr+1.5))
  }else if(currency2==2){
    sum=Math.round(sum*(oldcurrency.sgd_inr+1.5))
  }else if(currency2==3){
    sum=Math.round(sum*(oldcurrency.thb_inr+0.2))
  }else if(currency2==4){
    sum=Math.round(sum*(oldcurrency.eur_inr+1.5))
  }
  
  setcost(arr)
  settotalcost(sum)
  checkallgood()
 
}

const getcp=async(e, rd, hotel)=>{
  setOpen9(true)
  var nation=getnationality(searchData.nationality)
  // var data={'XML': '<CancellationPolicyRequest>\n <Authentication>\n      <AgentCode>CD102014</AgentCode>\n      <UserName>JVXML</UserName>\n      <Password>Operations@2024</Password>\n   </Authentication>\n<ArrivalDate>'+responseData.ArrivalDate+'</ArrivalDate>\n <DepartureDate>'+responseData.DepartureDate+'</DepartureDate>\n <HotelId>'+hotel.Id+'</HotelId>\n <CountryCode>'+hsData.dest+'</CountryCode>\n <City>'+hsData.city+'</City>\n <GuestNationality>'+nation+'</GuestNationality>\n <Currency>INR</Currency>\n <RoomDetails>\n <RoomDetail>\n <Type>'+rd.Type+'</Type>\n <BookingKey>'+rd.BookingKey+'</BookingKey>\n <Adults>'+rd.Adults+'</Adults>\n <Children>'+rd.Children+'</Children>\n <ChildrenAges>'+rd.ChildrenAges+'</ChildrenAges>\n </RoomDetail>\n </RoomDetails>\n </CancellationPolicyRequest>'}

  var data={'XML': '<CancellationPolicyRequest>\n <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n<ArrivalDate>'+responseData.ArrivalDate+'</ArrivalDate>\n <DepartureDate>'+responseData.DepartureDate+'</DepartureDate>\n <HotelId>'+hotel.Id+'</HotelId>\n <CountryCode>'+hsData.dest+'</CountryCode>\n <City>'+hsData.city+'</City>\n <GuestNationality>'+nation+'</GuestNationality>\n <Currency>INR</Currency>\n <RoomDetails>\n <RoomDetail>\n <Type>'+rd.Type+'</Type>\n <BookingKey>'+rd.BookingKey+'</BookingKey>\n <Adults>'+rd.Adults+'</Adults>\n <Children>'+rd.Children+'</Children>\n <ChildrenAges>'+rd.ChildrenAges+'</ChildrenAges>\n </RoomDetail>\n </RoomDetails>\n </CancellationPolicyRequest>'}

  console.log(data)

  const resdata=await rzcpbooking(data)
  console.log(resdata.data)

   const parser = new XMLParser();
   let jObj = parser.parse(resdata.data);
    console.log(jObj.CancellationPolicyResponse)
    setresponseData3(jObj.CancellationPolicyResponse)
}

const total = (pd) => {
    let a="airfare" in pd && pd.airfare?parseInt(pd.airfare):0
    let b="landprice" in pd && pd.landprice?parseInt(pd.landprice):0
    let c="otheritems" in pd && pd.otheritems?parseInt(pd.otheritems):0
    let d="landprice" in pd && pd.landprice?parseInt(pd.landprice * 0.05):0
    //console.log(a,b,c,d)
    return {total:a+b+c+d, airfare:a}
  };

const checkallgood=()=>{
  let flag=0
  for(let i=0;i<cost.length; i++){
    //console.log(arr[i].rate)
    if(cost[i].rate<0){
      flag=1
    }
  }
  //console.log(flag)
  if(!flag){
    setallgood(true)
  }else{
    setallgood(false)
  }
}

const getStarttime = (item) => {
  var selecttour=alllisttourData.filter(tour=>tour.tour_name==item.tour_name)
  if(selecttour[0] && ("start_time" in selecttour[0])){
    return selecttour[0].start_time
  }else{
    return ""
  }
  
}

const getEndtime = (item) => {
  var selecttour=alllisttourData.filter(tour=>tour.tour_name==item.tour_name)
  if(selecttour[0] &&("end_time" in selecttour[0])){
    return selecttour[0].end_time
  }else{
    return ""
  }
}

const GetHotelName=(item)=>{
  var name=listhotelData?.filter(hotel => hotel.hotel_name == item.hotel_name)
  if(name.length>0 && "rezlive_id" in name[0]){
    return "Hotel Name ("+name[0].rezlive_id+")"
  }else{
    return "Hotel Name"
  }
}

const changehotel=(value)=>{
  let hasDuplicate = hotellist.some((val, i) => hotellist.indexOf(val) !== i);
  if(hasDuplicate){
    alert("Duplicate hotels found. Search manually")
    setOpen7(false)
  }else{
  let found=0
  var rooms=[]
  for(let i=0;i<numberofrooms;i++){
    rooms=[...rooms,{}]
  }
  const tempobj={
    hotel_name: value,
  }
  
  var name=listhotelData?.filter(hotel => hotel.hotel_name == value)
  if(name.length>0 && "rezlive_id" in name[0]){
    tempobj.hotel_id = name[0].rezlive_id
    tempobj.dest = destcode(name[0].hotel_destination);
    tempobj.city = name[0].rezlive_city_id
    //tempobj.city = citycode(name[0].hotel_city);
  }else{
    tempobj.hotel_id = 0
  }
 console.log(daydata)
  for(let i=0; i<daydata.length; i++){
    if(value==daydata[i].hotel_name || value==daydata[i].hotel_name2 ||value==daydata[i].hotel_name3){
      if(!found){
        tempobj.start_date=new Date(daydata[i].date)
        console.log(tempobj)
      }
      found=1
    }else{
      found=0
      if(tempobj.start_date && !tempobj.end_date){
        tempobj.end_date=new Date(daydata[i].date)
      } 
    }
  }
  if(!tempobj.end_date){
    //console.log("ABC")
    tempobj.end_date=new Date(daydata[daydata.length-1].date)
  }

  if(numberofrooms==1){
    rooms[0].id=uuidv4()
    rooms[0].number_adults=quoteData.number_adults
    rooms[0].number_child=quoteData.number_child
    rooms[0].childnumber=childagearray(quoteData.number_child)
  }else{
    for(let i=0; i<numberofrooms-1; i++){
      rooms[i].id=uuidv4()
      rooms[i].number_adults=(quoteData.number_adults/numberofrooms%1)!==0?Math.ceil(quoteData.number_adults/numberofrooms)-1:Math.ceil(quoteData.number_adults/numberofrooms)
      rooms[i].number_child=(quoteData.number_child/numberofrooms%1)!==0?Math.ceil(quoteData.number_child/numberofrooms)-1:Math.ceil(quoteData.number_child/numberofrooms)
      rooms[i].childnumber=childagearray(rooms[i].number_child)
    } 
    rooms[numberofrooms-1].number_adults=quoteData.number_adults-getSumByKey2(rooms,"number_adults")
    rooms[numberofrooms-1].number_child=quoteData.number_child-getSumByKey2(rooms,"number_child")
    rooms[numberofrooms-1].childnumber=childagearray(rooms[numberofrooms-1].number_child)
    rooms[numberofrooms-1].id=uuidv4()
  }
   
  tempobj.rooms=rooms
  //console.log(tempobj)
  sethsData(tempobj)
  //console.log(getSumByKey2(rooms,"number_adults"))
}
}

const adultschange = (e, tid, id) => {
  var newarr=hsData.rooms
  const newdata = hsData.rooms[tid];
 
  // //console.log(newdata)
  const newitem = { ...newdata, number_adults: e.target.value };
  newarr=newarr.map(item=>item.id == id ? newitem : item)
  sethsData({...hsData,rooms:newarr})
  //setdata([...data, data[tid]=newitem])
  // console.log(cpdata)
};

const childchange = (e, tid, id) => {
  var newarr=hsData.rooms
  const newdata = hsData.rooms[tid];
 
  const arr=childagearray(e.target.value)
  const newitem = { ...newdata, number_child: e.target.value, childnumber:arr };
  newarr=newarr.map(item=>item.id == id ? newitem : item)
  sethsData({...hsData,rooms:newarr})
};

const childage = (value, tid, num, id) => {
  var newarr=hsData.rooms
  const newdata = hsData.rooms[tid];
  // const newdata = roomdata[name];
  // //setchildData([...newdata.childnumber, tempobj]);
  newdata.childnumber[num]=value
  //const newitem = { ...newdata, number_child: e.target.value, childnumber:arr };
  newarr=newarr.map(item=>item.id == id ? newdata : item)
  sethsData({...hsData,rooms:newarr})
  // setroomdata(roomdata.map((item) => (item.id == id ? newdata : item)));
};

const searchhotel = async() => {
  //console.log(hsData)
  if(hsData.hotel_id){
    var sd=formatDate3(hsData.start_date)
    var ed=formatDate3(hsData.end_date)

    var room=""
      
    for (let i=0; i<hsData.rooms.length; i++) {
      var cdata=""
      
      if("number_child" in hsData.rooms[i] && hsData.rooms[i].number_child>0){
        var cage=""
        
        for(let j=0;j<hsData.rooms[i].childnumber.length;j++){
          if(hsData.rooms[i].childnumber[j]!==""){
          cage=cage+"<ChildAge>"+hsData.rooms[i].childnumber[j]+"</ChildAge>\n"
          }else{
            alert("Enter child age and try again")
          }
        }
        cdata="<NoOfChilds>"+hsData.rooms[i].number_child+"</NoOfChilds>\n"+"<ChildrenAges>\n"+cage+"</ChildrenAges>\n"
      }else{
        cdata="<NoOfChilds>0</NoOfChilds>\n"
      }
      room=room+"<Room>\n"+"<Type>Room-"+(i+1)+"</Type>\n"+"<NoOfAdults>"+hsData.rooms[i].number_adults+"</NoOfAdults>\n"+cdata+"</Room>\n"
    }

    // var data = {
    //   'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD102014</AgentCode>\n      <UserName>JVXML</UserName>\n      <Password>Operations@2024</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+hsData.dest+'</CountryCode>\n      <City>'+hsData.city+'</City>\n <HotelIDs>\n<Int>'+hsData.hotel_id+'</Int>\n</HotelIDs>\n     <GuestNationality>IN</GuestNationality>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
    // };
    var data = {
      'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+hsData.dest+'</CountryCode>\n      <City>'+hsData.city+'</City>\n <HotelIDs>\n<Int>'+hsData.hotel_id+'</Int>\n</HotelIDs>\n     <GuestNationality>IN</GuestNationality>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
    };
    console.log(data)
    setstatus("Loading")

    const resdata=await rzsearchhotelbyid(data)
    setstatus("Completed")
    console.log((resdata.data))
    const parser = new XMLParser();
    const jObj = parser.parse(resdata.data);
    console.log(jObj.HotelFindResponse)
    setresponseData(jObj.HotelFindResponse)
    if("error" in jObj.HotelFindResponse && jObj.HotelFindResponse.error.includes("E-1004")){
      setstatus("error")
    }
    if("Hotels" in jObj.HotelFindResponse && "Hotel" in jObj.HotelFindResponse.Hotels){
      sethotelData([jObj.HotelFindResponse.Hotels.Hotel])
     }else{
      sethotelData([])
     }
  }else{
    alert("Id unknown for this hotel. Please add id first and then search")
  }
  
};

const usehotel=(e, rd, hotel)=>{
  setOpen7(false)
  setdraweropen3(true)
  const tempobj={
    name:hotel.Name,
    rate:String(rd.TotalRate).includes("|")?calccost(rd.TotalRate):Math.round(rd.TotalRate*oldcurrency.usd_inr),
    type:"Hotel-API",
    inventory:"Hotel",
    currency:"INR",
    room_type:rd.Type,
  }
  setcost([...cost,tempobj])
  sumcurrency([...cost,tempobj])
  //console.log(cost)
  // console.log(rd)
  // console.log(hotel)
}

const replacehotel=(e, rd, hotel)=>{
  var x=0
  var temp=[...cost]
  setOpen7(false)
  setdraweropen3(true)
  let found=0
  const tempobj={
    name:hsData.hotel_name,
    rate:String(rd.TotalRate).includes("|")?calccost(rd.TotalRate):Math.round(rd.TotalRate*oldcurrency.usd_inr),
    type:"Hotel-API",
    inventory:"Hotel",
    currency:"INR",
    room_type:rd.Type,
  }
  for(let i=0; i<temp.length; i++) {
    if(temp[i].name==hsData.hotel_name){
      if(found==0){
        //console.log("Found")
        temp[i]=tempobj
        found=1
      }else{
        //console.log("Not Found")
        temp.splice(i,1)
        i--
      }
      
    }
  }
  //console.log(temp)
  // setcost(temp)
  //setcost(cost.map(c=>c.name==hsData.hotel_name?tempobj:c))
  sumcurrency(temp)
  // const tempobj2=cost.filter(entry=>entry.name !==hsData.hotel_name && entry.name !=="Total (in currency)")
  // const tempobj3=tempobj2.filter(entry=>entry.type !=="Hotel-API" && entry.currency =="CUR")
  // const tempobj5=tempobj2.filter(entry=>entry.type =="API")
  // const sum=getSumByKey2(tempobj3,"rate")
  // const sum2=tempobj5.length>0?getSumByKey2(tempobj5,"rate"):0
  // console.log(sum)
  // const tempobj4={
  //   name:"Total (in currency)",
  //   rate:sum,
  //   type:"CRM",
  //   currency:"CUR"
  // }
  // // const tempobj3=cost.filter(entry=>entry.name =="Total (in currency)")
  // // console.log(tempobj3)
  // const currency2=identifycurr(quoteData.primary_destination)
  // if(currency2==1){
  //   x=Math.round(sum*(oldcurrency.usd_inr+1.5))
  // }else if(currency2==2){
  //   x=Math.round(sum*(oldcurrency.sgd_inr+1.5))
  // }else if(currency2==3){
  //   x=Math.round(sum*(oldcurrency.thb_inr+0.2))
  // }
  // settotalcost(x+parseInt(tempobj.rate)+sum2)
  // setcost([...tempobj2,tempobj, tempobj4])
  //console.log(cost)
  //console.log(tempobj2)
  //console.log(tempobj3)
}

const sumcurrency=(temp)=>{
  let sum=0
  let sum2=0
  let x=0
  for(let i=0;i<temp.length;i++){
    if(temp[i].name!=="Total (in currency)"){
      if(multidest){
        if(temp[i].type !=="CRM-Visa"){
          console.log(temp[i].name)
        sum2=sum2+temp[i].rate
        }
      }else{
        if(temp[i].currency=="CUR"){
          sum=sum+temp[i].rate
        }else {
          if(!(temp[i].type =="CRM-Visa" || temp[i].type =="Manual-Flight" || temp[i].type =="API-Flight") ){
          sum2=sum2+temp[i].rate
          }
        }
      }
    }
    const currency2=identifycurr(quoteData.primary_destination)
    //console.log(quoteData.primary_destination)
    //console.log(currency2)
    if(currency2==1){
      x=Math.round(sum*(oldcurrency.usd_inr+1.5))
    }else if(currency2==2){
      x=Math.round(sum*(oldcurrency.sgd_inr+1.5))
    }else if(currency2==3){
      x=Math.round(sum*(oldcurrency.thb_inr+0.2))
    }else if(currency2==4){
      x=Math.round(sum*(oldcurrency.eur_inr+1.5))
    }else{
      x=sum
    }
    const tempobj4={
        name:"Total (in currency)",
        rate:sum,
        type:"Total",
        inventory:"Total",
      }
  var temp2=temp.map(c=>c.name=="Total (in currency)"?tempobj4:c)
  //console.log(x, sum2)
  setcost(temp2)
  settotalcost(x+sum2)
    
  }
}

const sumcurrency2=(temp, dest)=>{
  let sum=0
  let sum2=0
  let x=0
  for(let i=0;i<temp.length;i++){
    if(temp[i].name!=="Total (in currency)"){
      if(multidest){
        if(temp[i].type !=="CRM-Visa"){
          console.log(temp[i].name)
        sum2=sum2+temp[i].rate
        }
      }else{
        if(temp[i].currency=="CUR"){
          sum=sum+temp[i].rate
        }else {
          if(!(temp[i].type =="CRM-Visa" || temp[i].type =="Manual-Flight" || temp[i].type =="API-Flight") ){
          sum2=sum2+temp[i].rate
          }
        }
      }
    }
    const currency2=identifycurr(dest)
    //console.log(quoteData.primary_destination)
    console.log(currency2)
    if(currency2==1){
      x=Math.round(sum*(84+1.5))
    }else if(currency2==2){
      x=Math.round(sum*(62+1.5))
    }else if(currency2==3){
      x=Math.round(sum*(2.3+0.2))
    }else if(currency2==4){
      x=Math.round(sum*(91+1.5))
    }else{
      x=sum
    }
    const tempobj4={
        name:"Total (in currency)",
        rate:sum,
        type:"Total",
        inventory:"Total",
      }
  var temp2=temp.map(c=>c.name=="Total (in currency)"?tempobj4:c)
  console.log(x, sum2)
  setcost(temp2)
  settotalcost(x+sum2)
    
  }
}

//console.log(oldcurrency)

const addpricetoquote=()=>{
  setpriceadd(true)
  setcostprice({...costprice, landprice:totalcost, airfare:totalflightcost, otheritems:totalvisacost})
  drawer3close()
}

const filterrooms=()=>{
// setfilterData({mealplan:value})
var newData = responseData.Hotels.Hotel

if("mealplan" in filterData && newData && filterData.mealplan != ""){
  var hd2=[]
  var rd2=[]
  
    console.log(newData)
    if(Array.isArray(newData.RoomDetails.RoomDetail)){
      if(filterData.mealplan=="Only Breakfast"){
        rd2=newData.RoomDetails.RoomDetail.filter(rd=> ("RoomDescription" in rd && rd.RoomDescription.includes("Breakfast") && !rd.RoomDescription.includes("Dinner") && !rd.RoomDescription.includes("Lunch")) || ("BoardBasis" in rd && rd.BoardBasis.includes("Breakfast") && !rd.BoardBasis.includes("Dinner") && !rd.BoardBasis.includes("Lunch")))
      }else if(filterData.mealplan=="Half Board"){
        rd2=newData.RoomDetails.RoomDetail.filter(rd=> ("RoomDescription" in rd && (rd.RoomDescription.includes("Breakfast") && rd.RoomDescription.includes("Dinner") && !rd.RoomDescription.includes("Lunch")) || rd.RoomDescription.includes("Half Board")) || (("BoardBasis" in rd && rd.BoardBasis.includes("Breakfast") && rd.BoardBasis.includes("Dinner") && !rd.BoardBasis.includes("Lunch")) || rd.BoardBasis.includes("Half Board")))
      }else if(filterData.mealplan=="Full Board"){
        rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && (rd.RoomDescription.includes("Breakfast") && rd.RoomDescription.includes("Dinner") && rd.RoomDescription.includes("Lunch")) || rd.RoomDescription.includes("Full Board") ||((("BoardBasis" in rd && rd.BoardBasis.includes("Breakfast") && rd.BoardBasis.includes("Dinner") && rd.BoardBasis.includes("Lunch")) || rd.BoardBasis.includes("Full Board"))))
      }else if(filterData.mealplan=="All Inclusive"){
        rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("All Inclusive") )
      }else if(filterData.mealplan=="Room Only"){
        rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("Room Only") )
      }
      
      const temproomdetails={...newData.RoomDetails, RoomDetail:rd2}
      const temphotel={...newData, RoomDetails:temproomdetails}
      console.log(temphotel)
      if(temphotel.RoomDetails.RoomDetail.length>0){
        hd2=[...hd2,temphotel]
      }
    }else{
      if(filterData.mealplan=="Only Breakfast"){
        rd2="RoomDescription" in newData.RoomDetails.RoomDetail && newData.RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && !newData.RoomDetails.RoomDetail.RoomDescription.includes("Dinner") && !newData.RoomDetails.RoomDetail.RoomDescription.includes("Lunch")?newData.RoomDetails.RoomDetail:[]
      }else if(filterData.mealplan=="Half Board"){
        rd2="RoomDescription" in newData.RoomDetails.RoomDetail && (newData.RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && newData.RoomDetails.RoomDetail.RoomDescription.includes("Dinner")) || newData.RoomDetails.RoomDetail.RoomDescription.includes("Half Board")?newData.RoomDetails.RoomDetail:[]
      }else if(filterData.mealplan=="Full Board"){
        rd2="RoomDescription" in newData.RoomDetails.RoomDetail && (newData.RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && newData.RoomDetails.RoomDetail.RoomDescription.includes("Dinner") && newData.RoomDetails.RoomDetail.RoomDescription.includes("Lunch")) || newData.RoomDetails.RoomDetail.RoomDescription.includes("Full Board")?newData.RoomDetails.RoomDetail:[]
      }else if(filterData.mealplan=="All Inclusive"){
        rd2="RoomDescription" in newData.RoomDetails.RoomDetail && newData.RoomDetails.RoomDetail.RoomDescription.includes("All Inclusive") ?newData.RoomDetails.RoomDetail:[]
      }else if(filterData.mealplan=="Room Only"){
        rd2="RoomDescription" in newData.RoomDetails.RoomDetail && newData.RoomDetails.RoomDetail.RoomDescription.includes("Room Only")?newData.RoomDetails.RoomDetail:[]
      }
     
      const temproomdetails={...newData.RoomDetails, RoomDetail:rd2}
      const temphotel={...newData, RoomDetails:temproomdetails}
      console.log(temphotel)
      if(temphotel.RoomDetails.RoomDetail.length>0){
        hd2=[...hd2,temphotel]
      }
    }
 
  newData=hd2
}else{
  newData=[newData]
}
console.log(newData)
sethotelData(newData)
}

const getToken=async()=>{
  
  const data= await fetchTokenData();
  //console.log(data.data)
  settoken(data.data[0].token)
  const newDate=DateCalc(0)
  const saveddate=DateCalc2(data.data[0].date, 0)
  //const saveddate=2
  //console.log(data.data[0])
  if(newDate!==saveddate){
      console.log("Fetching token")
      const newtokendata={
        "ClientId": "tboprod",
              "UserName": "DELJ300",
              "Password": "@dminInd$987#", 
      }
      console.log(newtokendata)
      const data2 = await fetchToken(newtokendata);
      
      console.log(data2.data)
      settoken(data2.data.TokenId)
      const newtokendata2={
        token:data2.data.TokenId,
        date:new Date()
      }
      //console.log(newtokendata2)
      const updatetokenResponse= await updateTokenData(data.data[0]._id, newtokendata2);
      
      if(updatetokenResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          console.log("Token Data Updated")
      }
      else{
          alert("Unable to refresh currency data");
          
      }
  }else{
      console.log("New token will be fetched after 24 hours")
  }
  
 }

 const getTCToken=async()=>{
  //console.log(process.env)
  const data= await fetchTokenData();
  console.log(data.data)
  const temp=data.data.filter(t=>t.source=="Travclan")
  settoken(temp[0].token)
  const newDate=DateCalc(0)
  const saveddate=DateCalc2(temp[0].date, 0)
  //console.log(newDate)
  //console.log(saveddate)
  if(newDate!==saveddate){
      console.log("Fetching token")
      const newtokendata={
          // "merchant_id":process.env.REACT_APP_TC_MERCHANT_ID,
          // "user_id":process.env.REACT_APP_TC_USER_ID,
          // "api_key":process.env.REACT_APP_TC_API_KEY,
          // "merchant_id":"jetovac8",
          // "user_id":"c881dfca7",
          // "api_key":"24a04715-8979-4beb-9309-182e63eed1fd",
          "merchant_id":"jetovc01",
          "user_id":"c5db5f622",
          "api_key":"d1990eed-dcc8-4b40-8aff-6dae1ec959fe",

        }
      //console.log(newtokendata)
      const data2 = await refreshTCToken(newtokendata);
      
      console.log(data2.data)
      settoken(data2.data.AccessToken)
      const newtokendata2={
        token:data2.data.AccessToken,
        date:new Date(),
        source:"Travclan"
      }
      //console.log(newtokendata2)
      const updatetokenResponse= await updateTokenData(temp[0]._id, newtokendata2);
      
      if(updatetokenResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          console.log("Token Data Updated")
      }
      else{
          alert("Unable to refresh currency data");
          
      }
  }else{
      console.log("New token will be fetched after 24 hours")
  }
  
 }

const addsp = () => {
  //console.log(spdata)

  setairportdata(
    airportdata.length == 0 ? [{ id: uuidv4(), cabin_class:"Economy",
    departure_time:"All Day",
    arrival_time:"All Day"}] : [...airportdata, { id: uuidv4(), cabin_class:"Economy",
    departure_time:"All Day",
    arrival_time:"All Day"}]
  );
};

const removesp = () => {
  //console.log(spdata)
  setairportdata([...airportdata].slice(0, airportdata.length - 1));
};

const sourcechange = (e, tid, id) => {
  //console.log(tid, id)
  const newdata = airportdata[tid];
  //console.log(newdata)
  const newitem = { ...newdata, source: e.target.value };
  
  if(searchData.type=="Return" || searchData.type=="Special Return"){
    if(airportdata[tid+1]){
      const newitem2 = { ...airportdata[tid+1], dest: e.target.value };
      setairportdata([newitem, newitem2])
      //setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
    }else{
      setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
    }  
  }else{
    setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  }
  setstatus("ABC")
 
};

const destchange = (e, tid, id) => {
  //console.log(tid, id)
  const newdata = airportdata[tid];
  const newitem = { ...newdata, dest: e.target.value };

  if(searchData.type=="Return" || searchData.type=="Special Return"){
    if(airportdata[tid+1]){
      const newitem2 = { ...airportdata[tid+1], source: e.target.value };
      setairportdata([newitem, newitem2])
      //setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
    }else{
      setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
    }  
  }else{
    setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  }
  //console.log(newitem)
  //setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  //setdata([...data, data[tid]=newitem])
  // console.log(cpdata)
};

const datechange = (e, tid, id) => {
  //console.log(tid, id)
  const newdata = airportdata[tid];
  const newitem = { ...newdata, date: e.target.value };
  //console.log(newitem)
  setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  //setdata([...data, data[tid]=newitem])
  // console.log(cpdata)
};

const classchange = (e, tid, id) => {
  //console.log(tid, id)
  const newdata = airportdata[tid];
  const newitem = { ...newdata, cabin_class: e.target.value };
  console.log(newitem)
  setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  //setdata([...data, data[tid]=newitem])
  // console.log(cpdata)
};
const departurechange = (e, tid, id) => {
  //console.log(tid, id)
  const newdata = airportdata[tid];
  const newitem = { ...newdata, departure_time: e.target.value };
  console.log(newitem)
  setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  //setdata([...data, data[tid]=newitem])
  // console.log(cpdata)
};
const arrivalchange = (e, tid, id) => {
  //console.log(tid, id)
  const newdata = airportdata[tid];
  const newitem = { ...newdata, arrival_time: e.target.value };
  console.log(newitem)
  setairportdata(airportdata.map((item) => (item.id == id ? newitem : item)));
  //setdata([...data, data[tid]=newitem])
  // console.log(cpdata)
};

const controlleg=(value)=>{
  setsearchData({...searchData, type:value})
  var someDate = tripData.trip_start_date
      ? new Date(tripData.trip_start_date).getTime()
      : 0;
    var mstoAdd = tripData.duration
      ? tripData.duration * 24 * 60 * 60 * 1000
      : 0;
    //console.log(someDate, mstoAdd);
    var returndate = new Date(someDate + mstoAdd).toISOString();
  
  if(value=="One-way"){
      setcontrol(false)
      setairportdata([{ id: uuidv4(),cabin_class:"Economy",
      departure_time:"All Day",
      source:destAirport2(tripData.lead_source_airport), dest:destAirport(tripData.primary_destination),
      date:tripData.trip_start_date
    ? tripData.trip_start_date.slice(0, 10)
    : 0,
      arrival_time:"All Day"},])
  }else if(value=="Return" || value=="Special Return"){
      setcontrol(false)
      setairportdata([{ id: uuidv4(), cabin_class:"Economy",
      departure_time:"All Day",
      date:tripData.trip_start_date
    ? tripData.trip_start_date.slice(0, 10)
    : 0,
      source:destAirport2(tripData.lead_source_airport), dest:destAirport(tripData.primary_destination),
      arrival_time:"All Day"}, 
      { id: uuidv4(), cabin_class:"Economy",
      date:returndate.slice(0, 10),
      departure_time:"All Day",
      arrival_time:"All Day", source:destAirport(tripData.primary_destination), dest:destAirport2(tripData.lead_source_airport)}])
  }else{
      setcontrol(true)
  }
}
const getdate=(date, time) =>{
  if(time=="All Day"){
    return date+"T00:00:00"
  }else if(time=="Morning"){
    return date+"T08:00:00"
  }else if(time=="Afternoon"){
    return date+"T14:00:00"
  }else if(time=="Evening"){
    return date+"T19:00:00"
  }else if(time=="Night"){
    return date+"T01:00:00"
  }
}

const getclass=(value) =>{
  if(value==2){
    return "Economy"
  }else if(value==3){
    return "Premium Economy"
  }else if (value==4){
    return "Business"
  }else if (value==5){
    return "Premium Business"
  }else if (value==6){
    return "First"
  }
}

const getprice=(fare)=>{
  var x=
    ("BaseFare" in fare?fare.BaseFare:0)+
    ("Tax" in fare?fare.Tax:0)+
    ("OtherCharges" in fare?fare.OtherCharges:0)+
    ("ServiceFee" in fare?fare.ServiceFee:0)+
    ("AirlineTransFee" in fare?fare.AirlineTransFee:0)-
    ("PLBEarned" in fare?fare.PLBEarned:0)-
    ("CommissionEarned" in fare?fare.CommissionEarned:0)-
    ("IncentiveEarned" in fare?fare.IncentiveEarned:0)+
    ("TdsOnPLB" in fare?fare.TdsOnPLB:0)+
    ("TdsOnCommission" in fare?fare.TdsOnCommission:0)+
    ("TdsOnIncentive" in fare?fare.TdsOnIncentive:0)+
    ("GST" in fare?fare.GST:0)
  return Math.round(x)
}

const getduration=(segment)=>{
  if(searchData.type=="Multi-stop"){
    return ""
  }else{
  var x=getSumByKey2(segment, "Duration")
  if(segment.length>1){
    for(let i=1;i<segment.length;i++){
      const temp=Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
      x+=temp
    }
  }
 
  return " || Total Duration: "+Math.floor(x/60)+"hrs "+Math.floor(x%60)+"mins"
}
}

const getduration2=(segment)=>{
  if(searchData.type=="Multi-stop"){
    return ""
  }else{
  var x=getSumByKey2(segment, "Duration")
  if(segment.length>1){
    for(let i=1;i<segment.length;i++){
      const temp=Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
      x+=temp
    }
  }
 
  return x
}
}

const getstopover=(segment)=>{
  var x=0
 if(segment.length<2){
  return x
 }else{
  for(let i=1;i<segment.length;i++){
    // if("GroundTime" in segment[i] && segment[i].GroundTime>0){
    //   x=x+segment[i].GroundTime
    // }else{
      if(segment[i-1]){
        x=x+Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
      }
      
    
    }
  return x
 }
  
}

const handleChange = (event, newValue) => {
  setValue(newValue);
  
};

const checkairline = (segments, value) => {
  let x=0
  for(let i=0;i<segments.length;i++){
    for(let j=0;j<segments[i].length;j++){
      if(segments[i][j].Airline.AirlineCode==getairlinecode(value)){
        x= 1
        
      }
    }
  }
  return x
}

const checkbaggage = (segments, value) => {
  let x=""
  for(let i=0;i<segments.length;i++){
    for(let j=0;j<segments[i].length;j++){
      if(segments[i][j].Baggage=="15 kgs" || segments[i][j].Baggage=="20 KG" || segments[i][j].Baggage=="1 Piece(s)" || segments[i][j].Baggage=="15 KG" || segments[i][j].Baggage=="1 PC(s)"){
        x= "1"
        break;
      }
      if(segments[i][j].Baggage=="30 KG" || segments[i][j].Baggage=="40 KG"){
        x= "2"
        break;
      }
      if(segments[i][j].Baggage=="45 kgs" || segments[i][j].Baggage=="60 KG"){
        x= "3"
        break;
      }
    }
  }
  return x
}

const filterresults=() => {
 var newData=[]
 var ftype=0
 if(searchData.type=="One-Way"){
  ftype=1
 }else if(searchData.type=="Return"){
  if(searchResponse.Results.length>1){
    ftype=3
  }else{
    ftype=2
  }
 }else if(searchData.type=="Multi-stop"){
  ftype=4
 }else if(searchData.type=="Special Return"){
  ftype=5
 }else{
  ftype=6
 }
 //console.log(ftype)

  if(filterData.airline) {
     //console.log(getairlinecode(filterData.airline))
    newData[0]=saveresults.Response.Results[0].filter(r=>checkairline(r.Segments, filterData.airline))
    if(saveresults.Response.Results.length>1){
      newData[1]=saveresults.Response.Results[1].filter(r=>checkairline(r.Segments, filterData.airline))
    }
  }else{
    newData=[...saveresults.Response.Results]
  }
  if(filterData.departure && filterData.departure !=="All-Day") {
    if(filterData.departure =="00-08"){
      // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
    newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()<8)
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()<8)
    }
  }
  if(filterData.departure =="08-14"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=8 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<14)
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=8 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<14)
  }
}
if(filterData.departure =="14-19"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
}
}
if(filterData.departure =="19-23"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
}
}
  }
  if(ftype==2){
    if(filterData.arrival && filterData.arrival !=="All-Day") {
      if(filterData.arrival =="00-08"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
      newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<8)
    }
    if(filterData.arrival =="08-14"){
      // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
    newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<14)
  }
  if(filterData.arrival =="14-19"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<19)
  }
  if(filterData.arrival =="19-23"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[0][r.Segments[0].length-1].Destination.ArrTime).getHours()<24)
  
  }
    }
  }else{
    if(filterData.arrival && filterData.arrival !=="All-Day") {
      if(filterData.arrival =="00-08"){
        // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
      newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<8)
      if(saveresults.Response.Results.length>1){
        newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<8)
      }
    }
    if(filterData.arrival =="08-14"){
      // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
    newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<14)
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<14)
    }
  }
  if(filterData.arrival =="14-19"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<19)
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<19)
  }
  }
  if(filterData.arrival =="19-23"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<24)
  if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<24)
  }
  }
    }
  }
  
  
  if(filterData.duration) {
    if(filterData.duration =="0-4 hrs"){
      //console.log(getduration2(newData[0][0].Segments[0]))
    newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])<240)
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])<240)
    }
  }
  if(filterData.duration =="4-8 hrs"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=240 && getduration2(r.Segments[0])<480)
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=240 && getduration2(r.Segments[0])<480)
  }
}
if(filterData.duration =="8-12 hrs"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=480 && getduration2(r.Segments[0])<720)
if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=480 && getduration2(r.Segments[0])<720)
}
}
if(filterData.duration =="12-16 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=720 && getduration2(r.Segments[0])<960)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=720 && getduration2(r.Segments[0])<960)
}
}
if(filterData.duration =="16-20 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=960 && getduration2(r.Segments[0])<1200)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=960 && getduration2(r.Segments[0])<1200)
}
}
if(filterData.duration =="20-24 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=1200 && getduration2(r.Segments[0])<1440)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=1200 && getduration2(r.Segments[0])<1440)
}
}
if(filterData.duration =="24+ hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getduration2(r.Segments[0])>=1440)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getduration2(r.Segments[0])>=1440)
}
}
  }
  if(filterData.stops) {
    if(filterData.stops =="0"){
      //console.log(getduration2(newData[0][0].Segments[0]))
    newData[0]=newData[0].filter(r=>r.Segments[0].length==1)
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>r.Segments[0].length==1)
    }
  }
  if(filterData.stops =="1"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
    newData[0]=newData[0].filter(r=>r.Segments[0].length==2)
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>r.Segments[0].length==2)
  }
}
if(filterData.stops =="2"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments[0].length==3)
if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>r.Segments[0].length==3)
}
}
if(filterData.stops =="3"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments[0].length==4)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>r.Segments[0].length==4)
}
}
  }
  if(filterData.baggage) {
    if(filterData.baggage =="0"){
      console.log(checkbaggage(newData[0][0].Segments,filterData.baggage))
    newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
    }
  }
  if(filterData.baggage =="1"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
    newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
  }
}
if(filterData.baggage =="2"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
}
}
if(filterData.baggage =="3"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>checkbaggage(r.Segments,filterData.baggage)==filterData.baggage)
}
}
  }
  if(filterData.multi) {
    if(filterData.multi =="Yes"){
      //console.log(getduration2(newData[0][0].Segments[0]))
    newData[0]=newData[0].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName || r.Segments[0][0].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName || r.Segments[0][1].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName  )))
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName !== r.Segments[0][1].Airline.AirlineName || r.Segments[0][0].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName || r.Segments[0][1].Airline.AirlineName !== r.Segments[0][2].Airline.AirlineName  )))
    }
  }
  if(filterData.multi =="No"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
    newData[0]=newData[0].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName && r.Segments[0][0].Airline.AirlineName == r.Segments[0][2].Airline.AirlineName )))
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>(r.Segments[0].length==2 && r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName) || (r.Segments[0].length==3 && (r.Segments[0][0].Airline.AirlineName == r.Segments[0][1].Airline.AirlineName && r.Segments[0][0].Airline.AirlineName == r.Segments[0][2].Airline.AirlineName )))
  }
}
if(filterData.stops =="2"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<19)
}
}
if(filterData.stops =="3"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>new Date(r.Segments[0][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[0][0].Origin.DepTime).getHours()<24)
}
}
  }
  if(filterData.stopover) {
    if(filterData.stopover =="0-4 hrs"){
      console.log(getstopover(newData[0][0].Segments[0]))
    newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])<240)
    if(saveresults.Response.Results.length>1){
      newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])<240)
    }
  }
  if(filterData.stopover =="4-8 hrs"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=240 && getstopover(r.Segments[0])<480)
  if(saveresults.Response.Results.length>1){
    newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=240 && getstopover(r.Segments[0])<480)
  }
}
if(filterData.stopover =="8-12 hrs"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=480 && getstopover(r.Segments[0])<720)
if(saveresults.Response.Results.length>1){
  newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=480 && getstopover(r.Segments[0])<720)
}
}
if(filterData.stopover =="12-16 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=720 && getstopover(r.Segments[0])<960)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=720 && getstopover(r.Segments[0])<960)
}
}
if(filterData.stopover =="16-20 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=960 && getstopover(r.Segments[0])<1200)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=960 && getstopover(r.Segments[0])<1200)
}
}
if(filterData.stopover =="20-24 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=1200 && getstopover(r.Segments[0])<1440)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=1200 && getstopover(r.Segments[0])<1440)
}
}
if(filterData.stopover =="24+ hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>getstopover(r.Segments[0])>=1440)
if(saveresults.Response.Results.length>1){
newData[1]=newData[1].filter(r=>getstopover(r.Segments[0])>=1440)
}
}
}
//----------------------------------------return flight search------------------------------
if(ftype=2){
 
 if(filterData2.departure && filterData2.departure !=="All-Day") {
   if(filterData2.departure =="00-08"){
     // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
   newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<8)
   
 }
 if(filterData2.departure =="08-14"){
   // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
 newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()>=8 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<14)
 
}
if(filterData2.departure =="14-19"){
 // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()>=14 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<19)

}
if(filterData2.departure =="19-23"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[1][0].Origin.DepTime).getHours()>=19 && new Date(r.Segments[1][0].Origin.DepTime).getHours()<24)
}
 }

 if(filterData2.arrival && filterData2.arrival !=="All-Day") {
  if(filterData2.arrival =="00-08"){
    // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
  newData[0]=newData[0].filter(r=>new Date(r.Segments.length>1 && r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<8)
}
if(filterData2.arrival =="08-14"){
  // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=8 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<14)

}
if(filterData2.arrival =="14-19"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=14 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<19)

}
if(filterData2.arrival =="19-23"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()>=19 && new Date(r.Segments[r.Segments.length-1][r.Segments[r.Segments.length-1].length-1].Destination.ArrTime).getHours()<24)

}
}

 if(filterData2.duration) {
   if(filterData2.duration =="0-4 hrs"){
     //console.log(getduration2(newData[0][0].Segments[0]))
   newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])<240)
   
 }
 if(filterData2.duration =="4-8 hrs"){
   // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
 newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=240 && getduration2(r.Segments[1])<480)
 
}
if(filterData2.duration =="8-12 hrs"){
 // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=480 && getduration2(r.Segments[1])<720)

}
if(filterData2.duration =="12-16 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=720 && getduration2(r.Segments[1])<960)

}
if(filterData2.duration =="16-20 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=960 && getduration2(r.Segments[1])<1200)

}
if(filterData2.duration =="20-24 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=1200 && getduration2(r.Segments[1])<1440)

}
if(filterData2.duration =="24+ hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getduration2(r.Segments[1])>=1440)

}
 }


 if(filterData2.stops) {
   if(filterData2.stops =="0"){
     //console.log(getduration2(newData[0][0].Segments[0]))
   newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==1)
   
 }
 if(filterData2.stops =="1"){
   // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
   newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==2)
 
}
if(filterData2.stops =="2"){
 // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==3)

}
if(filterData2.stops =="3"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && r.Segments[1].length==4)

}
 }


 if(filterData2.baggage) {
   if(filterData2.baggage =="0"){
     //console.log(checkbaggage(newData[0][0].Segments,filterData.baggage))
   newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)
   
 }
 if(filterData2.baggage =="1"){
   // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
   newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)
 
}
if(filterData2.baggage =="2"){
 // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)

}
if(filterData2.baggage =="3"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>checkbaggage(r.Segments,filterData2.baggage)==filterData2.baggage)

}
 }


 if(filterData2.stopover) {
   if(filterData2.stopover =="0-4 hrs"){
     //console.log(getstopover(newData[0][0].Segments[1]))
   newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])<240)
 }
 if(filterData2.stopover =="4-8 hrs"){
   // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
 newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=240 && getstopover(r.Segments[1])<480)

}
if(filterData2.stopover =="8-12 hrs"){
 // console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=480 && getstopover(r.Segments[1])<720)

}
if(filterData2.stopover =="12-16 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=720 && getstopover(r.Segments[1])<960)

}
if(filterData2.stopover =="16-20 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=960 && getstopover(r.Segments[1])<1200)

}
if(filterData2.stopover =="20-24 hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=1200 && getstopover(r.Segments[1])<1440)

}
if(filterData2.stopover =="24+ hrs"){
// console.log(new Date(saveresults.Response.Results[0][0].Segments[0][0].Origin.DepTime).getHours())
newData[0]=newData[0].filter(r=>r.Segments.length>1 && getstopover(r.Segments[1])>=1440)

}
}
}



  

  setsearchResponse({...saveresults.Response, Results:newData})
  
}

const newtcfilterresults=() => {
  var temp=[...searchResponse2.results.outboundFlights]
  console.log(filterData2)
  if("results" in searchResponse && "outboundFlights" in searchResponse.results && "inboundFlights" in searchResponse.results.outboundFlights[0]){
    console.log("Return")
    if(inbound && inboundindex){
      var temp2=temp[inboundindex-1].inboundFlights
      if(filterData2.stops){
        temp2=temp2.filter(data=>data[0].sg.length-1==filterData2.stops)
      }
      if(filterData2.departure  && filterData2.departure !=="All-Day"){
        if(filterData2.departure =="00-08"){
          temp2=temp2.filter(data=>new Date(data[0].sg[0].or.dT).getHours()<8)
        }
        
        if(filterData2.departure =="08-14"){
          temp2=temp2.filter(data=>new Date(data[0].sg[0].or.dT).getHours()>=8 && new Date(data[0].sg[0].or.dT).getHours()< 14)
        }
        if(filterData2.departure =="14-19"){
          temp2=temp2.filter(data=>new Date(data[0].sg[0].or.dT).getHours()>=14 && new Date(data[0].sg[0].or.dT).getHours()< 19)
        }
        if(filterData2.departure =="19-23"){
          temp2=temp2.filter(data=>new Date(data[0].sg[0].or.dT).getHours()>=19 && new Date(data[0].sg[0].or.dT).getHours()< 24)
        }
      }
      if(filterData2.arrival){
        if(filterData2.arrival =="00-08"){
          temp2=temp2.filter(data=>new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()<8)
        }
        
        if(filterData2.arrival =="08-14"){
          temp2=temp2.filter(data=>new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()>=8 && new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()< 14)
        }
        if(filterData2.arrival =="14-19"){
          temp2=temp2.filter(data=>new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()>=14 && new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()< 19)
        }
        if(filterData2.arrival =="19-23"){
          temp2=temp2.filter(data=>new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()>=19 && new Date(data[0].sg[data[0].sg.length-1].ds.aT).getHours()< 24)
        }
      }
      if(filterData2.baggage){
        if(filterData2.baggage==0){
          temp = temp.filter(item =>
            item[0].sg.every(subItem => subItem.bg === ""))
        }
        if(filterData2.baggage==1){
          temp = temp.filter(item =>
            item[0].sg.every(subItem => subItem.bg.startsWith("15") || subItem.bg.startsWith("20") || subItem.bg.startsWith("25")))
        }
        if(filterData2.baggage==2){
          temp = temp.filter(item =>
            item[0].sg.every(subItem => subItem.bg.startsWith("30")))
        }
        if(filterData2.baggage==3){
          
        }
      }
      if(filterData2.duration){
        if(filterData2.duration =="0-4 hrs"){
        temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))<4)
        }
        if(filterData2.duration =="4-8 hrs"){
          temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))>=4 && ((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))<8)
        }
        if(filterData2.duration =="8-12 hrs"){
          temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))>=8 && ((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))<12)
        }
        if(filterData2.duration =="12-16 hrs"){
          temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))>=12 && ((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))<16)
        }
        if(filterData2.duration =="16-20 hrs"){
          temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))>=16 && ((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))<20)
        }
        if(filterData2.duration =="20-24 hrs"){
          temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))>=20 && ((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))<24)
        }
        if(filterData2.duration =="24+ hrs"){
          temp=temp.filter(data=>((new Date(data[0].sg[data[0].sg.length-1].ds.aT).getTime()-new Date(data[0].sg[0].or.dT).getTime())/(1000*60*60))>24)
        }
      }
      if(filterData2.airline){
        temp = temp.filter(item =>
          item[0].sg.every(subItem => subItem.al.alN.trim().replace(/\s+/g, ' ').toLowerCase() === filterData2.airline.trim().replace(/\s+/g, ' ').toLowerCase())
        );
      }
      var temp3={...temp[inboundindex-1],inboundFlights:temp2}
      temp[inboundindex-1]=temp3
      setsearchResponse({...searchResponse, results:{outboundFlights:temp}})
    }else{
    if(filterData2.stops){
      temp=temp.filter(data=>data.outboundFlight.length-1==filterData2.stops)
    }
    if(filterData2.departure  && filterData2.departure !=="All-Day"){
      if(filterData2.departure =="00-08"){
        temp=temp.filter(data=>new Date(data.outboundFlight[0].or.dT).getHours()<8)
      }
      
      if(filterData2.departure =="08-14"){
        temp=temp.filter(data=>new Date(data.outboundFlight[0].or.dT).getHours()>=8 && new Date(data.outboundFlight[0].or.dT).getHours()< 14)
      }
      if(filterData2.departure =="14-19"){
        temp=temp.filter(data=>new Date(data.outboundFlight[0].or.dT).getHours()>=14 && new Date(data.outboundFlight[0].or.dT).getHours()< 19)
      }
      if(filterData2.departure =="19-23"){
        temp=temp.filter(data=>new Date(data.outboundFlight[0].or.dT).getHours()>=19 && new Date(data.outboundFlight[0].or.dT).getHours()< 24)
      }
    }
    if(filterData2.arrival){
      if(filterData2.arrival =="00-08"){
        temp=temp.filter(data=>new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()<8)
      }
      
      if(filterData2.arrival =="08-14"){
        temp=temp.filter(data=>new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()>=8 && new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()< 14)
      }
      if(filterData2.arrival =="14-19"){
        temp=temp.filter(data=>new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()>=14 && new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()< 19)
      }
      if(filterData2.arrival =="19-23"){
        temp=temp.filter(data=>new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()>=19 && new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getHours()< 24)
      }
    }
    if(filterData2.baggage){
      if(filterData2.baggage==0){
        temp = temp.filter(item =>
          item.outboundFlight.every(subItem => subItem.bg === ""))
      }
      if(filterData2.baggage==1){
        temp = temp.filter(item =>
          item.outboundFlight.every(subItem => subItem.bg.startsWith("15") || subItem.bg.startsWith("20") || subItem.bg.startsWith("25")))
      }
      if(filterData2.baggage==2){
        temp = temp.filter(item =>
          item.outboundFlight.every(subItem => subItem.bg.startsWith("30")))
      }
      if(filterData2.baggage==3){
        
      }
    }
    if(filterData2.duration){
      if(filterData2.duration =="0-4 hrs"){
      temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))<4)
      }
      if(filterData2.duration =="4-8 hrs"){
        temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))>=4 && ((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))<8)
      }
      if(filterData2.duration =="8-12 hrs"){
        temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))>=8 && ((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))<12)
      }
      if(filterData2.duration =="12-16 hrs"){
        temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))>=12 && ((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))<16)
      }
      if(filterData2.duration =="16-20 hrs"){
        temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))>=16 && ((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))<20)
      }
      if(filterData2.duration =="20-24 hrs"){
        temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))>=20 && ((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))<24)
      }
      if(filterData2.duration =="24+ hrs"){
        temp=temp.filter(data=>((new Date(data.outboundFlight[data.outboundFlight.length-1].ds.aT).getTime()-new Date(data.outboundFlight[0].or.dT).getTime())/(1000*60*60))>24)
      }
    }
    if(filterData2.airline){
      temp = temp.filter(item =>
        item.outboundFlight.every(subItem => subItem.al.alN.trim().replace(/\s+/g, ' ').toLowerCase() === filterData2.airline.trim().replace(/\s+/g, ' ').toLowerCase())
      );
    }
    setsearchResponse({...searchResponse, results:{outboundFlights:temp}})
  }
  }else{
 
  console.log(temp)
  if(filterData2.departure  && filterData2.departure !=="All-Day"){
    if(filterData2.departure =="00-08"){
      temp=temp.filter(data=>new Date(data.sg[0].or.dT).getHours()<8)
    }
    
    if(filterData2.departure =="08-14"){
      temp=temp.filter(data=>new Date(data.sg[0].or.dT).getHours()>=8 && new Date(data.sg[0].or.dT).getHours()< 14)
    }
    if(filterData2.departure =="14-19"){
      temp=temp.filter(data=>new Date(data.sg[0].or.dT).getHours()>=14 && new Date(data.sg[0].or.dT).getHours()< 19)
    }
    if(filterData2.departure =="19-23"){
      temp=temp.filter(data=>new Date(data.sg[0].or.dT).getHours()>=19 && new Date(data.sg[0].or.dT).getHours()< 24)
    }
  }

  if(filterData2.arrival){
    if(filterData2.arrival =="00-08"){
      temp=temp.filter(data=>new Date(data.sg[data.sg.length-1].ds.aT).getHours()<8)
    }
    
    if(filterData2.arrival =="08-14"){
      temp=temp.filter(data=>new Date(data.sg[data.sg.length-1].ds.aT).getHours()>=8 && new Date(data.sg[data.sg.length-1].ds.aT).getHours()< 14)
    }
    if(filterData2.arrival =="14-19"){
      temp=temp.filter(data=>new Date(data.sg[data.sg.length-1].ds.aT).getHours()>=14 && new Date(data.sg[data.sg.length-1].ds.aT).getHours()< 19)
    }
    if(filterData2.arrival =="19-23"){
      temp=temp.filter(data=>new Date(data.sg[data.sg.length-1].ds.aT).getHours()>=19 && new Date(data.sg[data.sg.length-1].ds.aT).getHours()< 24)
    }
  }
  if(filterData2.stops){
    temp=temp.filter(data=>data.sg.length-1==filterData2.stops)
  }
  if(filterData2.baggage){
    if(filterData2.baggage==0){
      temp = temp.filter(item =>
        item.sg.every(subItem => subItem.bg === ""))
    }
    if(filterData2.baggage==1){
      temp = temp.filter(item =>
        item.sg.every(subItem => subItem.bg.startsWith("15") || subItem.bg.startsWith("20") || subItem.bg.startsWith("25")))
    }
    if(filterData2.baggage==2){
      temp = temp.filter(item =>
        item.sg.every(subItem => subItem.bg.startsWith("30")))
    }
    if(filterData2.baggage==3){
      
    }
  }
  if(filterData2.duration){
    if(filterData2.duration =="0-4 hrs"){
    temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))<4)
    }
    if(filterData2.duration =="4-8 hrs"){
      temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))>=4 && ((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))<8)
    }
    if(filterData2.duration =="8-12 hrs"){
      temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))>=8 && ((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))<12)
    }
    if(filterData2.duration =="12-16 hrs"){
      temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))>=12 && ((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))<16)
    }
    if(filterData2.duration =="16-20 hrs"){
      temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))>=16 && ((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))<20)
    }
    if(filterData2.duration =="20-24 hrs"){
      temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))>=20 && ((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))<24)
    }
    if(filterData2.duration =="24+ hrs"){
      temp=temp.filter(data=>((new Date(data.sg[data.sg.length-1].ds.aT).getTime()-new Date(data.sg[0].or.dT).getTime())/(1000*60*60))>24)
    }
  }
  if(filterData2.airline){
    temp = temp.filter(item =>
      item.sg.every(subItem => subItem.al.alN.trim().replace(/\s+/g, ' ').toLowerCase() === filterData2.airline.trim().replace(/\s+/g, ' ').toLowerCase())
    );
  }
  

   
  console.log(temp)
  setsearchResponse({...searchResponse, results:{outboundFlights:temp}})
}
   
 }

const handleSubmit2 =async (e) => {
  e.preventDefault();
  if(searchData.number_adults+searchData.number_child+searchData.number_infant>9){
    alert("Total passengers cannot be more than 9")
  }else{
  setstatus("searching");
  var segment=[]
  //console.log(airportdata);
  for(let i=0; i<airportdata.length; i++){
    const s=airportlist.filter(a=>a.city==airportdata[i].source)
    const d=airportlist.filter(a=>a.city==airportdata[i].dest)
    const temp={
      "Origin":s.length>0?s[0].airport:"",
      "Destination":d.length>0?d[0].airport:"",
      "FlightCabinClass":airportdata[i].cabin_class=="All"?1:airportdata[i].cabin_class=="Economy"?2:airportdata[i].cabin_class=="Premium Economy"?3:airportdata[i].cabin_class=="Business"?4:airportdata[i].cabin_class=="Premium Busines"?5:airportdata[i].cabin_class=="First"?6:0,
      "PreferredDepartureTime":getdate(airportdata[i].date,airportdata[i].departure_time),
      "PreferredArrivalTime":getdate(airportdata[i].date,airportdata[i].arrival_time)
    }
    segment.push(temp)
  }

  const finalsearchData={
    "TokenId":token,
    "AdultCount":searchData.number_adults,
    "ChildCount":searchData.number_child,
    "InfantCount":searchData.number_infant,
    "DirectFlight":searchData.stops==0?1:0,
    "OneStopFlight":searchData.stops==1?1:0,
    "JourneyType":searchData.type=="One-way" ? 1: searchData.type=="Return"?2: searchData.type=="Multi-stop"?3: searchData.type=="Special Return"?5:searchData.type=="Advanced Search"?4:0,
    "PreferredAirlines": null,
    "Sources": searchData.type=="Special Return"?["4","5"]:null,
    "Segments":segment
  }

  console.log(finalsearchData)
  const sfResponse= await fetchflights(finalsearchData);
  
  if(sfResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
    
      console.log(sfResponse.data.Response)
      setsaveresults(sfResponse.data)
      setsearchResponse(sfResponse.data.Response)
      setstatus("completed")
  }
  else{
      alert("Something went wrong. Contact support");
      window.location = ("/home");
  }
}
}

const TCFlightSearch =async (e) => {
  e.preventDefault();
  if(searchData.number_adults+searchData.number_child+searchData.number_infant>9){
    alert("Total passengers cannot be more than 9")
  }else{
  setstatus("searching");
  //var segment=[]
  console.log(airportdata);
  const s=airportlist.filter(a=>a.city==airportdata[0].source)
  const d=airportlist.filter(a=>a.city==airportdata[0].dest)
 

const finalsearchData={
  data:{
    adultCount:searchData.number_adults,
    childCount :searchData.number_child,
    infantCount:searchData.number_infant,
    directFlight:searchData.stops==0?true:false,
    flightCabinClass: "1",
    journeyType:searchData.type=="One-way" ? 1: searchData.type=="Return"?2: searchData.type=="Multi-stop"?3: searchData.type=="Special Return"?5:searchData.type=="Advanced Search"?4:0,
    origin:s.length>0?s[0].airport:"",
    destination:d.length>0?d[0].airport:"",
    // "preferredDepartureTime": "2024-11-01T00:00:00",
    // "preferredReturnDepartureTime": "2024-11-08T00:00:00",
    preferredDepartureTime: airportdata.length>0?new Date(DateCalc2(airportdata[0].date,0)):new Date(),
    preferredReturnDepartureTime: airportdata.length>1?new Date(DateCalc2(airportdata[1].date,0)):new Date(),
  },
  token:token
}

  console.log(finalsearchData)
  const sfResponse= await searchTCflight(finalsearchData);
  
  if(sfResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
    
      console.log(sfResponse.data.response)
      setsaveresults(sfResponse.data)
      setsearchResponse(sfResponse.data.response)
      setsearchResponse2(sfResponse.data.response)
      setstatus("completed")
  }
  else{
      alert("Something went wrong. Contact support");
      window.location = ("/home");
  }
}
}

//console.log(searchResponse)
//console.log(new Date(searchResponse.results.outboundFlights[0].sg[0].or.dT).getTime())

const prebook=()=>{
  let temp=[...cost]
  let flag=0
  if(searchData.type=="Return" && searchResponse.Results.length>1 && resultpass.length!==2){
    alert("Select two flights one for onward and one for return")
  }else{
    setOpen4(false);
    const temp3="tbo_flight" in quoteData? quoteData.tbo_flight:[]
    const temp2=[...temp3, ...resultpass]
    setquoteData({...quoteData, tbo_flight:temp2})
    let sum=0
    for(let i=0; i<temp2.length; i++){
      sum=sum+getprice(temp2[i].Fare)
    }
    for(let i=0;i<temp.length;i++){
      if(temp[i].name=="Flight"){
        temp[i]={
          name:"Flight",
          rate:sum,
          type:"API-Flight",
          inventory:"Flight",
        }
        flag=1
      }
    }
    if(flag==0){
      const temp2={
          name:"Flight",
          rate:sum,
          type:"API-Flight",
          inventory:"Flight",
      }
      temp.push(temp2)
    }
    setcost(temp)
    settotalflightcost(sum)
  }
}

const TCprebook=()=>{
  let temp=[...cost]
  let flag=0
  if(searchData.type=="Return" && tcresultpass.length!==2){
    alert("Select two flights one for onward and one for return")
  }else{
    setOpen14(false);
    const temp3="travclan_flight" in quoteData? quoteData.travclan_flight:[]
    const temp2=[...temp3, ...tcresultpass]
    setquoteData({...quoteData, travclan_flight:temp2})
    let sum=0
    for(let i=0; i<temp2.length; i++){
      sum=sum+temp2[i].fF
      console.log(sum)
    }
    for(let i=0;i<temp.length;i++){
      if(temp[i].name=="Flight"){
        temp[i]={
          name:"Flight",
          rate:sum,
          type:"API-Flight",
          inventory:"Flight",
        }
        flag=1
      }
    }
    if(flag==0){
      const temp2={
          name:"Flight",
          rate:sum,
          type:"API-Flight",
          inventory:"Flight",
      }
      temp.push(temp2)
    }
    setcost(temp)
    settotalflightcost(sum)
  }
}

const farerule=async(result)=>{
  if(searchData.type=="Return" && searchResponse.Results.length>1){
    var temp=resultpass.length>0?[...resultpass]:[]
      if(result.ResultIndex.startsWith("OB")){    
            temp[0]=result
      }else if(result.ResultIndex.startsWith("IB")){
        if(temp.length==0){
          temp[0]=null              
          temp[1]=result
        } else{
          temp[1]=result
        } 
      }
    setresultpass(temp)
   
  }else{
  setresultpass([result])

  }
}

const TCfarerule=async(result, resulttype)=>{
  if(searchData.type=="Return" && "inboundFlights" in searchResponse.results && searchResponse.results.inboundFlights.length>0){
    var temp=tcresultpass.length>0?[...tcresultpass]:[]
      if(resulttype=="OB"){    
            temp[0]=result
      }else if(resulttype=="IB"){
        if(temp.length==0){
          temp[0]=null              
          temp[1]=result
        } else{
          temp[1]=result
        } 
      }
      console.log(temp)
    settcresultpass(temp)
   
  }else{
  settcresultpass([result])

  }
}

const TCfarerule2=async(result, result2)=>{
    console.log(result)
    console.log(result2)
    var temp=[]
     const newresult={
        aR: result.ar, 
        bF:result.bF, 
        cr: result.cr,
        db: result.db,
        fF: 0,
        fFWAM: result.fFWAM,
        fareIdentifier:result.fareIdentifier,
        groupId:result.groupId,
        iL:result.iL,
        iR: result.iR,
        pF: result.pF,
        pFC: result.pFC,
        pr: result.pr,
        rI: result.rI,
        sA: result.sA,
        sC: result.sC,
        sF: result.sF,
        tAS:result.tAS,
        sg:result.outboundFlight,
        
     }
      temp=[...temp, newresult, result2]
      console.log(temp)
    settcresultpass(temp)
}
//console.log(tcresultpass)

const addvisa=()=>{
  //console.log(cost)
  let arr=[...cost]
  let sum=0
  let sum2=0
  for(let i=0;i<quotevisaData.length;i++){
    let y=0
    sum=sum+quotevisaData[i].cp*quotevisaData[i].number+quotevisaData[i].extra
    sum2=sum2+quotevisaData[i].sp*quotevisaData[i].number+quotevisaData[i].extra
    for(let j=0;j<cost.length;j++){
      if(cost[j].name==quotevisaData[i].name){
        //console.log(cost[j])
        y=1
        const temp2={
          name:cost[j].name,
          rate:quotevisaData[i].cp*quotevisaData[i].number+quotevisaData[i].extra,
          type:"CRM-Visa",
          inventory:"Visa",
          sp:quotevisaData[i].sp*quotevisaData[i].number+quotevisaData[i].extra,
          currency:"INR",
        }
        arr=arr.map(c=>c.name==quotevisaData[i].name?temp2:c)
      }
    }
    if(y==0){
      //console.log("ABC")
      const temp2={
        name:quotevisaData[i].name,
        rate:quotevisaData[i].cp*quotevisaData[i].number+quotevisaData[i].extra,
        type:"CRM-Visa",
        sp:quotevisaData[i].sp*quotevisaData[i].number+quotevisaData[i].extra,
        currency:"INR",
        inventory:"Visa",
      }
      arr=[...arr, temp2]
    } 
  }
setcost(arr)
//console.log(sum, sum2)
settotalvisacost(sum)
settotalvisasales(sum2)
setOpen8(false)
}

const visachange=(tid, value, visa)=>{
  //alert(value)
  //alert(maxpass)
  if(value!==maxpass.length){
    alert("Number of Visa selected is not equal to number of passengers mentioned. Please recheck")
  }
  if(quotevisaData.length==0){
    const temp={
      name:visa.name,
      cp:visa.cp,
      sp:visa.sp,
      number:value,
      extra:visa.extra
    }
   
    setquotevisaData([temp]) 
    //
  }else{
    let visarr=[...quotevisaData]
    let x=0
    for(let i=0;i<visarr.length;i++){
      if(visarr[i].name==visa.name){
        visarr[i].number=value
        x=1
      }
    }
    if(x==0){
      const temp={
        name:visa.name,
        cp:visa.cp,
        sp:visa.sp,
        number:value,
        extra:visa.extra
      }
      // const temp2={
      //   name:visa.name,
      //   rate:visa.cp*value,
      //   type:"CRM"
      // }
      visarr=[...visarr, temp]
      //setcost([...cost, temp2])
    }
    setquotevisaData(visarr)
  }
}

const getprofitrange=(totalcost,totalflightcost, totalvisasales, number)=>{
  return Math.round((totalcost+totalcost*number/100)+(totalflightcost?totalflightcost*1.02:0)+(totalvisasales?totalvisasales:0))
}

const getvaluerange=(totalcost,totalflightcost, totalvisasales, number)=>{
  return Math.round((totalcost)+(totalflightcost?totalflightcost*1.02:0)+(totalvisasales?totalvisasales:0)+number*(tripData.number_adults+tripData.number_child))
}

const usevalueprice=async(number, number2)=>{
  setpriceadd(true)
  if(number2){
    var temp3=totalflightcost?totalflightcost+number2:0
    var temp4=totalvisasales?totalvisasales:0
    var temp6=((totalcost+number*(tripData.number_adults+tripData.number_child))/tripData.number_adults)*1.05
    //console.log(temp3, temp4, temp6)
    var pp=Math.round(((temp3+temp4)/(tripData.number_adults+tripData.number_child))+temp6)
    var pcwb=tripData.number_child>0?Math.round(((temp3)+(temp4))/(tripData.number_adults+tripData.number_child)):0
    var pcnb=tripData.number_child>0?Math.round(((temp3)+(temp4))/(tripData.number_adults+tripData.number_child)):0
    setprice({...price,airfare:(totalflightcost?Math.round(totalflightcost+number2):0), landprice:(totalcost+number*(tripData.number_adults+tripData.number_child)), otheritems:(totalvisasales?totalvisasales:0),perperson:pp, percwb:pcwb, percnb:pcnb})
  }else{
    var temp1=totalflightcost?totalflightcost*1.02:0
    var temp2=totalvisasales?totalvisasales:0
    var temp5=((totalcost+number*(tripData.number_adults+tripData.number_child))/tripData.number_adults)*1.05
    var pp2=Math.round(((temp1+temp2)/(tripData.number_adults+tripData.number_child))+temp5)
    //console.log(temp1, temp2, temp5)
    var pcwb2=tripData.number_child>0?Math.round(((temp1)+(temp2))/(tripData.number_adults+tripData.number_child)):0
    var pcnb2=tripData.number_child>0?Math.round(((temp1)+(temp2))/(tripData.number_adults+tripData.number_child)):0
    setprice({...price,airfare:(totalflightcost?Math.round(totalflightcost*1.02):0), landprice:(totalcost+number*(tripData.number_adults+tripData.number_child)), otheritems:(totalvisasales?totalvisasales:0),perperson:pp2, percwb:pcwb2, percnb:pcnb2})
  }
  
  setcostprice({...costprice, landprice:totalcost, airfare:totalflightcost && totalflightcost>0?totalflightcost:costprice.airfare, otheritems:totalvisacost && totalvisacost>0?totalvisacost:costprice.otheritems})
  // setprice({...price, landprice:totalcost, airfare:(totalflightcost?Math.round(totalflightcost+number2):0), otheritems:totalvisacost && totalvisacost>0?totalvisacost:costprice.otheritems})
  setdraweropen3(false)
  
}

const useperprice=async(number)=>{
  setpriceadd(true)
  var temp1=totalflightcost?totalflightcost*1.02:0
  var temp2=totalvisasales?totalvisasales:0
  var temp3=(totalcost+totalcost*number/100)*1.05
  var pp=Math.round(((temp1)+(temp2))/(tripData.number_adults+tripData.number_child)+(temp3/tripData.number_adults))
  var pcwb=tripData.number_child>0?Math.round(((temp1)+(temp2))/(tripData.number_adults+tripData.number_child)):0
  var pcnb=tripData.number_child>0?Math.round(((temp1)+(temp2))/(tripData.number_adults+tripData.number_child)):0
  setprice({...price,airfare:(totalflightcost?Math.round(totalflightcost*1.02):0), landprice:(totalcost+totalcost*number/100), otheritems:(totalvisasales?totalvisasales:0), perperson:pp, percwb:pcwb, percnb:pcnb})
  setcostprice({...costprice, landprice:totalcost, airfare:totalflightcost && totalflightcost>0?totalflightcost:costprice.airfare, otheritems:totalvisacost && totalvisacost>0?totalvisacost:costprice.otheritems})
  setdraweropen3(false)
 
}

const defaultdate = (index) => {
  //var d=new Date(daydata[0]?.date ? daydata[0].date : (tripData.trip_start_date===undefined ? "2021-01-01" : tripData.trip_start_date.split("T").slice(0,1)))
  // if (index > 0){
  var d = new Date(
    quoteData.trip_start_date === undefined
      ? "2021-01-01"
      : quoteData.trip_start_date.split("T").slice(0, 1)
  );
  d.setDate(d.getDate() + index);
  const fupy = d.getFullYear();
  const fupm =
    d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
  const fupdt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
  const dt = fupy + "-" + fupm + "-" + fupdt;
  return dt;
};

const manualentrycur = (name)=>{
  let rate=window.prompt("Enter rate (1 night only/room - NOT TOTAL - and in CURRENCY):")
  let source=window.prompt("Enter source of rate:")
  if(rate){
  let temp=[...cost]
  //console.log(temp)
  const currency2=identifycurr(quoteData.primary_destination)
  let sum=0
  var newsum=0
  var newsum2=0
  for(let i=0;i<temp.length;i++){
    var rate2=temp[i].inventory=="Hotel"?parseInt(rate)*numberofrooms:parseInt(rate)
    if(temp[i].name==name){
      temp[i]={
        inventory:temp[i].inventory,
        name:name,
        rate:rate2,
        type:"Manual-CUR",
        currency:"CUR",
        room_type:"room_type" in temp[i]?temp[i].room_type:"",
        source:source
      }
      sum=sum+parseInt(rate2)
    }else if(temp[i].currency=="CUR"){
      sum=sum+temp[i].rate
    }else if(temp[i].currency=="INR" && temp[i].type !=="CRM-Visa"){
      newsum2=newsum2+temp[i].rate
    } 
    // if(temp[i].type=="Total"){
    //   temp[i]={
    //     name:"Total (in currency)",
    //     rate:sum,
    //     type:"Total"
    //   }
     
    // }
    //console.log(sum)
  }
  for(let i=0;i<temp.length;i++){
    if(temp[i].type=="Total"){
      temp[i]={
        name:"Total (in currency)",
        rate:sum,
        type:"Total",
        inventory:"Total",
      }
     
    }
  }
 console.log(temp)
 sumcurrency(temp)
  // setcost(temp)
  // if(currency2==1){
  //   newsum=Math.round(sum*(oldcurrency.usd_inr+1.5))
  // }else if(currency2==2){
  //   newsum=Math.round(sum*(oldcurrency.sgd_inr+1.5))
  // }else if(currency2==3){
  //   newsum=Math.round(sum*(oldcurrency.thb_inr+0.2))
  // }else if(currency2==4){
  //   newsum=Math.round(sum*(oldcurrency.eur_inr+1.5))
  // }else{
  //   newsum=sum
  // }
  // console.log(newsum)
  // console.log(newsum2)
  // settotalcost(newsum+newsum2)
  checkallgood()
}
}

const manualentryinr = (name)=>{
  let rate=window.prompt("Enter rate (For Hotels- 1 night only/room - NOT TOTAL - and in INR):")
  let source=window.prompt("Enter source of rate:")
  //console.log(cost)
  if(rate && !isNaN(rate)){
  let temp=[...cost]
  const currency2=identifycurr(quoteData.primary_destination)
  let sum=0
  var newsum=0
  var newsum2=0
  for(let i=0;i<temp.length;i++){
    var rate2=temp[i].inventory=="Hotel"?parseInt(rate)*numberofrooms:parseInt(rate)
    if(temp[i].name==name){
      temp[i]={
        name:name,
        rate:rate2,
        type:"Manual-INR",
        currency:"INR",
        room_type:"room_type" in temp[i]?temp[i].room_type:"",
        source:source,
        inventory:temp[i].inventory,
      }
      sum=sum+parseInt(rate2)
    }else if(temp[i].currency=="CUR"){
      newsum=newsum+temp[i].rate
    }else if(temp[i].currency=="INR" && temp[i].type!=="CRM-Visa"){
      sum=sum+temp[i].rate
    }
    if(temp[i].type=="Total"){
      temp[i]={
        name:"Total (in currency)",
        rate:newsum,
        type:"Total",
        currency:"CUR",
        inventory:"Total",
      }
 
    }
  
  }
  console.log(temp)
  sumcurrency(temp)
  // setcost(temp)
  // if(currency2==1){
  //   newsum2=Math.round(newsum*(oldcurrency.usd_inr+1.5))
  // }else if(currency2==2){
  //   newsum2=Math.round(newsum*(oldcurrency.sgd_inr+1.5))
  // }else if(currency2==3){
  //   newsum2=Math.round(newsum*(oldcurrency.thb_inr+0.2))
  // }else if(currency2==4){
  //   newsum2=Math.round(newsum*(oldcurrency.eur_inr+1.5))
  // }else{
  //   newsum2=newsum
  // }
  // console.log(newsum2, sum)
  // if(multidest){
  //   settotalcost(newsum+sum)
  // }else{
  //   settotalcost(newsum2+sum)
  // }
  //settotalcost(newsum2+sum)
  checkallgood()
}
}

const manualentryflightinr = (name)=>{
  let rate=window.prompt("Enter total flight rate (including everything):")
  let temp=[...cost]
  let flag=0
  if(rate && !isNaN(rate)){
    for(let i=0;i<temp.length;i++){
      if(temp[i].name==name){
        temp[i]={
          name:name,
          rate:parseInt(rate),
          type:"Manual-Flight",
          inventory:"Flight",
        }
        flag=1
      }
    }
    if(flag==0){
      const temp2={
        name:name,
        rate:parseInt(rate),
        type:"Manual-Flight",
        inventory:"Flight",
      }
      temp.push(temp2)
    }
    setcost(temp)
    settotalflightcost(parseInt(rate))
    setcostprice({...costprice, airfare:rate})
    setprice({...price, airfare:rate})
    checkallgood()
}
}

const manualentryvisainr = (name)=>{
  let rate=window.prompt("Enter total cost value (including everything):")
  let rate2=window.prompt("Enter total sales value (including everything):")
  let temp=[...cost]
  let flag=0
  if(rate && !isNaN(rate) && rate2 && !isNaN(rate2)){
    for(let i=0;i<temp.length;i++){
      if(temp[i].name==name){
        let oldsales="sp" in temp[i]?temp[i].sp:0
        let oldcost=temp[i].rate
        console.log(oldsales)
        temp[i]={
          inventory:temp[i].inventory,
          name:name,
          rate:parseInt(rate),
          type:"Manual-Others",
          sp:rate2,
          
        }
        flag=1
        settotalvisacost(totalvisacost+parseInt(rate)-oldcost)
        settotalvisasales(totalvisasales+parseInt(rate2)-oldsales)
      }
    }
    if(flag==0){
      const temp2={
        inventory:"Visa",
        name:name,
        rate:parseInt(rate),
        type:"Manual-Others",
        sp:rate2
      }
      temp.push(temp2)
      settotalvisacost(totalvisacost+parseInt(rate))
      settotalvisasales(totalvisasales+parseInt(rate2))
    }
    setcost(temp)
   
    
    checkallgood()
}
}

const addinventorycur = ()=>{
  let name=window.prompt("Enter name of inventory:")
  let rate=window.prompt("Enter rate of inventory:")
  let source=window.prompt("Enter source of rate:")
  if(name && rate && !isNaN(rate)){
  let temp=[...cost]
  const currency2=identifycurr(quoteData.primary_destination)
  let sum=0
  var newsum=0
  var newsum2=0
  const temp2={
    name:name,
    rate:parseInt(rate),
    type:"Manual-CUR",
    currency:"CUR",
    source:source,
    inventory:name,
  }
  temp.push(temp2)
  for(let i=0;i<temp.length;i++){
    if(temp[i].type=="Total"){
      temp[i]={
        name:"Total (in currency)",
        rate:temp[i].rate+parseInt(rate),
        type:"Total",
        inventory:"Total",
      }
      break
    }
  }
  //console.log(temp)
  setcost(temp)
  if(currency2==1){
    newsum=Math.round(parseInt(rate)*(oldcurrency.usd_inr+1.5))
  }else if(currency2==2){
    newsum=Math.round(parseInt(rate)*(oldcurrency.sgd_inr+1.5))
  }else if(currency2==3){
    newsum=Math.round(parseInt(rate)*(oldcurrency.thb_inr+0.2))
  }else if(currency2==4){
    newsum=Math.round(parseInt(rate)*(oldcurrency.eur_inr+1.5))
  }else{
    newsum=totalcost
  }
  if("landprice" in costprice){
    setcostprice({...costprice, landprice:costprice.landprice+newsum})
  }else{
    setcostprice({...costprice, landprice:newsum})
  }
  settotalcost(totalcost+newsum)
  checkallgood()
}
}

const addinventoryinr = ()=>{
  let name=window.prompt("Enter name of inventory:")
  let rate=window.prompt("Enter rate of inventory:")
  let source=window.prompt("Enter source of rate:")
  //let category=window.prompt("Enter 1 for land:")
  if(name && rate && !isNaN(rate)){
  let temp=[...cost]

  let sum=0
  var newsum=0
  var newsum2=0
  const temp2={
    name:name,
    rate:parseInt(rate),
    type:"Manual-INR",
    currency:"INR",
    source:source,
    inventory:name,
  }
  temp.push(temp2)
  setcost(temp)
 
  // console.log(newsum2, sum)
  settotalcost(totalcost+parseInt(rate))
  if("landprice" in costprice){
    setcostprice({...costprice, landprice:costprice.landprice+parseInt(rate)})
  }else{
    setcostprice({...costprice, landprice:parseInt(rate)})
  }
  
  checkallgood()
}
}

const customprofit=async()=>{
  let rate=window.prompt("Enter per person land profit:")
  let rate2=window.prompt("Enter flight profit:")
  if(rate && rate2 && !isNaN(rate) && !isNaN(rate2)){
    usevalueprice(rate, parseInt(rate2))
  }
 
}

const customflightprofit=()=>{
  let rate=window.prompt("Enter flight profit:")
  if(rate){
    setprice({...price,airfare:(totalflightcost?totalflightcost+rate:0)})
  }
  
}

function roundUp(number){
  return Math.ceil(number / 100) * 100;
  }
  function roundDown(number){
  return Math.floor(number / 100) * 100;
  }

  const removeflightfromquote=(result, index)=>{
    const temp=[...quoteData.travclan_flight]
    const temp2=result.fF
    temp.splice(index,1)
    setquoteData({...quoteData,travclan_flight:temp})
    setprice({...price,airfare:price.airfare-temp2*1.02})
    setcostprice({...costprice,airfare:costprice.airfare-temp2})
    settotalflightcost(totalflightcost-temp2)
  }

 const showssr=async(result, index)=>{
  setssrstatus("Searching")
  setidentifier({
    index:index,
    resultindex:Array.isArray(result)?result[0].ResultIndex:result.ResultIndex
  })
  console.log(identifier)
  const finalsearchData={
    "TokenId":token,
    "TraceId":searchResponse.TraceId,
    "ResultIndex":Array.isArray(result)?result[0].ResultIndex:result.ResultIndex,
  }
  console.log(finalsearchData)
  const ffrResponse=await fetchfarerule(finalsearchData)
  if(ffrResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
      
    console.log(ffrResponse.data)

}
else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
}

if(ffrResponse.data.Response.ResponseStatus==1){
  const ffqResponse=await fetchfarequote(finalsearchData)
  if(ffqResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
      
    console.log(ffqResponse.data)
    
  }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
}
if(ffqResponse.data.Response.ResponseStatus==1){
  const serviceResponse=await fetchssr(finalsearchData)
  if(serviceResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
    console.log(serviceResponse.data)
    setssrResponse(serviceResponse.data.Response)
    if(serviceResponse.data.Response.ResponseStatus!==1){
      alert(serviceResponse.data.Response.Error.ErrorMessage)
    }
    
  }else{
alert("Something went wrong. Contact support");
window.location = ("/home");
  }
    }else{
      alert(ffqResponse.data.Response.Error.ErrorMessage)
    }
  }else{
    alert(ffrResponse.data.Response.Error.ErrorMessage)
  }
  setssrstatus("Completed")
 } 

 const selectbaggage=(bg, result, index)=>{
    console.log(index)
    console.log(bg)
    console.log(result)
    const temparr=[...resultpass]
    let found=0
    for (let i=0;i<result.Segments.length;i++) {
      for(let j=0;j<result.Segments[i].length;j++) {
        // if(found){
        //   console.log("DEF")
        //   result.Segments[i][j].Baggage=result.Segments[i][j].Baggage+" "+bg.Weight
        // }
        if(result.Segments[i][j].Origin.Airport.AirportCode==bg.Origin){
          console.log(bg.Origin)
          found=1
          result.Segments[i][j].Baggage=result.Segments[i][j].Baggage+" || "+bg.Weight
          console.log(result.Segments[i][j].Baggage)
        }
        if(result.Segments[i][j].Destination.Airport.AirportCode==bg.Destination){
          console.log(bg.Destination)
          if(!found){
            result.Segments[i][j].Baggage=result.Segments[i][j].Baggage+" || "+bg.Weight
            console.log(result.Segments[i][j].Baggage)
          } 
          
        }
        found=0
      }
    }
    result.Fare.BaseFare=result.Fare.BaseFare+bg.Price
    console.log(result)
    temparr[index]=result
    console.log(temparr)
    setresultpass(temparr)
 }

 const changestartdate=(value)=>{
  //console.log(daydata)
  setquoteData({...quoteData, trip_start_date: value})
  const temp=[]
  for(let i=0; i<daydata.length; i++){
    temp[i]={...daydata[i], date:DateCalc2(value,i)}
    //console.log(DateCalc2(quoteData.trip_start_date,i))
  }
  getFD(value)
  setdaydata(temp)
 }

 const prefix="https://cf.bstatic.com"

 const gethotelpics=async(item)=>{
  
  const hotel=listhotelData.filter(h=>h.hotel_name==item.hotel_name);
  //console.log(hotel)
  if(hotel && hotel.length>0 && "booking_id" in hotel[0]){
    setOpen10(true)
  const options = {
    method: 'GET',
    url: 'https://apidojo-booking-v1.p.rapidapi.com/properties/get-hotel-photos',
    params: {
      hotel_ids: hotel[0].booking_id,
      languagecode: 'en-us'
    },
    headers: {
      'X-RapidAPI-Key': 'cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1',
      'X-RapidAPI-Host': 'apidojo-booking-v1.p.rapidapi.com'
    }
  };
  
  try {
    const response = await axios.request(options);
    console.log(response.data);
    let finalarr=[]
    let filterarr=[]
    let temp=response.data.data[hotel[0].booking_id]
    if(temp && temp.length>50){
      temp=temp.slice(0,50)
    }
    for(let i=0; i<temp.length; i++){
      if(temp[i][1].length>0 && "tag_name" in temp[i][1][0]){
        filterarr.push(temp[i][1][0].tag_name)
      }
      for(let j=0; j<temp[i].length; j++){
        if(typeof temp[i][j]=="string" && temp[i][j].startsWith('/xdata')){
          const temp2={
            name:prefix+temp[i][j],
            description:temp[i][1].length>0?temp[i][1][0].tag_name:""
          }
          finalarr.push(temp2)
          break
        }
      }
    }
    const filterarr2=removeDuplicates2(filterarr)
    setpicsfilter(filterarr2)
    console.log(finalarr)
    setpicsdata2(finalarr)
    setpicsdata(finalarr)
   
  } catch (error) {
    console.error(error);
  }
}else{
  // const temp=listhotelData.map(h=>h.hotel_name)
  // alert(temp)
  alert("Mapping not done for this hotel")
  //setOpen10(false)
}
 }

 const changefilter=(value)=>{
  if(value=="Clear"){
    let temp=[...picsdata2]
    setpicsdata(temp)
  }else{
  let temp=[...picsdata2]
  temp=temp.filter(pic=>pic.description==value)
  setpicsdata(temp)
  }
 }

 const gethelptext=(daydata)=>{
  var temparr=[]
  for(let i=0;i<daydata.length;i++){
    var name2=listhotelData?.filter(hotel => hotel.hotel_name == daydata[i].hotel_name)
    //console.log(name2)
    var temp=name2.length>0 && "hotel_reco" in name2[0] && name2[0].hotel_reco=="Not Recommended"?"Not a recommended hotel. Check hotel list for other recommended hotels":""
    temparr[i]=temp
  }
  sethelptext(temparr)
  //return temp
 }
 //console.log(helptext)
  const gethelptext2=(index)=>{
  var temparr=[]

    var name2=listhotelData?.filter(hotel => hotel.hotel_name == daydata[index].hotel_name)
    //console.log(name2)
    var temp=name2.length>0 && "hotel_reco" in name2[0] && name2[0].hotel_reco=="Not Recommended"?"Not a recommended hotel. Check hotel list for other recommended hotels":""
    
 
  //sethelptext(temparr)
  return temp
 }


 const gethotelname=(hotel)=>{
  //console.log("Ran")
  if(hotel.hotel_reco_reason){
    return hotel.hotel_name+" ----- "+hotel.hotel_reco_reason
  }else{
    return hotel.hotel_name
  }
 }

 const getrc=(hotelname)=>{
    const hotel=listhotelData.filter(h=>h.hotel_name==hotelname)
    //console.log(hotel)
     if(hotel.length>0 && "room_category" in hotel[0] && hotel[0].room_category.length>0 && hotel[0].room_category.every(str => str.length > 3)){
      return true
    }else{
      return false
    }

   
 }

 const getbenefit=(hotelname, date)=>{
  if(hotelname && date && new Date(date).getTime()>new Date().getTime()){
  var temp=hotelname
  if(hotelname.includes("--")){
    temp=hotelname.split("--")[0].trim()
  }
  const hotel=listhotelData.filter(h=>h.hotel_name==temp)
  //console.log(hotel)
  if(hotel.length>0 && "hotel_benefit" in hotel[0] && "hotel_benefit_end_date" in hotel[0] && new Date(date).getTime()<new Date(hotel[0].hotel_benefit_end_date).getTime()){
    return hotel[0].hotel_benefit
  }else{
    return false
  }
  }else{
    return false
  }
 
}

 const getroomcategoryoptions=(hotelname)=>{
  const hotel=listhotelData.filter(h=>h.hotel_name==hotelname)
  //console.log(hotel)
  if(hotel.length>0 && "room_category" in hotel[0] && hotel[0].room_category.length>0){
    return hotel[0].room_category
  }else{
    return []
  }
 }

 const opencoupon=()=>{
  var temp="coupon" in quoteData?quoteData.coupon:[]
  setfinalcouponData(temp)
  setOpen11(true)
 }

 const generatecoupon=()=>{
  const temp={
    code:generateRandomAlphanumeric(),
    expiry:addHoursToDate(new Date(), couponData.expiry),
    amount:couponData.amount,
  }
  const couponarr="coupon" in quoteData?[...quoteData.coupon, temp]:[temp]
  //console.log(couponarr)
  var discount=0
  if(new Date().getTime()<new Date(couponarr[couponarr.length-1].expiry).getTime()){
    discount=couponarr[couponarr.length-1].amount
  }
  setquoteData({...quoteData, coupon:couponarr, quote_discount:discount})
  //handleSubmit()
 }

 const getcouponstatus=(c,index)=>{
  var temp=""
    if(quoteData.coupon.length!==(index+1)){
        temp= "Inactive"
    }else{
      if(new Date().getTime()>new Date(c.expiry).getTime()){
        temp= "Inactive"
      }else{
        temp= "Active"
      }
    }
    //console.log(temp)
    return temp
 }

 const fupfinalDate = DateCalc(0);

 const getdatafromchild=(data)=>{
  setchilddata(data)
 }

 const showinbound=(value)=>{
 console.log(value)
  setinbound(true)
  setinboundindex(value)
 }

 const showoutbound=()=>{
  setinbound(false)
  setinboundindex(null)
 }

 const getsuppliers = async () => {
     try{
    setOpen12(true)
     //const data = await fetchSuppliersbyDest(tripData.primary_destination);
     const data = await fetchSuppliers();
     var data2=data.data.filter(sup=>sup.supplier_destinations==tripData.primary_destination || sup.supplier_destinations=="All")
     if(tripData.secondary_destinations){
       const data3=data.data.filter(sup=>sup.supplier_destinations==tripData.secondary_destinations)
       data2=data2.concat(data3)
       //console.log(data3)
       //console.log(data2)
     }
     if(tripData.tertiary_destinations){
      const data4=data.data.filter(sup=>sup.supplier_destinations==tripData.tertiary_destinations)
      data2=data2.concat(data4)
      //console.log(data3)
      //console.log(data2)
    }
     let sortedSuppliers = data2.sort((a, b) => {
       if (a.supplier_name < b.supplier_name) {
           return -1;
       }
       if (a.supplier_name > b.supplier_name) {
           return 1;
       }
       return 0;
   });;
         setsData(sortedSuppliers)
          var hoteldata=[]
         for(let i=0; i<daydata.length; i++) {
          var temp={
            date:daydata[i].date, 
            inventory:daydata[i].hotel_name,
            inventory_status:true,
          }
          hoteldata=[...hoteldata, temp]
         }
         for(let i=0; i<daydata.length; i++) {
          var temp={
            date:daydata[i].date, 
            inventory:daydata[i].tour_name,
            inventory_status:true,
          }
          hoteldata=[...hoteldata, temp]
         }
         setinventoryData(hoteldata)
       }catch(err){
         console.log(err)
       }
   };

const changeswitch=(d, name, checked)=>{
  // console.log(inventoryData)
  // console.log(d, name, checked)
  const temp=inventoryData.map(i=>i.inventory==name && i.date==d?{...i,inventory_status:checked}:i)
  console.log(temp)
  setinventoryData(temp)
}

const sendquery=async()=>{
  if(partnerData.partner_name==""){
    alert("Select which supplier to send query")
  }else{
  var temp={
    cust_name: quoteData.cust_name,
    trip_start_date: quoteData.trip_start_date,
    primary_destination: quoteData.primary_destination,
    primary_mobile_number: tripData.primary_mobile_number,
    primary_email_id: tripData.primary_email_id,
    number_adults: quoteData.number_adults,
    child_age:tripData.child_age,
    number_child: quoteData.number_child,
    duration: quoteData.duration,
    trip_status: quoteData.trip_status,
    cost_price:quoteData.cost_price,
    trip_id: quoteData.trip_id,
    trip_owner:quoteData.trip_owner,
    // trip_review:String,
    // trip_review_score:Number,
    // trip_review_source:String,
    // trip_review_show:Boolean,
    // trip_review_location:String,
    // post_trip_score:Number,
    // trip_review_date:Date,
    // flight_ticket:String,
    // hotel_voucher:String,
    // land_voucher:String,
    // visa:String,
    // driver_number:String,
    // driver_name:String,
    // driver_contact:String,
    // travel_insurance:String,
    // flight_cp:Number,
    // land_cp:Number,
    // anc_cp:Number,
    // visa_cp:Number,
    // cruise_cp:Number,
    // quote_id:Number,
    // red_flag:Boolean,
    // supplier_payments:[{
    //     id:String,
    //     date:Date,
    //     amount:Number,
    //     status: String,
    //     mode: String,
    //     account:String,
    //     details:String,
    //     name:String,
    //     businesstype: String,
    //     responsible:String,
    //     checker:String,
    //     all_good:Boolean,
    //     pna:Boolean,
    //     invoice:String,
    //     airline_name:String,
    // }],
    inventory_list:inventoryData,
    inventory_price:null,
    inventory_currency:identifycurrency(quoteData.primary_destination),
    expected_price:partnerData.expected_price,
    partner_id:sData.filter(s=>s.supplier_name==partnerData.partner_name)[0].supplier_id,
    partner_name:partnerData.partner_name,
    query_status:"New",
    query_notes:partnerData.query_notes,
    // supplier_details:{
    //     type: Schema.Types.ObjectId,
    //     ref: "supplierModel"
    // },
    // file:[{
    //     name:String,
    //     location:String,
    //     type_of_doc:String,
    //     uploadtime:Date,
    // }],
    createdAt:new Date(),
    
  }
  console.log(temp)
  setpartnerData(temp)
  const addqueryResponse= await addQuery(temp);
          // dispatch(createCustomer(finalcustData));
          //console.log(addcustResponse.data.cust_id);
          if(addqueryResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
              alert("New query added with query id "+addqueryResponse.data.query_id);
              setOpen12(false)
          }
          else{
              alert("Something went wrong. Contact support");
              window.location = ("/");
          }
}
}

const getratecategory=(day)=>{
  var gt=0
  const temp=alllisttourData.filter(t=>t.tour_name==day.tour_name)
  if(temp.length>0){
    var rc=temp[0].rate_category
    for(let i=0;i<rc.length;i++){
      if(new Date(day.date).getTime()>new Date(rc[i].start_date).getTime() && new Date(day.date).getTime()<new Date(rc[i].end_date).getTime()){
        if(rc[i].category=="Normal"){
          gt=1
        
        }else if(rc[i].category=="Mid"){
          gt=2
          
        }else if(rc[i].category=="High"){
          gt=3
         
        }
      }
    }
  }
  if(!gt){
    let xx=prompt("Enter category of tour prices: 1 for normal, 2 for mid and 3 for high season for "+day.tour_name)
    return xx
  }else{
    return gt
  }
}

const getadvancenotice=(name)=>{
  if(name){
    const t=alllisttourData.filter(tour=>tour.tour_name==name && "advance_booking" in tour && tour.advance_booking)
    if(t.length>0){
      return " (Advance booking required)"
    }else{
      return ""
    }
  }else{
    return ""
  }
}

const openitinerary=async()=>{
  try{
    const tourarr=daydata.map(d=>d.tour_id)
    //console.log(tourarr)
    const data=await gettouritinerary(tourarr)
    //console.log(data.data)
    setitinerarytext(data.data)
    setOpen15(true)
  }catch(err){
    console.log(err)
  }
}

const gettourmealplan=(meal)=>{
  if(quoteData && "primary_destination" in quoteData && identifydest(quoteData.primary_destination)){
  if(meal){
    if(meal=="No meals"){
      return ""
    }else if(meal=="Breakfast"){
      return ""
    }else if(meal=="Dinner"){
      return " with Dinner"
    }else if(meal=="Breakfast and Dinner"){
      return " with Dinner"
    }else if(meal=="Breakfast and Lunch"){
      return " with Lunch"
    }else if(meal=="Lunch and Dinner" || meal=="Breakfast, Lunch and Dinner" || meal=="All Inclusive"){
      return " with Lunch & Dinner"
    }else{
      return ""
    }
  }else{
    return ""
  }
}else{
  return ""
}
}
 //console.log(finalcouponData)
//console.log(childdata)
    return ( 
        <div>
       
        <Drawer anchor="left" open={draweropen} onClose={()=>setdraweropen(false)}>
        <div>
          {info.length>0?<div>
            {info.map(infobit => 
            <div>
            <Typography variant="h6" className={classes.textField2}>{infobit}</Typography>
            
            </div>
            )}
            
          </div>:<div>Loading...</div>}
          {/* {info2.length>0?<div>
            {info2.map(infobit => 
            <div>
            <Typography variant="h6" className={classes.textField3}>{infobit}</Typography>
            
            </div>
            )}
            
          </div>:<div>Loading...</div>}
          {info3.length>0?<div>
            {info3.map(infobit => 
            <div>
            <Typography variant="h6" className={classes.textField2}>{infobit}</Typography>
            
            </div>
            )}
            
          </div>:<div>Loading...</div>} */}
          </div>
        </Drawer>
        <Drawer anchor="right" open={draweropen2} onClose={drawer2close}>
        <div>
        <h1>Rates</h1>
          {daydata?.length>0 && cost && totalcost?<div>
            {cost.length==daydata.length*2-1? (
              <div>
            {daydata.map((data, index) => 
            <div>
            <Typography variant="h6"  className={cost[index+daydata.length]==0?classes.textField3:classes.textField2}>{data.hotel_name} : {cost[index+daydata.length]}</Typography>
            <Typography variant="h6"  className={cost[index]==0?classes.textField3:classes.textField2}>{data.tour_name} : {cost[index]}</Typography>
            <hr></hr>
            </div>
            )}
            
            <Typography variant="h6" className={classes.textField}>Total : {totalcost}</Typography>
            </div>
            ):(<div>Cost calculation is incorrect</div>)}
          </div>:<div>Loading...</div>}
          </div>
        </Drawer>
        <Drawer anchor="right" open={draweropen3} onClose={drawer3close}>
        <div>
        {quoteData.primary_destination=="Singapore"?(
        <p>For Sands sky park, Museum of Ice Cream and Duck tour, ticket required for 2+ years. Rest ticket required for 3+ years</p>
        ):("")}
        {quoteData.primary_destination=="Dubai"?(
        <p>For Dubai Aquarium & Underwater zoo, Dolphin show, Green Planet, Aquafun park, Wonder Bus ticket required for 2+ years. Rest ticket required for 3+ years</p>
        ):("")}
        <h1>Rates</h1>
        <h2>Number of rooms: {numberofrooms}</h2>
          {daydata?.length>0 && cost?.length>0?<div>
          {cost.map(item=>
          <div>
          <Typography variant="h6"  className={item.rate<0?classes.textField5:(!("rate" in item) || item.rate==0 || item.rate=="" || item.rate==null)?classes.textField3:classes.textField2}>{item.name} ({"room_type" in item? item.room_type:""}) : {"source" in item?item.rate+" ("+item.source+")":item.rate}</Typography>
          {item.type=="CRM" || item.type=="Manual-INR" || item.type=="Manual-CUR" ?(
            <FormGroup row className={classes.formgroup}>
            {multidest?(""):(
              <Button variant="outlined" color="primary" className={classes.smallbutton3} onClick={()=>manualentrycur(item.name)}>Add Manually-CUR</Button>
            )}
            <Button variant="outlined" color="primary" className={classes.smallbutton3} onClick={()=>manualentryinr(item.name)}>Add Manually-INR</Button>
            </FormGroup>
          ):("")}
          {item.type=="Manual-Others" || item.type=="CRM-Visa"?(
            <FormGroup row className={classes.formgroup}>
            
            <Button variant="outlined" color="primary" className={classes.smallbutton3} onClick={()=>manualentryvisainr(item.name)}>Add Manually-INR</Button>
            </FormGroup>
          ):("")}
          </div>)}
          <Typography variant="h6" className={classes.textField}>Total Land (in INR): {totalcost}</Typography>
          <Typography variant="h6" className={classes.textField}>Total Flight (in INR): {totalflightcost}</Typography>
          <Typography variant="h6" className={classes.textField}>Total Others (in INR): {totalvisacost}</Typography>
          <Typography variant="h6" className={classes.textField}>Total Package Cost (in INR): {(totalcost?totalcost:0)+(totalflightcost?totalflightcost:0)+(totalvisacost?totalvisacost:0)}</Typography>
          <FormGroup row className={classes.formgroup}>
          {multidest?(""):(
          <Button variant="contained" color="primary" className={classes.button3} onClick={()=>addinventorycur()}>Add Inventory-CUR</Button>
          )}
          <Button variant="contained" color="primary" className={classes.button3} onClick={()=>addinventoryinr()}>Add Inventory-INR</Button>
          </FormGroup>
          <br></br>
          {fdtext? <Typography
            variant="h4"
            align="center"
            className={classes.red}
          >
            {" "}
            {fdtext.text}
          </Typography>:""}
          <br></br>
          <Button variant="contained" color="primary" className={classes.button3} onClick={()=>checkallgood()}>Get Profit Table</Button>
          <br></br>
          <Button variant="outlined" color="secondary" className={classes.button3} onClick={dialogopen5}>Fetch Hotel Rates via API</Button>
          <hr></hr>
          <br></br>
          <Button variant="outlined" color="secondary" className={classes.button3} onClick={()=>setOpen14(true)}>Fetch Flight Rates via API</Button>
          <Button variant="outlined" color="primary" className={classes.button3} onClick={()=>manualentryflightinr("Flight")}>Add Flight Manually-INR</Button>
          {/* <Button variant="outlined" color="inherit" className={classes.button3} onClick={()=>customflightprofit()}>Add Custom Flight Profit</Button> */}
          <hr></hr>
          <br></br>
          <Button variant="outlined" color="primary" className={classes.button3} onClick={dialogopen8}>Fetch Other Rates</Button>
          <hr></hr>
          <br></br>
          {allgood?(
            <div>
            {/* <Typography variant="h6" className={classes.textField}>Suggested Price: {getprofitrange(totalcost,totalflightcost, totalvisasales,15)} - {getprofitrange(totalcost,totalflightcost, totalvisasales, 50)}</Typography> */}
            {tripData.trip_channel=="TripCrafters"?(<Typography variant="h6" className={classes.textField3}>Lead may have competition. Keep lower profits</Typography>):("")}
            <Typography variant="h6" className={classes.textField}>Sales price at differnt profit values:</Typography>
            <Typography variant="h6" className={classes.textField3}>Use coupons whenever applicable</Typography>
            {/* <Table>
              <TableHead>
                <TableCell>Profit per person</TableCell>
                <TableCell>Sales Price</TableCell>
                <TableCell>Action Item</TableCell>
              </TableHead>
              <TableRow>
                <TableCell>3.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,3200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(3200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>3.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,3700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(3700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>4.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,4200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(4200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>4.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,4700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(4700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>5.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,5200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(5200)}>Add</button></TableCell>
              </TableRow>
              
              <TableRow>
                <TableCell>5.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,5700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(5700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>6.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,6200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(6200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>6.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,6700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(6700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>7.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,7200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(7200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>7.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,7700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(7700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>8.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,8200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(8200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>8.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,8700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(8700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>9.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,9200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(9200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>9.7k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,9700)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(9700)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>10.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,10200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(10200)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>11.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,11000)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(11000)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>12.2k</TableCell>
                <TableCell>{getvaluerange(totalcost,totalflightcost, totalvisasales,12200)}</TableCell>
                <TableCell><button onClick={()=>usevalueprice(12200)}>Add</button></TableCell>
              </TableRow>
            </Table> */}
            <Button variant="outlined" color="primary" className={classes.button3} onClick={()=>customprofit()}>Add Custom Profit</Button>
            <br>
            </br>
            <br></br>
            <Table>
              <TableHead>
                <TableCell>Percentage (land price)</TableCell>
                <TableCell>Sales Price</TableCell>
              </TableHead>
              <TableRow>
                <TableCell>10%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,10)}</TableCell>
                <TableCell><button onClick={()=>useperprice(10)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>12.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,12.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(12.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>15%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,15)}</TableCell>
                <TableCell><button onClick={()=>useperprice(15)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>17.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,17.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(17.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>20%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,20)}</TableCell>
                <TableCell><button onClick={()=>useperprice(20)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>22.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,22.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(22.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>25%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,25)}</TableCell>
                <TableCell><button onClick={()=>useperprice(25)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>27.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,27.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(27.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>30%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,30)}</TableCell>
                <TableCell><button onClick={()=>useperprice(30)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>32.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,32.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(32.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>35%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,35)}</TableCell>
                <TableCell><button onClick={()=>useperprice(35)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>37.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,37.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(37.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>40%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,40)}</TableCell>
                <TableCell><button onClick={()=>useperprice(40)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>42.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,42.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(42.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>45%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,45)}</TableCell>
                <TableCell><button onClick={()=>useperprice(45)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>47.5%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,47.5)}</TableCell>
                <TableCell><button onClick={()=>useperprice(47.5)}>Add</button></TableCell>
              </TableRow>
              <TableRow>
                <TableCell>50%</TableCell>
                <TableCell>{getprofitrange(totalcost,totalflightcost, totalvisasales,50)}</TableCell>
                <TableCell><button onClick={()=>useperprice(50)}>Add</button></TableCell>
              </TableRow>
            </Table>
            </div>
          ):("")}
          <hr></hr>
          <br></br>
          <Button variant="contained" color="secondary" onClick={addpricetoquote}>Add to Quote</Button>
          </div>:<div>Rates cannot be loaded</div>}
          </div>
        </Drawer>
        <Dialog fullWidth maxWidth="m" open={Open11} onClose={handleClose11}>
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  label="Amount" InputLabelProps={{ shrink: true }} value={couponData.amount} className={classes.textField} onChange={(e)=> setcouponData({...couponData, amount: e.target.value})}/>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="city">Expriy</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="expiry"   value={couponData.expiry} onChange={(e) => setcouponData({...couponData, expiry: e.target.value})}>
                {/* <MenuItem value={-1}>-1</MenuItem> */}
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={12}>12</MenuItem>
                <MenuItem value={24}>24</MenuItem>
                <MenuItem value={36}>36</MenuItem>
                <MenuItem value={48}>48</MenuItem>
                <MenuItem value={60}>60</MenuItem>
                <MenuItem value={72}>72</MenuItem>
                <MenuItem value={1000}>1000</MenuItem>
                </Select>
                </FormControl>  
        </FormGroup>
        <div align="center">
        <Button onClick={()=>generatecoupon()} variant="contained" color="inherit" className={classes.button}>Generate</Button>
        </div>
        <br></br>
        <br></br>
       
        
        {"coupon" in quoteData && quoteData.coupon.length>0?(<Table>
          <TableHead>
        <TableCell>Code</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Expiry</TableCell>
            <TableCell>Status</TableCell>
        </TableHead>
          {quoteData.coupon.map(c=>{return(
          <TableRow>
            <TableCell>{c.code}</TableCell>
            <TableCell>{c.amount}</TableCell>
            <TableCell>{new Date(c.expiry).toLocaleString()}</TableCell>
            <TableCell>{getcouponstatus(c, quoteData.coupon.indexOf(c))}</TableCell>
          </TableRow>
        )})}
        </Table>):("")}
        
        </Dialog>
        <Dialog fullWidth maxWidth="m" open={Open15} onClose={handleClose15}>
        {daydata && itinerarytext && daydata.map(d=>
        <div>
        <p>{d.date+" --> "+d.tour_name}</p>
        <p>{itinerarytext.filter(i=>i.tour_id==d.tour_id)[0].tour_itinerary_text}</p>
        <br></br>
        </div>
        )}
        
        
        </Dialog>
        <Dialog
        fullWidth
        maxWidth="l"
        open={Open12}
        onClose={handleClose12}
      >
 {quoteData && daydata?(
        <div>
        <h3>{quoteData.cust_name} || {quoteData.primary_destination} || Jeto Vacations || {quoteData.trip_id}</h3>
      <h3 className={classes.row}>Pax: {quoteData.number_adults} adults {quoteData.number_child>0?(quoteData.number_child+" children"):""}</h3>
      <h3 className={classes.row}>Customer Notes:</h3>
      {quoteData && "cust_notes_arr" in quoteData && quoteData.cust_notes_arr.map(note=>
        <h5 className={classes.row}>{note}</h5>
      )}
      <TextField variant="standard"  label="Partner Notes" InputLabelProps={{ shrink: true }} value={partnerData.query_notes} className={classes.textField} />
     
      <h3 className={classes.row}>Hotel details:</h3>
      {daydata.map((day)=>
      <div>
        <h5 className={classes.row}>{day.date} -- {day.hotel_name} ({day.room_type}) -- {day.meal_plan}</h5>
        {(daydata.indexOf(day)==0 || daydata.indexOf(day)>0 && day.hotel_name !==daydata[daydata.indexOf(day)-1].hotel_name) && getbenefit(day.hotel_name, day.date)?<p className={classes.black}>{"Extra Benefit: "+getbenefit(day.hotel_name, day.date)}</p>:("")}
        <FormControlLabel control={<Switch  defaultChecked onChange={(e)=>changeswitch(day.date, day.hotel_name, e.target.checked)} color="secondary" />} label="Send to supplier?"/>
        <hr></hr>
      </div>
      )}
      <br></br>
      <h3 className={classes.row}>Tour details:</h3>
      {daydata.map((day)=>
      <div>
        <h5 className={classes.row}>{day.date+ " -- "+ day.tour_name+" ("+gettourmealplan(day.meal_plan)+")"}</h5>
        <FormControlLabel control={<Switch  defaultChecked  onChange={(e)=>changeswitch(day.date, day.tour_name, e.target.checked)} color="secondary" />} label="Send to supplier?"/>
        <hr></hr>
        </div>
      )}
      <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="supplier">Supplier</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="supplier"
                      value={partnerData.partner_name}
                      onChange={(e) => setpartnerData({...partnerData, partner_name: e.target.value})}
                    >
                    <ListSubheader>DMC</ListSubheader>
                    {sData && sData.filter(s=>s.supplier_type=="DMC").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Hotel</ListSubheader>
                      {sData && sData.filter(s=>s.supplier_type=="Hotel").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                     
                     
                      
                      <ListSubheader>Cab driver</ListSubheader>
                      {sData && sData.filter(s=>s.supplier_type=="Cab driver").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Cab agency</ListSubheader>
                      {sData && sData.filter(s=>s.supplier_type=="Cab agency").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Restaurant</ListSubheader>
                      {sData && sData.filter(s=>s.supplier_type=="Restaurant").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      
                      <ListSubheader>Others</ListSubheader>
                      {sData && sData.filter(s=>s.supplier_type=="Others").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                     
                      
                    </Select>
                  </FormControl>
                  <TextField variant="standard"  label="Expected Price" InputLabelProps={{ shrink: true }} value={partnerData.expected_price} className={classes.textField} />
                  <Button variant="contained" color="primary" onClick={sendquery} className={classes.button}>Send Query</Button>
        </div>
      ):("")}
      </Dialog>
        <Dialog
        fullWidth
        maxWidth="l"
        open={Open3}
        onClose={handleClose3}
      >
      {quoteData && daydata?(
        <div>
        <h3>{quoteData.cust_name} || {quoteData.primary_destination} || Jeto Vacations || {quoteData.trip_id}</h3>
        <h3>Hi</h3>
      <h3>Please quote:</h3>
      <h3 className={classes.row}>Pax: {quoteData.number_adults} adults {quoteData.number_child>0?(quoteData.number_child+" children"):""}</h3>
      <h3 className={classes.row}>Customer Notes:</h3>
      {quoteData && "cust_notes_arr" in quoteData && quoteData.cust_notes_arr.map(note=>
        <h5 className={classes.row}>{note}</h5>
      )}
      <h3 className={classes.row}>Internal Notes:</h3>
      {quoteData && "internal_notes" in quoteData? <h5 className={classes.row}>{quoteData.internal_notes}</h5>:""}
      <h3 className={classes.row}>Inclusions:</h3>
      {quoteData && "inclusions_arr" in quoteData && quoteData.inclusions_arr.map(note=>
        <h5 className={classes.row}>{note}</h5>
      )}
      <h3 className={classes.row}>Exclusions:</h3>
      {quoteData && "exclusions_arr" in quoteData && quoteData.exclusions_arr.map(note=>
        <h5 className={classes.row}>{note}</h5>
      )}
      <h3 className={classes.row}>Hotel details:</h3>
      {/* {showhoteldetails()} */}
      {daydata.map((day)=>
      <div>
        <h5 className={classes.row}>{day.date} -- {day.hotel_name} ({day.room_type}) -- {day.meal_plan} X {day.number_rooms}</h5>
        {(daydata.indexOf(day)==0 || daydata.indexOf(day)>0 && day.hotel_name !==daydata[daydata.indexOf(day)-1].hotel_name) && getbenefit(day.hotel_name, day.date)?<p className={classes.black}>{"Extra Benefit: "+getbenefit(day.hotel_name, day.date)}</p>:("")}
        <p className={classes.row}>{"hotel_internal_notes" in day? day.hotel_internal_notes:""}</p>
      </div>
      )}
      <br></br>
      <h3 className={classes.row}>Tour details:</h3>
      {daydata.map((day)=>
      <div>
        <h5 className={classes.row}>{day.date+ " -- "+ day.tour_name+" ("+gettourmealplan(day.meal_plan)+")"} {getadvancenotice(day.tour_name)}</h5>
         <p className={classes.row}>{"tour_internal_notes" in day? day.tour_internal_notes:""}</p>
         </div>
      )}
        </div>
      ):("")}
      <Typography variant="h4" align="center" className={classes.headertext}> <a href={"https://www.jetovacations.com/quote/"+quoteData._id} target="_blank" rel="noreferrer">(Check Tour Inclusions before sending mail)</a></Typography>
    
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={Open8}
        onClose={handleClose8}
      >
      {visaData && visaData.length>0?(<Table>
      <TableRow>
        <TableCell>Inventory</TableCell>
        <TableCell>Cost Price</TableCell>
        <TableCell>Sales Price</TableCell>
        <TableCell>Quantity</TableCell>
      </TableRow>
        {visaData.map(visa=> <TableRow>
          <TableCell>{visa.name}</TableCell>
          <TableCell>{visa.cp} </TableCell>
          <TableCell>{visa.sp} </TableCell>
          <TableCell>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="number">Number</InputLabel>
                <Select classname={classes.textField} labelId="number"  onChange={(e) => visachange(visaData.indexOf(visa), e.target.value, visa)}>
                <MenuItem value={0}>0</MenuItem>
                {maxpass?.map(max => {
                    return <MenuItem value={max}>{max}</MenuItem>})}
                </Select>
                </FormControl>  
          </TableCell>
        </TableRow>)}
        <TableRow>
        <Button onClick={addvisa} variant="contained" color="primary" className={classes.button}>Proceed</Button>
        </TableRow>
      </Table>):("No Data Found")}
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={Open5}
        onClose={handleClose5}
      >
      <Typography variant="h4" align="center" className={classes.headertext}>Results</Typography>
      {frData? (
        <div>
        <br></br>
        {frData.itineraries?(<div>

        
        <RadioGroup
    aria-labelledby="demo-controlled-radio-buttons-group"
    name="controlled-radio-buttons-group"
    value={fselection?fselection:0}
    onChange={(e)=>handlechange(e)}
  >
        <Typography variant="h4" align="center" className={classes.headertext}>Cheapest</Typography>
        
        {frData.itineraries.buckets?(
          <table border="0" width="700" align="center">
          {frData?.itineraries?.buckets[2]?.items.map(item =>
          <div>
        <tr>
        <td><b>Price (per person):</b>{item.price.raw} || <b>Total:</b>{item.price.raw*(fsData.number_adults+fsData.number_child)} </td>
        </tr>
        <br></br>
        {item.legs.map(leg =>
        <div>
        {leg.segments.map(segment =>
        <div>
        <div align="center">{segment.timediff?segment.timediff:""}</div>
        <br></br>
        <table border="0" width="700">
          <tr>
          <td><b>From:</b>{segment.origin.parent.name} ({segment.origin.flightPlaceId})</td>
          <td><b>To:</b>{segment.destination.parent.name} ({segment.destination.flightPlaceId})</td>
          <td><b>Airline:</b>{segment.marketingCarrier.name}</td>
        </tr>
        <tr>
          <td><b>Departure:</b>{String(segment.departure).split("T").slice(0,1)} at {String(segment.departure).split("T").slice(1,2)}</td>
          <td><b>Arrival:</b>{String(segment.arrival).split("T").slice(0,1)} at {String(segment.arrival).split("T").slice(1,2)}</td>
          <td><b>Duration: </b>{Math.floor(segment.durationInMinutes/60)} hrs {segment.durationInMinutes%60} mins</td>
        </tr>
        {/* <tr>
            <td>{item.id}</td>
        </tr> */}
        <br></br>
        </table>
        
        </div>
        )} 
        <hr  className={classes.line}></hr>
        </div>
        )} 
        {/* <FormControlLabel control={<Checkbox color="primary"/>}  value={fselection.id==item.id?1:0} label="Select flight" onChange={(e)=> setfselection({item})}/> */}
        <FormControlLabel value={item.id} control={<Radio checked={(fselection && item)?(fselection.item.id==item.id)?1:0:0}/>} label="Select" />
        <hr></hr>
        </div>
        )}
        </table>
        ):("")}
       
        <Typography variant="h4" align="center" className={classes.headertext}>Fastest</Typography>
        {frData.itineraries.buckets ?(
        <table border="0" width="700" align="center">
        {frData?.itineraries?.buckets[1]?.items.map(item =>
          <div>
        <tr>
        <td><b>Price (per person):</b>{item.price.raw} || <b>Total:</b>{item.price.raw*(fsData.number_adults+fsData.number_child)} </td>
        </tr>
        <br></br>
        {item.legs.map(leg =>
        <div>
        {leg.segments.map(segment =>
        <div>
        <div align="center">{segment.timediff?segment.timediff:""}</div>
        <br></br>
        <table border="0" width="700">
          <tr>
          <td><b>From:</b>{segment.origin.parent.name} ({segment.origin.flightPlaceId})</td>
          <td><b>To:</b>{segment.destination.parent.name} ({segment.destination.flightPlaceId})</td>
          <td><b>Airline:</b>{segment.marketingCarrier.name}</td>
        </tr>
        <tr>
          <td><b>Departure:</b>{String(segment.departure).split("T").slice(0,1)} at {String(segment.departure).split("T").slice(1,2)}</td>
          <td><b>Arrival:</b>{String(segment.arrival).split("T").slice(0,1)} at {String(segment.arrival).split("T").slice(1,2)}</td>
          <td><b>Duration: </b>{(segment.durationInMinutes/60).toFixed(0)} hrs {segment.durationInMinutes%60} mins</td>
        </tr>
        <br></br>
        </table>
        </div>
        )} 
        <hr  className={classes.line}></hr>
        </div>
        )} 
        {/* <FormControlLabel control={<Checkbox color="primary"/>}  value={fselection.id==item.id?1:0} label="Select flight" onChange={(e)=> setfselection({item})}/> */}
        <FormControlLabel value={item?item.id:0} control={<Radio checked={(fselection && item)?(fselection.item.id==item.id)?1:0:0}/>} label="Select" />
        <hr></hr>
        </div>
        )}
        </table>
        ):("")}
        <Typography variant="h4" align="center" className={classes.headertext}>Direct</Typography>
        {frData.itineraries.buckets ?(
        <table border="0" width="700" align="center">
        {frData?.itineraries?.buckets[3]?.items.map(item =>
        <div>
        <tr>
        <td><b>Price (per person):</b>{item.price.raw} || <b>Total:</b>{item.price.raw*(fsData.number_adults+fsData.number_child)} </td>
        </tr>
        <br></br>
        {item.legs.map(leg =>
        <div>
        {leg.segments.map(segment =>
        <div>
        <div align="center">{segment.timediff?segment.timediff:""}</div>
        <br></br>
        <table border="0" width="700">
          <tr>
          <td><b>From:</b>{segment.origin.parent.name} ({segment.origin.flightPlaceId})</td>
          <td><b>To:</b>{segment.destination.parent.name} ({segment.destination.flightPlaceId})</td>
          <td><b>Airline:</b>{segment.marketingCarrier.name}</td>
        </tr>
        <tr>
          <td><b>Departure:</b>{String(segment.departure).split("T").slice(0,1)} at {String(segment.departure).split("T").slice(1,2)}</td>
          <td><b>Arrival:</b>{String(segment.arrival).split("T").slice(0,1)} at {String(segment.arrival).split("T").slice(1,2)}</td>
          <td><b>Duration: </b>{(segment.durationInMinutes/60).toFixed(0)} hrs {segment.durationInMinutes%60} mins</td>
        </tr>
        <br></br>
        </table>
        </div>
        )} 
        <hr  className={classes.line}></hr>
        </div>
        )} 
        {/* <FormControlLabel control={<Checkbox color="primary"/>}  value={fselection.id==item.id?1:0} label="Select flight" onChange={(e)=> setfselection({item})}/> */}
        <FormControlLabel value={item?item.id:0} control={<Radio checked={(fselection && item)?(fselection.item.id==item.id)?1:0:0}/>} label="Select" />
        <hr></hr>
        </div>
        )}
        </table>
        ):("")}
        <Typography variant="h4" align="center" className={classes.headertext}>Best</Typography>
        {frData.itineraries.buckets ?(
        <table border="0" width="700" align="center">
        {frData?.itineraries?.buckets[0]?.items.map(item =>
          <div>
        <tr>
        <td><b>Price (per person):</b>{item.price.raw} || <b>Total:</b>{item.price.raw*(fsData.number_adults+fsData.number_child)} </td>
        </tr>
        <br></br>
        {item.legs.map(leg =>
        <div>
        {leg.segments.map(segment =>
        <div>
        <div align="center">{segment.timediff?segment.timediff:""}</div>
        <br></br>
        <table border="0" width="700">
          <tr>
          <td><b>From:</b>{segment.origin.parent.name} ({segment.origin.flightPlaceId})</td>
          <td><b>To:</b>{segment.destination.parent.name} ({segment.destination.flightPlaceId})</td>
          <td><b>Airline:</b>{segment.marketingCarrier.name}</td>
        </tr>
        <tr>
          <td><b>Departure:</b>{String(segment.departure).split("T").slice(0,1)} at {String(segment.departure).split("T").slice(1,2)}</td>
          <td><b>Arrival:</b>{String(segment.arrival).split("T").slice(0,1)} at {String(segment.arrival).split("T").slice(1,2)}</td>
          <td><b>Duration: </b>{(segment.durationInMinutes/60).toFixed(0)} hrs {segment.durationInMinutes%60} mins</td>
        </tr>
        <br></br>
        </table>
        </div>
        )} 
        <hr  className={classes.line}></hr>
        </div>
        )} 
        {/* <FormControlLabel control={<Checkbox color="primary"/>}  value={fselection.id==item.id?1:0} label="Select flight" onChange={(e)=> setfselection({item})}/> */}
        <FormControlLabel value={item?item.id:0} control={<Radio checked={(fselection && item)?(fselection.item.id==item.id)?1:0:0}/>} label="Select" />
        <hr></hr>
        </div>
        )}
        </table>
        ):("")}
        </RadioGroup>
        </div>):("API did not return results")}
        <FormGroup row className={classes.formgroup}>
        <Button onClick={addflighttoquote} variant="contained" color="primary" className={classes.button}>Add to Quote</Button>
        </FormGroup>
        </div>
        
      ):("Loading...")}
     
      </Dialog>
      <Dialog fullWidth maxWidth="xl" open={Open6} onClose={handleClose6}>
      <Typography variant="h4" align="center" className={classes.headertext}>Results</Typography>
      {frData? (
        <div>
        <br></br>
        {frData.data?(<div>
        <RadioGroup
    aria-labelledby="demo-controlled-radio-buttons-group"
    name="controlled-radio-buttons-group2"
    value={fselection?fselection:0}
    onChange={(e)=>handlechange2(e)}
  >
        
        {frData.data.length>0?(
          <table border="0" width="700" align="center">
          {frData?.data.map(item =>
          <div>
        <tr>
        <td><b>{frData.data.indexOf(item)+1} - Price (per person):</b>{item.price.amount} || <b>Total:</b>{item.price.amount*(fsData.number_adults+fsData.number_child)} </td>
        </tr>
        <br></br>
        {item.legs.map(leg =>
        <div>
        
        {/* <div align="center">{segment.timediff?segment.timediff:""}</div> */}
        <br></br>
        <table border="0" width="700">
          <tr>
          <td><b>From:</b>{leg.origin.name} ({leg.origin.display_code})</td>
          <td><b>To:</b>{leg.destination.name} ({leg.destination.display_code})</td>
          <td><b>Airline:</b>{leg.carriers[0].name} ({leg.carriers[0].display_code})</td>
        </tr>
        <tr>
          <td><b>Departure:</b>{String(leg.departure).split("T").slice(0,1)} at {String(leg.departure).split("T").slice(1,2)}</td>
          <td><b>Arrival:</b>{String(leg.arrival).split("T").slice(0,1)} at {String(leg.arrival).split("T").slice(1,2)}</td>
          <td><b>Duration: </b>{Math.floor(leg.duration/60)} hrs {leg.duration%60} mins</td>
        </tr>
        {leg.stops && leg.stops.map(stop =>
        <tr>
            <td>Stop: {leg.stops.indexOf(stop)+1} at {stop.name}({stop.display_code})</td>
        </tr>
        )}
        <br></br>
        </table>
        
        
        <hr  className={classes.line}></hr>
        </div>
        )} 
        {/* <FormControlLabel control={<Checkbox color="primary"/>}  value={fselection.id==item.id?1:0} label="Select flight" onChange={(e)=> setfselection({item})}/> */}
        <FormControlLabel value={item.id} control={<Radio checked={(fselection && item)?(fselection.id==item.id)?1:0:0}/>} label="Select" />
        <hr></hr>
        {fselection && fselection.id==item.id?(<div>
          
        {flightdetails?(<div>
          <table>
            
          {flightdetails.legs.map(leg =>
          <div>
          
          <tr>
          <td>
             <b> Leg {flightdetails.legs.indexOf(leg)+1} - {leg.origin.name} ({leg.origin.displayCode}) to {leg.destination.name} ({leg.destination.displayCode})</b>
              </td>
          </tr>
          
          {leg.segments.map(segment =>
          <div>
          <tr>
          <td><b>From:</b>{segment.origin.name} ({segment.origin.displayCode})</td>
          <td><b>To:</b>{segment.destination.name} ({segment.destination.displayCode})</td>
          <td><b>Airline:</b>{segment.marketingCarrier.name} ({segment.marketingCarrier.displayCode})</td>
        </tr>
        <tr>
          <td><b>Departure:</b>{String(segment.departure).split("T").slice(0,1)} at {String(segment.departure).split("T").slice(1,2)}</td>
          <td><b>Arrival:</b>{String(segment.arrival).split("T").slice(0,1)} at {String(segment.arrival).split("T").slice(1,2)}</td>
          <td><b>Duration: </b>{Math.floor(segment.duration/60)} hrs {segment.duration%60} mins</td>
        </tr>
        {leg.layovers && leg.layovers.map(layover=>
        <div>
        {leg.layovers.indexOf(layover)==leg.segments.indexOf(segment)?(
          <p className={classes.line}>Layover: {Math.floor(layover.duration/60)} hrs {layover.duration%60} mins</p>
        ):("")}
          
          </div>
          )}
        {/* <tr><td>{leg.layovers[leg.segments.indexOf(segment)].duration}</td></tr> */}
        
          </div>)}
          <hr></hr>
          </div>
          )}
          <tr><td><b>Pricing Options</b></td></tr>
          {flightdetails.pricingOptions.map(po =><div>
            {po.agents.map(agent =>
              <tr><td>{agent.name} - {agent.price*(fsData.number_adults+fsData.number_child)} </td></tr>
            )}
            
          </div>)}
          </table>
        </div>):("")}
          <Button onClick={getdetails} variant="contained" color="secondary" className={classes.smallbutton}>Details</Button>
        <Button onClick={addflighttoquote3} variant="contained" color="primary" className={classes.smallbutton}>Add</Button>
        </div>):("")}
        
        </div>
        
        )}
        </table>
        ):("")}
        </RadioGroup>
        </div>):("API did not return results")}
        {/* <FormGroup row className={classes.formgroup}>
        <Button onClick={addflighttoquote3} variant="contained" color="primary" className={classes.button}>Add to Quote</Button>
        </FormGroup> */}
        </div>
        
      ):("Loading...")}
      </Dialog>
      <Dialog fullWidth maxWidth="xl" open={Open10} onClose={handleClose10}>
      
      {picsdata?(<div>
        <FormGroup row className={classes.formgroup}>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="picsfilter">Pics filter</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="picsfilter"  onChange={(e) => changefilter(e.target.value)}>
                <MenuItem value={"Clear"}>Clear</MenuItem>
                {picsfilter?.map(filter => {
                    return <MenuItem value={filter}>{filter}</MenuItem>})}
                </Select>
                </FormControl> 
      </FormGroup>
      <Carousel
        next={ () => {/* Do stuff */} }
        prev={ () => {/* Do other stuff */} }
        NextIcon={<NavigateNextIcon/>}
        PrevIcon={<ArrowBackIosIcon/>}
      >
            {
              picsdata && picsdata.map( (item, i) => <Item key={i} item={item} /> )
            }
        </Carousel>
      </div>):(
        <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
      )}
     
       
      </Dialog>
      {showModal? (<MyModal data={{cm:handleCancel, cm2:modalText, cm3:handleConfirm }} />):(
        <Paper variant="outlined" className={classes.paper} elevation={10}>
        <div align="right">
        {(role=="Support" || role=="Operations" || role=="Product" || role=="Operations-TL" || role=="Admin") && quoteData.primary_destination=="Singapore"?(<Button
          onClick={()=>openitinerary()}
          variant="contained"
          color="secondary"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Tentative Itinerary</h6>
        </Button>):("")}
        <Button
          onClick={()=>opencoupon()}
          variant="contained"
          color="secondary"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Coupons</h6>
        </Button>
        
        <Button
          onClick={()=>getsuppliers()}
          variant="contained"
          color="inherit"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Supplier Portal</h6>
        </Button>
        
        <Button
          onClick={dialogopen3}
          variant="contained"
          color="inherit"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Supplier Email</h6>
        </Button>
        <Button
          onClick={drawer}
          variant="contained"
          color="primary"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Info</h6>
        </Button>
        {/* <Button
          onClick={tourcost}
          variant="contained"
          color="secondary"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Tour Cost</h6>
        </Button> */}
        <Button
          onClick={checkdates}
          variant="contained"
          color="secondary"
          align="right"
          className={classes.smallbutton}
        >
          <h6>Get Cost</h6>
        </Button>
        <Button
            onClick={()=>setdraweropen3(true)}
            variant="contained"
            color="primary"
            align="right"
            className={classes.smallbutton}
          >
            <h6>Open Cost</h6>
          </Button>
      </div>
      
        <Typography variant="h4" align="center" className={classes.headertext}> Update Quote ({quoteData.quote_id}) - <a href={"/tripdataentry/"+quoteData.trip_id} >(Trip Id: {quoteData.trip_id})</a> <a href={"https://www.jetovacations.com/quote/"+quoteData._id} target="_blank" rel="noreferrer">(Link to quote)</a></Typography>
        <Typography variant="h6" align="center" >Quote created on:{new Date(quoteData.createdAt).toLocaleString()
                    .split(",")
                    .slice(0, 1)} at {new Date(quoteData.createdAt).toLocaleString()
                    .split(",")
                    .slice(1, 2)} || Quote updated on:{new Date(quoteData.updatedAt).toLocaleString()
                    .split(",")
                    .slice(0, 1)} at {new Date(quoteData.updatedAt).toLocaleString()
                    .split(",")
                    .slice(1, 2)} || Edit count:{quoteData.edit_count?quoteData.edit_count:0}</Typography>
        <form onSubmit={handleSubmit}>
        
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  label="Header" InputLabelProps={{ shrink: true }} value={quoteData.quote_header} className={classes.textField} onChange={(e) => setquoteData({...quoteData, quote_header:e.target.value})}/>
        <TextField variant="standard"  disabled label="Customer" InputLabelProps={{ shrink: true }} value={quoteData.cust_name} className={classes.textField} />
        <TextField variant="standard"  disabled label="Destination" InputLabelProps={{ shrink: true }} value={quoteData.primary_destination} className={classes.textField} />
        <TextField variant="standard"  disabled label="Adults" InputLabelProps={{ shrink: true }} value={quoteData.number_adults} className={classes.textField} />
        <TextField variant="standard"  disabled label="Child" InputLabelProps={{ shrink: true }} value={quoteData.number_child} className={classes.textField} />
        <TextField variant="standard"  disabled label="Child" InputLabelProps={{ shrink: true }} value={quoteData.child_age} className={classes.textField} />
        </FormGroup>
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  type="date" inputProps={{ min: role=="Admin"?(null):(quoteData.trip_status=="Converted" || quoteData.trip_status=="Closed" || quoteData.trip_status=="Dropped After Booking"?null:fupfinalDate) }} label="Start date" InputLabelProps={{ shrink: true }} value={((quoteData.trip_start_date)===undefined ? "" : quoteData.trip_start_date.split("T")).slice(0,1)} className={classes.textField} onChange={(e)=> changestartdate(e.target.value)}/>
        <TextField variant="standard"  label="Duration" InputLabelProps={{ shrink: true }} value={quoteData.duration} className={classes.textField} onChange={(e)=> setquoteData({...quoteData, duration: e.target.value})}/>
        {role=="Admin" || role=="Product"?(
          <div>
        <FormControlLabel control={<Checkbox color="primary"/>}  checked={quoteData.favorite} label="Set favorite for re-use" onChange={(e)=> setquoteData({...quoteData, favorite: e.target.checked})}/>
        <FormControlLabel control={<Checkbox color="secondary"/>}  checked={quoteData.sample_package} label="Sample?" disabled/>
        </div>
        ):("")}
        <FormControlLabel control={<Checkbox color="primary"/>}  checked={quoteData.option2?1:0} label="Option 2" onChange={(e)=> setquoteData({...quoteData, option2: e.target.checked})}/>
        <FormControlLabel control={<Checkbox color="primary"/>}  checked={quoteData.option3?1:0} label="Option 3" onChange={(e)=> setquoteData({...quoteData, option3: e.target.checked})}/>
        </FormGroup>
        {quoteData.favorite ?
        <FormGroup row className={classes.formgroup}>
        <TextField variant="standard"  label="Identifier" InputLabelProps={{ shrink: true }} value={quoteData.quote_identifier} className={classes.textField} onChange={(e) => setquoteData({...quoteData, quote_identifier:e.target.value})}/>
        </FormGroup>
        :""}

        <Typography variant="h4" align="center" className={classes.headertext}> Flight</Typography>
        {fdtext?<div> <Typography
            variant="h4"
            align="center"
            className={classes.red}
          >
            {" "}
            {fdtext.text}
          </Typography>
          <p
           variant="standard"
          label="Onward Flight"
          fullWidth
                multiline
                rows={4}
          value={fdtext.onward}
          className={classes.textArea}
          ></p>
          <p
           variant="standard"
          label="Return Flight"
          fullWidth
                multiline
                rows={4}
          value={fdtext.return}
          className={classes.textArea}
          ></p>
          </div>
          :""}
     
            {"tbo_flight" in quoteData && quoteData.tbo_flight.length>0?(
                  <div>
                  {quoteData.tbo_flight.map(result=>
                  <div>
                               {/* <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[resultpass.indexOf(result)].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br> */}
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                   <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)/60)} hrs {(gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime))%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} </Typography>
                     <br></br>
                   {/* <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography> */}
                   <hr></hr>
                   <hr></hr>
                   <Button variant="outlined" color="primary" className={classes.smallbutton3} onClick={()=>removeflightfromquote(result, quoteData.tbo_flight.indexOf(result))}>Remove</Button>
                  </div>
                  )}
                  <TextField variant="outlined"  label={"Extra Baggage"}  fullWidth multiline InputLabelProps={{ shrink: true }} value={quoteData.baggage} className={classes.textField9} onChange={(e) => setquoteData({...quoteData, baggage:e.target.value})}/>
                  </div>
                ):("")}
            
                {"travclan_flight" in quoteData && quoteData.travclan_flight.length>0?(
                  <div>
                  {quoteData.travclan_flight.map(result=>
                  <div>
                  <div>
                   
                   <Typography variant="h6" className={classes.black}>Result {quoteData.travclan_flight.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                                    <br></br>
                                  
                                    {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+Math.floor(segment.gT/60)+" hrs"+segment.gT%60+" mins"+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                                  <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result.iR} || Remark: {result.ar} 
                                  </Typography>
                                 <hr></hr>
                                  </div>
                                  <Button variant="outlined" color="primary" className={classes.smallbutton3} onClick={()=>removeflightfromquote(result, quoteData.travclan_flight.indexOf(result))}>Remove</Button>
                   <hr></hr>
                   <hr></hr>
                  
                  </div>
                  )}
                  <TextField variant="outlined"  label={"Extra Baggage"}  fullWidth multiline InputLabelProps={{ shrink: true }} value={quoteData.baggage} className={classes.textField9} onChange={(e) => setquoteData({...quoteData, baggage:e.target.value})}/>
                  </div>
                ):("")}

          
        <Typography variant="h4" align="center" className={classes.headertext}> Day-wise Itinerary</Typography>
        
       {daydata?.map(item => {
                return (
                <Box className={daydata.indexOf(item)%2==0?classes.sec1:classes.sec2} >
            <FormGroup row className={classes.formgroup}>
                
                <TextField variant="standard"  label={item.date?"Date ("+getdaytext(new Date(item.date).getDay())+")":"Date"}  id={daydata.indexOf(item)} type="date" InputLabelProps={{ shrink: true }} value={defaultdate(daydata.indexOf(item))} className={classes.textField} onChange={(e) => daydatechange(e,e.target.id, item.id)}/>
                            
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="city">City</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="city"  name={daydata.indexOf(item)} value={item.city} onChange={(e) => daycitychange(e,e.target.name, item.id)}>
                {cities?.map(city => {
                    return <MenuItem value={city}>{city}</MenuItem>})}
                </Select>
                </FormControl> 
                {tripData.trip_status=="Converted" || tripData.trip_status=="Closed" || tripData.trip_status=="Dropped After Booking"?(
                  <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="tour">{"Tour Name (" + item.tour_id+")"}</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="tour"  name={daydata.indexOf(item)} value={item.tour_name} onChange={(e) => daytourchange(e,e.target.name, item.id)}>
                <MenuItem value={item.tour_name}>{item.tour_id+" - "+item.tour_name}</MenuItem>
               
                
                  {alllisttourData?.filter(tour => tour.tour_city == item.city).map(tour => {
                    return <MenuItem value={tour.tour_name}>{tour.tour_id+" - "+tour.tour_name}</MenuItem>})}
                
                </Select>
                <FormHelperText>{"tour_internal_note" in item?item.tour_internal_note:""}</FormHelperText>
                </FormControl> 
                ):(
                  <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="tour">{"Tour Name (" + item.tour_id+")"}</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="tour"  name={daydata.indexOf(item)} value={item.tour_name} onChange={(e) => daytourchange(e,e.target.name, item.id)}>
                <MenuItem value={item.tour_name}>{item.tour_id+" - "+item.tour_name}</MenuItem>
                
                {listtourData?.filter(tour => tour.tour_city == item.city).map(tour => {
                    return <MenuItem value={tour.tour_name}>{tour.tour_id+" - "+tour.tour_name}</MenuItem>})}
                   
                </Select>
                <FormHelperText>{"tour_internal_note" in item?item.tour_internal_note:""}</FormHelperText>
                </FormControl> 
                )} 
                {/* <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="tour">{"Tour Name (" + item.tour_id+")"}</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="tour"  name={daydata.indexOf(item)} value={item.tour_name} onChange={(e) => daytourchange(e,e.target.name, item.id)}>
                <MenuItem value={item.tour_name}>{item.tour_id+" - "+item.tour_name}</MenuItem>
                {tripData.trip_status=="Converted" || tripData.trip_status=="Closed" || tripData.trip_status=="Dropped After Booking"?(<div>
                
                  {alllisttourData?.filter(tour => tour.tour_city == item.city).map(tour => {
                    return <MenuItem value={tour.tour_name}>{tour.tour_id+" - "+tour.tour_name}</MenuItem>})}
                </div>):(<div>
                {listtourData?.filter(tour => tour.tour_city == item.city).map(tour => {
                    return <MenuItem value={tour.tour_name}>{tour.tour_id+" - "+tour.tour_name}</MenuItem>})}
                    </div>)}
                </Select>
                <FormHelperText>{"tour_internal_note" in item?item.tour_internal_note:""}</FormHelperText>
                </FormControl>  */}
            </FormGroup>

            <FormGroup row className={classes.formgroup}>


            {/* <Autocomplete
      id="country-select-demo"
      sx={{ width: 300 }}
      options={listhotelData}
      value={Value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        inputValue={InputValue}
        // onInputChange={(event, newInputValue) => {
        //   // setInputValue(newInputValue);
        //   dayhotelchange2(event, newInputValue, item.id)
        // }}
      getOptionLabel={(option) => option.hotel_name}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          
          {option.hotel_name} 
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choose a country"
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    /> */}


                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                
                
                <InputLabel id="hotel name">{GetHotelName(item)}</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="hotel name"  name={daydata.indexOf(item)} value={item.hotel_name} onChange={(e) => dayhotelchange(e,e.target.name, item.id)}>
                {/* {recohotellist2
                       
                        .map((data) => {
                          return (
                            <div>
                            <ListSubheader value={data.category}>
                            {data.category}
                            </ListSubheader>
                            {data.hotellist && data.hotellist.length>0 && data.hotellist
                              
                            .map(hotel=>{
                              <div>
                              <MenuItem value={"ABC"}>
                            {data.hotellist.length>0 && "hotel_name" in data.hotellist[0]?data.hotellist[0].hotel_name:"ABC"}
                            </MenuItem>
                              <MenuItem value={hotel.hotel_name}>
                            {gethotelname(hotel)}
                            </MenuItem>
                            </div>
                            })}
                            <MenuItem value={"ABC"}>
                            {data.hotellist.length>0 && "hotel_name" in data.hotellist[0]?data.hotellist[0].hotel_name:"ABC"}
                            </MenuItem>
                            </div>
                          );
                        })} */}
                <ListSubheader>Recommended Hotels</ListSubheader>
                    {recohotellist
                        ?.filter((hotel) => hotel.hotel_city == item.city)
                        .map((hotel) => {
                          return (
                            <MenuItem value={hotel.hotel_name} className={getbenefit(gethotelname(hotel), item.date)?classes.orange:classes.black}>
                            {gethotelname(hotel)}
                            </MenuItem>
                          );
                        })}
                        {recohotellist.length>0 && recohotellist
                          
                          .map(data=>{
                          <div>
                          
                          <ListSubheader>{data.category}</ListSubheader>
                          {data.hotelnames
                            ?.filter((hotel) => hotel.hotel_city == item.city)
                          .map(hotel=>{
                            <MenuItem value={hotel.hotel_name} className={getbenefit(gethotelname(hotel), item.date)?classes.orange:classes.black}>
                           {hotel.hotel_name}
                            </MenuItem>
                          })}
                          </div>
                        })}
                        <ListSubheader>All Hotels</ListSubheader>
                      {listhotelData
                        ?.filter((hotel) => hotel.hotel_city == item.city)
                        .map((hotel) => {
                          return (
                            <MenuItem value={hotel.hotel_name} className={getbenefit(gethotelname(hotel), item.date)?classes.orange:classes.black}>
                            {gethotelname(hotel)}
                            </MenuItem>
                          );
                        })}
                       
                </Select>
                {/* <FormHelperText>{"hotel_internal_notes" in item?helptext[daydata.indexOf(item)]+" || "+item.hotel_internal_notes:helptext[daydata.indexOf(item)]}</FormHelperText> */}
                <FormHelperText>{gethelptext2(daydata.indexOf(item))+" || "+item.hotel_internal_notes}</FormHelperText>
                {/* <FormHelperText>ABC</FormHelperText> */}
                </FormControl>  
                <FormControl style={{minWidth: 360, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="meal">Meal Plan</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="meal"  name={daydata.indexOf(item)} value={item.meal_plan} onChange={(e) => daymealchange(e,e.target.name, item.id)}>
                    <MenuItem value={"No meals"}>No meals</MenuItem>
                    <MenuItem value={"Breakfast"}>Breakfast</MenuItem>
                    <MenuItem value={"Dinner"}>Dinner</MenuItem>
                    <MenuItem value={"Breakfast and Dinner"}>Breakfast and Dinner</MenuItem>  
                    <MenuItem value={"Breakfast and Lunch"}>
                        Breakfast and Lunch
                      </MenuItem>
                      <MenuItem value={"Lunch and Dinner"}>Lunch and Dinner</MenuItem> 
                    <MenuItem value={"Breakfast, Lunch and Dinner"}>Breakfast, Lunch and Dinner</MenuItem>   
                    <MenuItem value={"All Inclusive"}>All Inclusive</MenuItem>   
                </Select>
                </FormControl> 
                {getrc(item.hotel_name)?(<div>
                  <FormControl style={{minWidth: 360, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="room">Room Details</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="room"  name={daydata.indexOf(item)} value={item.room_type} onChange={(e) => dayroomchange(e,e.target.name, item.id)}>
                    {getroomcategoryoptions(item.hotel_name).map(rc=>{
                      return(
                        <MenuItem value={rc}>{rc}</MenuItem> 
                      )
                      })} 
                </Select>
                </FormControl> 
                
                </div>
                ):(
                  <TextField variant="standard" label="Room Details"   id={daydata.indexOf(item)} value={item.room_type} className={classes.textField} onChange={(e) => dayroomchange(e,e.target.id, item.id)}/>
                )}
                 <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="numberroom">Number Rooms</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="numberroom"  name={daydata.indexOf(item)} value={item.number_rooms} onChange={(e) => daynumberroomchange(e,e.target.name, item.id)}>
                        <MenuItem value={0}>0</MenuItem> 
                        <MenuItem value={1}>1</MenuItem> 
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                         <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                           <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                             <MenuItem value={10}>10</MenuItem>
                </Select>
                </FormControl>                
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            {getbenefit(item.hotel_name, item.date)?<p className={classes.redlarge}>{"Extra Benefit: "+getbenefit(item.hotel_name, item.date)}</p>:("")}
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="outlined" disabled label="Start Time"  id={daydata.indexOf(item)} InputLabelProps={{ shrink: true }} value={getStarttime(item)}  className={classes.textField} />
            <TextField variant="outlined" disabled label="End Time"  id={daydata.indexOf(item)} InputLabelProps={{ shrink: true }} value={getEndtime(item)}  className={classes.textField} />
           
              <Button variant="outlined" color="secondary" className={classes.button} onClick={()=>gethotelpics(item)}> Hotel Pics</Button>
         
            
            {/* <TextField variant="outlined" disabled label="Hotel Cost"  id={daydata.indexOf(item)} InputLabelProps={{ shrink: true }} value={getHotelCost(item.hotel_name, item.date)}  className={classes.textField4} />
            <TextField variant="outlined" disabled label="Tour Cost"  id={daydata.indexOf(item)} InputLabelProps={{ shrink: true }} value={getTourCost(item.tour_name)}  className={classes.textField4} /> */}
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined" disabled label="Tour description"  id={daydata.indexOf(item)} InputLabelProps={{ shrink: true }} value={item.tour_description}  className={classes.textArea} fullWidth multiline rows={4}  />
            </FormGroup>
            {quoteData?.option2?(<div>
              <Typography variant="h4" align="center" className={classes.headertext}> Option 2</Typography>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="hotel name2">Hotel Name</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="hotel name2"  name={daydata.indexOf(item)} value={item.hotel_name2} onChange={(e) => dayhotelchange2(e,e.target.name, item.id)}>
                {listhotelData?.filter(hotel => hotel.hotel_city == item.city).map(hotel => {
                    return <MenuItem value={hotel.hotel_name}>{hotel.hotel_name}</MenuItem>})}
                       
                </Select>
                </FormControl>  
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="meal2">Meal Plan</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="meal2"  name={daydata.indexOf(item)} value={item.meal_plan2} onChange={(e) => daymealchange2(e,e.target.name, item.id)}>
                    <MenuItem value={"No meals"}>No meals</MenuItem>
                    <MenuItem value={"Breakfast"}>Breakfast</MenuItem>
                    <MenuItem value={"Dinner"}>Dinner</MenuItem>
                    <MenuItem value={"Breakfast and Dinner"}>Breakfast and Dinner</MenuItem>  
                    <MenuItem value={"Lunch and Dinner"}>Lunch and Dinner</MenuItem>
                    <MenuItem value={"Breakfast, Lunch and Dinner"}>Breakfast, Lunch and Dinner</MenuItem>   
                    <MenuItem value={"All Inclusive"}>All Inclusive</MenuItem>   
                </Select>
                </FormControl> 
                <TextField variant="standard" label="Room Details"   id={daydata.indexOf(item)} value={item.room_type2} className={classes.textField} onChange={(e) => dayroomchange2(e,e.target.id, item.id)}/>
            </FormGroup></div>):("")}
            {quoteData?.option3?(<div>
              <Typography variant="h4" align="center" className={classes.headertext}> Option 3</Typography>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="hotel name3">Hotel Name</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="hotel name3"  name={daydata.indexOf(item)} value={item.hotel_name3} onChange={(e) => dayhotelchange3(e,e.target.name, item.id)}>
                {listhotelData?.filter(hotel => hotel.hotel_city == item.city).map(hotel => {
                    return <MenuItem value={hotel.hotel_name}>{hotel.hotel_name}</MenuItem>})}
                       
                </Select>
                </FormControl>  
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
                <InputLabel id="meal3">Meal Plan</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="meal3"  name={daydata.indexOf(item)} value={item.meal_plan3} onChange={(e) => daymealchange3(e,e.target.name, item.id)}>
                    <MenuItem value={"No meals"}>No meals</MenuItem>
                    <MenuItem value={"Breakfast"}>Breakfast</MenuItem>
                    <MenuItem value={"Lunch"}>Lunch</MenuItem>
                    <MenuItem value={"Dinner"}>Dinner</MenuItem>
                    <MenuItem value={"Breakfast and Dinner"}>Breakfast and Dinner</MenuItem>  
                    <MenuItem value={"Lunch and Dinner"}>Lunch and Dinner</MenuItem>
                    <MenuItem value={"Breakfast, Lunch and Dinner"}>Breakfast, Lunch and Dinner</MenuItem>   
                    <MenuItem value={"All Inclusive"}>All Inclusive</MenuItem>   
                </Select>
                </FormControl> 
                <TextField variant="standard" label="Room Details"   id={daydata.indexOf(item)} value={item.room_type3} className={classes.textField} onChange={(e) => dayroomchange3(e,e.target.id, item.id)}/>
            </FormGroup></div>):("")}
            <FormGroup row className={classes.formgroup}>
            <Button variant="outlined" color="primary"  className={classes.smallbutton} onClick={()=>addmid(daydata.indexOf(item))}> + Day</Button>
                <Button variant="outlined" color="secondary" className={classes.smallbutton} onClick={()=>removemid(item)}> - Day</Button>
            </FormGroup>
                <Typography variant="h4" align="center" className={classes.headertext}> ------------------------------------------------------------------------------------------- </Typography>
            </Box>
            )})}
           
            <FormGroup row className={classes.formgroup}>
                
                <Button variant="outlined" color="primary"  className={classes.button} onClick={addday}> + Tranche</Button>
                <Button variant="outlined" color="secondary" className={classes.button} onClick={removeday}> - Tranche</Button>
              
            </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> Price Information</Typography>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Airfare (number)"  disabled value={"airfare" in price? Math.round(price.airfare):0} className={classes.textField} onChange={(e) => setprice({...price, airfare:e.target.value})}/>
            <TextField variant="standard"  label="land (number)" disabled value={price?.landprice ===undefined ? 0 :(quoteData.quote_discount?(price.landprice-quoteData.quote_discount):price.landprice)} className={classes.textField} onChange={(e) => setprice({...price, landprice:e.target.value})}/>
            <TextField variant="standard"   disabled label="Other Items(number)" value={price?.otheritems ===undefined ? 0 :price.otheritems} className={classes.textField} onChange={(e) => setprice({...price, otheritems:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  disabled label="Taxes (number)" value={"landprice" in price?("coupon" in quoteData && quoteData.coupon.length>0 && getcouponstatus(quoteData.coupon[quoteData.coupon.length-1],quoteData.coupon.length-1 )=="Active" && quoteData.quote_discount?Math.round((price.landprice-quoteData.quote_discount)*0.05):Math.round(price.landprice*0.05)):0} className={classes.textField} onChange={(e) => setprice({...price, taxes:e.target.value})}/>
            <TextField variant="standard"  disabled label="TCS (number)" value={"coupon" in quoteData && quoteData.coupon.length>0 &&getcouponstatus(quoteData.coupon[quoteData.coupon.length-1],quoteData.coupon.length-1 )=="Active" && quoteData.quote_discount?gettcs():gettcs()} className={classes.textField} />
            <TextField variant="standard"  disabled label="Total (number)" value={price?.total ===undefined ? 0 : ("coupon" in quoteData && quoteData.coupon.length>0 &&getcouponstatus(quoteData.coupon[quoteData.coupon.length-1],quoteData.coupon.length-1 )=="Active" && quoteData.quote_discount?Math.round(parseInt(price.airfare)+parseInt(price.landprice)-quoteData.quote_discount+parseInt(price.otheritems)+(parseInt(price.landprice)-quoteData.quote_discount)*0.05):Math.round(parseInt(price.airfare)+parseInt(price.landprice)+parseInt(price.otheritems)+parseInt(price.landprice)*0.05))} className={classes.textField} />
            
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            
            <TextField variant="standard"  label="Per Adult (number)" value={price?.perperson ===undefined ? 0 :price.perperson} className={classes.textField} onChange={(e) => setprice({...price, perperson:e.target.value})}/>
            <TextField variant="standard"  label="Per Child (CWB) (number)" value={price?.percwb ===undefined ? 0 :price.percwb} className={classes.textField} onChange={(e) => setprice({...price, percwb:e.target.value})}/>
            <TextField variant="standard"  label="Per Child (CNB) (number)" value={price?.percnb ===undefined ? 0 :price.percnb} className={classes.textField} onChange={(e) => setprice({...price, percnb:e.target.value})}/>
            </FormGroup>
        
            {quoteData?.option2?(<div>
              <FormGroup row className={classes.formgroup}>
              <TextField variant="standard"  label="Option 2 land (number)" value={price?.landprice2 ===undefined ? 0 :price.landprice2} className={classes.textField} onChange={(e) => setprice({...price, landprice2:e.target.value})}/>
              <TextField variant="standard"  disabled label="Taxes (number)" value={price?.landprice2 ===undefined ? 0 :price.landprice2*0.05} className={classes.textField} />
              <TextField variant="standard"  disabled label="TCS (number)" value={gettcs2()} className={classes.textField} />
              </FormGroup>
              </div>):("")}
              {quoteData?.option3?(<div>
                <FormGroup row className={classes.formgroup}>
              <TextField variant="standard"  label="Option 3 land (number)" value={price?.landprice3 ===undefined ? 0 :price.landprice3} className={classes.textField} onChange={(e) => setprice({...price, landprice3:e.target.value})}/>
              <TextField variant="standard"  disabled label="Taxes (number)" value={price?.landprice3 ===undefined ? 0 :price.landprice3*0.05} className={classes.textField} />
              <TextField variant="standard"  disabled label="TCS (number)" value={gettcs3()} className={classes.textField} />
              </FormGroup>
              </div>):("")}
              
            <FormGroup row className={classes.formgroup}>
            <TextField disabled variant="standard"  label="Promo Code" InputLabelProps={{ shrink: true }} value={"coupon" in quoteData && quoteData.coupon.length>0?quoteData.coupon[quoteData.coupon.length-1].code:""} className={classes.textField}  />
            <TextField disabled variant="standard"  label="Discount (number)" InputLabelProps={{ shrink: true }} value={"coupon" in quoteData && quoteData.coupon.length>0?quoteData.coupon[quoteData.coupon.length-1].amount:""} className={classes.textField} />
            <TextField disabled variant="standard"  label="Status" InputLabelProps={{ shrink: true }} value={"coupon" in quoteData && quoteData.coupon.length>0?getcouponstatus(quoteData.coupon[quoteData.coupon.length-1],quoteData.coupon.length-1 ):"" } className={classes.textField} />
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Customer Notes"  InputLabelProps={{ shrink: true }} value={quoteData.cust_notes} className={classes.textArea} fullWidth multiline rows={6} onChange={(e) => setquoteData({...quoteData, cust_notes:e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Inclusions"  InputLabelProps={{ shrink: true }} value={quoteData.inclusions} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, inclusions:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Exclusions"  InputLabelProps={{ shrink: true }} value={quoteData.exclusions} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, exclusions:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Terms & Conditions"  InputLabelProps={{ shrink: true }} value={quoteData.tnc} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, tnc:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Cancellation Policy"  InputLabelProps={{ shrink: true }} value={quoteData.cancellation_policy} className={classes.textArea} fullWidth multiline rows={5} onChange={(e) => setquoteData({...quoteData, cancellation_policy:e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Internal Notes"  InputLabelProps={{ shrink: true }} value={quoteData.internal_notes} className={classes.textArea} fullWidth multiline rows={2} onChange={(e) => setquoteData({...quoteData, internal_notes:e.target.value})}/>
            </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> Cost Price Calculation</Typography>
            <FormGroup row className={classes.formgroup}>
            <TextField disabled variant="standard"  label="Airfare (number)" value={costprice?.airfare} className={classes.textField} onChange={(e) => setcostprice({...costprice, airfare:(e.target.value)})}/>
            <TextField disabled variant="standard"  label="land (number)" value={costprice?.landprice ===undefined ? 0 :costprice.landprice} className={classes.textField} onChange={(e) => setcostprice({...costprice, landprice:(e.target.value)})}/>
            <TextField disabled variant="standard"  label="Other Items(number)" value={costprice?.otheritems} className={classes.textField} onChange={(e) => setcostprice({...costprice, otheritems:e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            {/* <TextField variant="standard"  label="Taxes (number)" value={costprice?.taxes} className={classes.textField} onChange={(e) => setcostprice({...costprice, taxes:e.target.value})}/> */}
            {/* <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="profittype">Profit calc Type</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="profittype"
            value={costprice?.profit_type}
              onChange={(e) =>
                setcostprice({ ...costprice, profit_type: e.target.value })
              }
            >
              <MenuItem value={"Value"}>Value</MenuItem>
              <MenuItem value={"Percentage"}>Percentage</MenuItem>
            </Select>
          </FormControl>
            <TextField variant="standard"  label="Profit (number)" value={costprice?.profit} className={classes.textField} onChange={(e) => setcostprice({...costprice, profit:e.target.value})}/>
            <TextField variant="standard"  disabled label="Total (number)" 
            value={costprice?.profit_type=="Value"?(parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes)+parseInt(costprice?.profit)):
            (((parseInt(costprice?.airfare)+parseInt(costprice?.landprice)+parseInt(costprice?.otheritems)+parseInt(costprice?.taxes))*(1+(costprice?.profit)/100)))
            } className={classes.textField} /> */}
            {quoteData?.option2?(<div>
              <TextField variant="standard"  label="Option 2 land (number)" value={costprice?.landprice2 ===undefined ? 0 :costprice.landprice2} className={classes.textField} onChange={(e) => setcostprice({...costprice, landprice2:e.target.value})}/>
              </div>):("")}
              {quoteData?.option3?(<div>
              <TextField variant="standard"  label="Option 3 land (number)" value={costprice?.landprice3 ===undefined ? 0 :costprice.landprice3} className={classes.textField} onChange={(e) => setcostprice({...costprice, landprice3:e.target.value})}/>
              </div>):("")}
            </FormGroup>
            
            <FormGroup row className={classes.formgroup}>
            <Typography variant="h6" align="center" className={classes.headertext}> USD to INR: {oldcurrency?.usd_inr} || SGD to INR: {oldcurrency?.sgd_inr} || AED to INR:{oldcurrency?.aed_inr} || THB to INR:{oldcurrency?.thb_inr} || IDR to INR:{oldcurrency?.idr_inr} || EUR to INR:{oldcurrency?.eur_inr}</Typography>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  label="Value in currency" className={classes.textField} onChange={(e) => setcurrency({...currency, currency_value:e.target.value})}/>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="choosecurrency">Choose Currency</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="choosecurrency"
            value={currency?.currency_name}
              onChange={(e) =>
                setcurrency({ ...currency, currency_name: e.target.value })
              }
            >
              <MenuItem value={"USD"}>USD</MenuItem>
              <MenuItem value={"SGD"}>SGD</MenuItem>
              <MenuItem value={"THB"}>THB</MenuItem>
              <MenuItem value={"AED"}>AED</MenuItem>
              <MenuItem value={"IDR"}>IDR</MenuItem>
            </Select>
          </FormControl>
            <Button variant="contained" color="primary" className={classes.button} onClick={(e) =>getER(e)}>Convert</Button>
            <TextField variant="standard"  InputLabelProps={{ shrink: true }} label="Value in INR" value={currency?.newvalue} className={classes.textField}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href={"/tripdataentry/"+quoteData.trip_id} variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                <Button onClick={viewquote} variant="contained" color="inherit" className={classes.button}>View Quote</Button>
            </FormGroup>
        </form>
        </Paper>
      )}
        <Dialog fullWidth maxWidth="xl" open={Open4} onClose={handleClose4}>
        <a
          href="https://docs.google.com/spreadsheets/d/19Wf3-D1hW-SILdEip0F6Gf9ypBlBIUxWQX2xFwYX1J8"
          rel="noopener noreferrer"
          target="_blank"
          variant="h6"
          align="center"
          className={classes.headertext}
        >
          {" "}
          Doc Link for Airport codes
        </a>
        <form onSubmit={handleSubmit2}>
        <FormGroup row className={classes.formgroup}>
                
        <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Adults"># Adults (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Adults (12+ years)"
                required
                variant="outlined"
                value={searchData.number_adults}
                onChange={(e) => setsearchData({...searchData, number_adults:e.target.value})}
              >
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Child"># Child/Infant (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Child (2-12 years)"
                required
                variant="outlined"
                value={searchData.number_child}
                onChange={(e) => setsearchData({...searchData, number_child:e.target.value})}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Infant"># Infant (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Infant (0-1 years)"
                required
                variant="outlined"
                value={searchData.number_infant}
                onChange={(e) => setsearchData({...searchData, number_infant:e.target.value})}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
                
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                
                
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Type</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="Journey Type"
                        required
                        variant="outlined"
                        value={searchData.type}
                        onChange={(e) => controlleg(e.target.value)}
                      >
                        <MenuItem value={"One-way"}>One-way</MenuItem>
                        <MenuItem value={"Return"}>Return</MenuItem>
                        <MenuItem value={"Multi-stop"}>Multi-stop</MenuItem>
                        <MenuItem value={"Advanced Search"}>Advanced Search</MenuItem>
                        <MenuItem value={"Special Return"}>Special Return</MenuItem>
                       
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="Stops"
                        required
                        variant="outlined"
                        value={searchData.stops}
                        onChange={(e) => setsearchData({...searchData, stops:e.target.value})}
                      >
                        <MenuItem value={0}>0 </MenuItem>
                        <MenuItem value={1}>1 </MenuItem>
                        <MenuItem value={"Any"}>Any </MenuItem>
                        
                      </Select>
                    </FormControl>
                        
                    </FormGroup>
                    <hr></hr>
                    {airportdata.length>0 && airportdata.map(leg => {
            return(
            <div>
            <FormGroup row className={classes.formgroup}>
            <Typography className={classes.textField6}>{"Leg "+(airportdata.indexOf(leg)+1)}</Typography>
            
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Source">From</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField6}
                labelId="Source"
                required
                name={airportdata.indexOf(leg)}
                variant="outlined"
                value={leg.source}
                onChange={(e) => sourcechange(e, e.target.name, leg.id)}
              >
                {airportlist2.map(data=>
                    <MenuItem value={data.city}>{data.city}</MenuItem>
                  )}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Destination">To</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField6}
                labelId="Destination"
                name={airportdata.indexOf(leg)}
                variant="outlined"
                value={leg.dest}
                onChange={(e) => destchange(e, e.target.name, leg.id)}
              >
                {airportlist2.map(data=>
                    <MenuItem value={data.city}>{data.city}</MenuItem>
                  )}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              type="date"
              name={airportdata.indexOf(leg)}
              inputProps={{ min: airportdata[airportdata.indexOf(leg)-1] && "date" in airportdata[airportdata.indexOf(leg)-1]?airportdata[airportdata.indexOf(leg)-1].date:fupfinalDate2 }}
              label="Date"
              required
              value={leg.date}
              className={classes.textField6}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => datechange(e, e.target.name, leg.id)
              }
            />
            
                    </FormGroup>
                    <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Cabin Class</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Cabin Class"
                        required
                        variant="outlined"
                        value={leg.cabin_class}
                        onChange={(e) => classchange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        <MenuItem value={"Economy"}>Economy </MenuItem>
                        <MenuItem value={"Premium Economy"}>Premium Economy </MenuItem>
                        <MenuItem value={"Business"}>Business </MenuItem>
                        <MenuItem value={"Premium Business"}>Premium Business </MenuItem>
                        <MenuItem value={"First"}>First </MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Departure Time"
                        required
                        variant="outlined"
                        value={leg.departure_time}
                        onChange={(e) => departurechange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"Morning"}>Morning</MenuItem>
                        <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                        <MenuItem value={"Evening"}>Evening</MenuItem>
                        <MenuItem value={"Night"}>Night</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Ariival Time"
                        required
                        variant="outlined"
                        value={leg.arrival_time}
                        onChange={(e) => arrivalchange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"Morning"}>Morning</MenuItem>
                        <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                        <MenuItem value={"Evening"}>Evening</MenuItem>
                        <MenuItem value={"Night"}>Night</MenuItem>
                      </Select>
                    </FormControl>
                    
          </FormGroup>
    
           
            </div>)
          })}
           <FormGroup row className={classes.formgroup}>
           {control?(<div>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addsp}
            >
              {" "}
              + Leg
            </Button>
            
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removesp}
              
            >
              {" "}
              - Leg
            </Button>
           </div>):("")}
             
                <Button variant="contained" color="primary" onClick={TCFlightSearch} className={classes.button}>Search</Button>
                
            </FormGroup>
            </form>
            <br></br>
            <hr></hr>
            <hr></hr>
            {status === "Normal" ? (
              ""
            ) : (
              <div>
                {status == "searching" ? (
                  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
            <LinearProgress color="secondary" />
            <LinearProgress color="primary" />
            <LinearProgress color="inherit" />
          </Stack>
                ) : (<div>
                {resultpass && resultpass.length>0?(
                  <Typography variant="h4" className={classes.red}>Selected Flights</Typography>
                ):("")}  
                {resultpass && resultpass.length>0?(
                  <div>
                  {resultpass.map(result=>
                  <div>
                               <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[resultpass.indexOf(result)].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                 
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)/60)} hrs {gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <hr></hr>
                   <hr></hr>
                  </div>
                  )}
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>prebook()}
                    
                    className={classes.button}
                  >
                    Proceed
                  </Button>
                  </div>
                ):("")}
                {searchResponse && "Results" in searchResponse?(<div>
                  <FormGroup row className={classes.formgroup}>
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Airline</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="airline"
                        variant="outlined"
                        value={filterData.airline}
                        onChange={(e) => setfilterData({...filterData, airline:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                       {airlinelist2.map((airline)=>
                       <MenuItem value={airline}>{airline}</MenuItem>
                        )}
                       
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData.departure}
                        onChange={(e) => setfilterData({...filterData, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData.arrival}
                        onChange={(e) => setfilterData({...filterData, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Multi-Airline</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="multi"
               
                        variant="outlined"
                        value={filterData.multi}
                        onChange={(e) => setfilterData({...filterData, multi:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"Yes"}>Yes</MenuItem>
                        <MenuItem value={"No"}>No</MenuItem>
                        
                      </Select>
                    </FormControl>
                  </FormGroup>
                  
                  {/* {searchData && "type" in searchData && searchData.type == "Multi-stop"?(""):(
                    <FormGroup row className={classes.formgroup}> 
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Duration</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Duration"
               
                        variant="outlined"
                        value={filterData.duration}
                        onChange={(e) => setfilterData({...filterData, duration:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Stops"
               
                        variant="outlined"
                        value={filterData.stops}
                        onChange={(e) => setfilterData({...filterData, stops:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Baggage</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Baggage"
               
                        variant="outlined"
                        value={filterData.baggage}
                        onChange={(e) => setfilterData({...filterData, baggage:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                       <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stopover</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Stopover"
                    
                        variant="outlined"
                        value={filterData.stopover}
                        onChange={(e) => setfilterData({...filterData, stopover:e.target.value})}
                      >
                     
                     <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  )} */}
                  {/* {searchData && "type" in searchData && searchData.type == "Return" && searchResponse && "Results" in searchResponse && searchResponse.Results.length==1?(
                    <div>
                    <hr></hr>
                    <h3>For return flights:</h3>
                    <FormGroup row className={classes.formgroup}>
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData2.departure}
                        onChange={(e) => setfilterData2({...filterData2, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData2.arrival}
                        onChange={(e) => setfilterData2({...filterData2, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Duration</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Duration"
               
                        variant="outlined"
                        value={filterData2.duration}
                        onChange={(e) => setfilterData2({...filterData2, duration:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                    
                  </FormGroup>
                  <FormGroup row className={classes.formgroup}> 
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Stops"
               
                        variant="outlined"
                        value={filterData2.stops}
                        onChange={(e) => setfilterData2({...filterData2, stops:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Baggage</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Baggage"
               
                        variant="outlined"
                        value={filterData2.baggage}
                        onChange={(e) => setfilterData2({...filterData2, baggage:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                       <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stopover</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Stopover"
                    
                        variant="outlined"
                        value={filterData2.stopover}
                        onChange={(e) => setfilterData2({...filterData2, stopover:e.target.value})}
                      >
                     
                     <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>
                  </div>
                  ):("")} */}
                
                  {/* <FormGroup row className={classes.formgroup}>    
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={filterresults}
                    
                    className={classes.button}
                  >
                    Filter
                  </Button>
                   </FormGroup> */}
                  { searchResponse.ResponseStatus==1 ?(<div>
              
              {"Results" in searchResponse && searchResponse.Results.length==1?(<div>
                {searchResponse.Results[0].map(result => <div>
                  <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[0].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {"FareBreakdown" in result && result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
             
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)/60)} hrs {gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {getprice(result.Fare)} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>farerule(result)}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                  {result.IsLCC?(<Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>showssr(result, searchResponse.Results[0].indexOf(result))}
                    
                    className={classes.button}
                  >
                    Fetch Baggage
                  </Button>):("")}
                  
                  </FormGroup>
                  {identifier && identifier.index==searchResponse.Results[0].indexOf(result) && identifier.resultindex==searchResponse.Results[0][searchResponse.Results[0].indexOf(result)].ResultIndex?(
                    <div>
                    {ssrstatus=="Searching"?(
              <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
            ):(<div>
              {ssrstatus=="Completed"?(
                <div>
                {ssrResponse && "Baggage" in ssrResponse?(<div>
                  {ssrResponse.Baggage.map(b=><div>
              {b.map(bg=>
             <Table>
             <TableRow>
              <TableCell>
              <Typography variant="h6" className={classes.black}>{bg.Origin} to {bg.Destination} ({bg.AirlineCode})|| {bg.Weight} kgs -- {bg.Currency} {bg.Price} ({"Text" in bg?bg.Text:""})</Typography>
              </TableCell>
              <TableCell>
              {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>selectbaggage(bg, result, searchResponse.Results[0].indexOf(result))}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
              </TableCell>
             </TableRow>
                </Table>)}
            </div>)}
                </div>):(<div>No Baggage SSR</div>)}
                </div>
              ):("")}
            </div>)}
                    </div>
                  ):("")}
            
                  <hr></hr>
                </div>)}
              </div>):
              searchResponse.Results.length>1?(<div>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="basic tabs example"
      centered
    >
      <Tab label="Segment 1" {...a11yProps(0)} />
      {searchResponse.Results.length> 1 ?
      <Tab label="Segment 2" {...a11yProps(1)} />:""}
      {searchResponse.Results.length> 2 ?
      <Tab label="Segment 3" {...a11yProps(2)} />:""}
      {searchResponse.Results.length> 3 ?
      <Tab label="Segment 4" {...a11yProps(3)} />:""}
      {searchResponse.Results.length> 4 ?
      <Tab label="Segment 5" {...a11yProps(4)} />:""}
      {/* <Tab label="Sightseeing Descriptions" {...a11yProps(2)} /> */}
    </Tabs>
  </Box>
  <TabPanel value={value} index={0}>
  {searchResponse.Results[0].map(result=><div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[0].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     {"FareBreakdown" in result ?(<Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>):(<div></div>)}
                     
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage}  || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)/60)} hrs {gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {"FareBreakdown" in result?getprice(result.Fare):""} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>farerule(result)}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                  {result.IsLCC?(<Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>showssr(result, searchResponse.Results[0].indexOf(result))}
                    
                    className={classes.button}
                  >
                    Fetch Baggage
                  </Button>):("")}
                  </FormGroup>
                  {identifier && identifier.index==searchResponse.Results[0].indexOf(result) && identifier.resultindex==searchResponse.Results[0][searchResponse.Results[0].indexOf(result)].ResultIndex?(
                    <div>
                    {ssrstatus=="Searching"?(
              <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
            ):(<div>
              {ssrstatus=="Completed"?(
                <div>
                {ssrResponse && "Baggage" in ssrResponse?(<div>
                  {ssrResponse.Baggage.map(b=><div>
              {b.map(bg=>
             <Table>
             <TableRow>
              <TableCell>
              <Typography variant="h6" className={classes.black}>{bg.Origin} to {bg.Destination} ({bg.AirlineCode})|| {bg.Weight} kgs -- {bg.Currency} {bg.Price} ({"Text" in bg?bg.Text:""})</Typography>
              </TableCell>
              <TableCell>
              {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>selectbaggage(bg, result, searchResponse.Results[0].indexOf(result))}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
              </TableCell>
             </TableRow>
                </Table>)}
            </div>)}
                </div>):(<div>No Baggage SSR</div>)}
                </div>
              ):("")}
            </div>)}
                    </div>
                  ):("")}
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={1}>
  {searchResponse.Results.length> 1 && searchResponse.Results[1].map(result=><div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.Results[1].indexOf(result)+1} (LCC: {result.IsLCC?"True":"False"} || GST Mandatory: {result.IsGSTMandatory?"True":"False"} || PAN Mandatory: {result.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {result.IsPassportRequiredAtTicket?"True":"False"})</Typography>
                     <br></br>
                     {"FareBreakdown" in result ?(
                     <Typography variant="h6" className={classes.purple}>
                     {result.FareBreakdown.length==1?"Adults: "+result.FareBreakdown[0].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==2?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==2 && result.FareBreakdown[1].PassengerType==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Infant: "+result.FareBreakdown[1].PassengerCount:result.FareBreakdown.length==3?"Adults: "+result.FareBreakdown[0].PassengerCount+" || Child: "+result.FareBreakdown[1].PassengerCount+" || Infant: "+result.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                     ):("")}
                   <br></br>
                   
                  {result.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.floor((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} {getduration(segment)}
                   </Typography>
                   {/* <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography> */}
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} --------------------- {"> "+details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} -------------------- {"> "+new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)/60)} hrs {gettimediff(details.Origin.Airport.CityName, details.Origin.DepTime, details.Destination.Airport.CityName, details.Destination.ArrTime)%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                     
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {"FareBreakdown" in result?getprice(result.Fare):""} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Airline: {result.AirlineCode} || Remark: {result.AirlineRemark} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>farerule(result)}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                  {result.IsLCC?(<Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>showssr(result, searchResponse.Results[1].indexOf(result))}
                    
                    className={classes.button}
                  >
                    Fetch Baggage
                  </Button>):("")}
                  </FormGroup>
                  {identifier && identifier.index==searchResponse.Results[1].indexOf(result) && identifier.resultindex==searchResponse.Results[1][searchResponse.Results[1].indexOf(result)].ResultIndex?(
                    <div>
                    {ssrstatus=="Searching"?(
              <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
            ):(<div>
              {ssrstatus=="Completed"?(
                <div>
                {ssrResponse && "Baggage" in ssrResponse?(<div>
                  {ssrResponse.Baggage.map(b=><div>
              {b.map(bg=>
             <Table>
             <TableRow>
              <TableCell>
              <Typography variant="h6" className={classes.black}>{bg.Origin} to {bg.Destination} ({bg.AirlineCode})|| {bg.Weight} kgs -- {bg.Currency} {bg.Price} ({"Text" in bg?bg.Text:""})</Typography>
              </TableCell>
              <TableCell>
              {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>selectbaggage(bg, result, searchResponse.Results[0].indexOf(result))}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
              </TableCell>
             </TableRow>
                </Table>)}
            </div>)}
                </div>):(<div>No Baggage SSR</div>)}
                </div>
              ):("")}
            </div>)}
                    </div>
                  ):("")}
                  
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>

  
  
              </div>):(<div></div>)}
            </div>):(<div>
              { searchResponse.ResponseStatus==3 || searchResponse.ResponseStatus==2?(<div>
                {searchResponse.Error.ErrorMessage}
              </div>):(<div></div>)}
            </div>)}
                </div>):(<div>
                  <h2>Waiting for response</h2>
                </div>)}

                </div>)} 
                </div>)}
      </Dialog>
        <Dialog fullWidth maxWidth="xl" open={Open7} onClose={handleClose7}>
      {hotellist.length>0?(<div>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="hotel">Select Hotel:</InputLabel>
          <Select
            className={classes.textField}
            labelId="hotel"
            value={hsData.hotel_name}
            onChange={(e) => changehotel(e.target.value)}
          >
          {hotellist.map(h=>
            <MenuItem id={hotellist.indexOf(h)} value={h}>{h}</MenuItem>
          )}
            
          </Select>
        </FormControl>
      </div>):("No hotels found")}
      {"hotel_name" in hsData?(<div>
        {"hotel_id" in hsData?(<div>
        <Typography variant="h4" align="center" className={classes.headertext}>Search Parameters</Typography>
        <Typography variant="h6" className={classes.headertext}>Hotel Name: {hsData.hotel_name} ({hsData.hotel_id})</Typography>
        <Typography variant="h6" className={classes.headertext}>Place: {hsData.dest} ({hsData.city})</Typography>
        <Typography variant="h6" className={classes.headertext}>Check-In Date: {String(hsData.start_date).slice(0,15)} || Check-Out Date: {String(hsData.end_date).slice(0,15)}</Typography>
        <Typography variant="h4" align="center" className={classes.headertext}>Rooms</Typography>
        {hsData.rooms.map(room=>
        <div>
        <Typography variant="h6" className={classes.headertext}>Room {hsData.rooms.indexOf(room)+1}:</Typography>
          <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Adults"># Adults (number)</InputLabel>
              <Select
                classname={classes.textField}
                labelId="Adults"
                name={hsData.rooms.indexOf(room)}
                variant="outlined"
                value={room.number_adults}
                onChange={(e) => adultschange(e, e.target.name, room.id)}
              >
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Child"># Child (number)</InputLabel>
              <Select
                classname={classes.textField}
                labelId="Child"
                name={hsData.rooms.indexOf(room)}
                variant="outlined"
                value={room.number_child}
                onChange={(e) => childchange(e, e.target.name, room.id)}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
              </Select>
            </FormControl>
            {"childnumber" in room && room.childnumber.length > 0?(<div>
              <FormGroup row>
            {room.childnumber.map((child) => (
              <FormControl
                style={{
                  minWidth: 100,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 32,
                }}
              >
                <InputLabel>
                  Age of child {room.childnumber.indexOf(child) + 1}
                </InputLabel>
                <Select
                  displayEmpty
                  required
                  classname={classes.textField}
                  variant="outlined"
                  name={hsData.rooms.indexOf(room)}
                  value={child.age}
                  onChange={(e) =>
                    childage(e.target.value, e.target.name, room.childnumber.indexOf(child), room.id)
                  }
                >
                  <MenuItem value={2}>2 </MenuItem>
                  <MenuItem value={3}>3 </MenuItem>
                  <MenuItem value={4}>4 </MenuItem>
                  <MenuItem value={5}>5 </MenuItem>
                  <MenuItem value={6}>6 </MenuItem>
                  <MenuItem value={7}>7 </MenuItem>
                  <MenuItem value={8}>8 </MenuItem>
                  <MenuItem value={9}>9 </MenuItem>
                  <MenuItem value={10}>10 </MenuItem>
                  <MenuItem value={11}>11 </MenuItem>
                  
                </Select>
              </FormControl>
            ))}
          </FormGroup>
            </div>):("")}
         
          </div>
        )}
        <div align="center">
        <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={searchhotel}
            >
              Search
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={handleClose7}
            >
              Cancel
            </Button>
            </div>
      </div>):("Could not find hotel data. Search manually")}
      </div>):("")}
      
      {status == "Loading" ? (
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
          ) : (
            <div>
            {status == "error" ?(<div>
              <h2>IP Address Error {responseData.error}</h2>
            </div>):(
              <div>
            <FormControl
                    style={{
                      minwidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="mealplan">Meal Plan</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="mealplan"
                      variant="outlined"
                      value={filterData.mealplan}
                      onChange={(e) =>
                        setfilterData({ ...filterData, mealplan: e.target.value })
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      <MenuItem value="">Clear</MenuItem>
                      <MenuItem value={"Only Breakfast"}>Only Breakfast</MenuItem>
                      <MenuItem value={"Half Board"}>Half Board</MenuItem>
                      <MenuItem value={"Full Board"}>Full Board</MenuItem>
                      <MenuItem value={"All Inclusive"}>All Inclusive</MenuItem>
                      <MenuItem value={"Room Only"}>Room Only</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={filterrooms}
                    
                    className={classes.button}
                  >
                    Filter
                  </Button>
            {hotelData && hotelData.length>0?(<div>
              {hotelData.map((hotel) => (
                      <div>
                        <Table>
                          <TableHead>
                            <TableCell>
                              <Typography>
                                {" "}
                                {hotelData.indexOf(hotel) + 1}. {hotel.Name} (
                                {hotel.Rating})
                              </Typography>
                            </TableCell>
                          </TableHead>

                          {/* {showid.includes(hotelData.indexOf(hotel)) ? (
                            <div> */}
                            {Array.isArray(hotel.RoomDetails.RoomDetail)?(
                              <div>
                              {hotel.RoomDetails.RoomDetail.map((rd) => (
                                <div>
                                  <TableRow>
                                    <TableCell width={width / 2}>
                                      {"Type" in rd && rd.Type.includes("|")?(rd.Type.split("|").map(t=><p>{t}</p>)):rd.Type}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                    {String(rd.TotalRate).includes("|")?"INR "+calccost(rd.TotalRate):"INR "+Math.round(rd.TotalRate*oldcurrency.usd_inr)}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                      {"BoardBasis" in rd && rd.BoardBasis.includes("|")?rd.BoardBasis.replaceAll("|","\n"):rd.BoardBasis}
                                    </TableCell>
                                    <TableCell width={width / 6}>
                                      {"RoomDescription" in rd && rd.RoomDescription.includes("|")?rd.RoomDescription.replaceAll("|","\n"):rd.RoomDescription}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                      {"CancellationPolicy" in rd && "Refundable" in rd.CancellationPolicy && rd.CancellationPolicy.Refundable == "Yes"
                                        ? "Refundable"
                                        : ""}
                                      {"CancellationPolicy" in rd && "TillDate" in rd.CancellationPolicy
                                        ? " till "+rd.CancellationPolicy.TillDate
                                        : ""}
                                    </TableCell>
                                    {/* <TableCell width={width/10}>
        {rd.ChildrenAges.map(cp=>
<div>
  {cp.name} {cp.value}
</div>
        )}
        </TableCell> */}
                                    <TableCell width={width / 8}>
                                      A:{rd.Adults} C:{rd.Children}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                    {/* <Link to={{pathname:"/hotelbook",state:{hotels:hotelData,hotel:hotel,rd:rd},}} target="_blank"> */}
                                    {/* <Link to={{pathname:"/hotelbook",state:{data:"ABC"}}}> */}
                                       <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={e=>replacehotel(e, rd, hotel)}
                                        className={classes.button2}
                                      >
                                        Replace
                                      </Button>
                                      </TableCell>
                                      <TableCell width={width / 12}>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={e=>usehotel(e, rd, hotel)}
                                        className={classes.button2}
                                      >
                                        Use
                                      </Button> 
                                      </TableCell>
                                      <TableCell width={width / 12}>
                                      <Button
                                        variant="contained"
                                        color="inherit"
                                        onClick={e=>getcp(e, rd, hotel)}
                                        className={classes.button2}
                                      >
                                        Get CP
                                      </Button> 
                                      {/* </Link> */}
                                    </TableCell>
                                  </TableRow>
                                </div>
                              ))}
                              </div>
                            ):(
                              <div>
                              <TableRow>
                                    <TableCell width={width / 2}>
                                      {hotel.RoomDetails.RoomDetail.Type.includes("|")?hotel.RoomDetails.RoomDetail.Type.replaceAll("|","&"):hotel.RoomDetails.RoomDetail.Type}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                    {String(hotel.RoomDetails.RoomDetail.TotalRate).includes("|")?calccost(hotel.RoomDetails.RoomDetail.TotalRate):Math.round(hotel.RoomDetails.RoomDetail.TotalRate*oldcurrency.usd_inr)}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                      {hotel.RoomDetails.RoomDetail.BoardBasis.includes("|")?hotel.RoomDetails.RoomDetail.BoardBasis.replaceAll("|","\n"):hotel.RoomDetails.RoomDetail.BoardBasis}
                                    </TableCell>
                                    <TableCell width={width / 6}>
                                      {"RoomDescription" in hotel.RoomDetails.RoomDetail && hotel.RoomDetails.RoomDetail.RoomDescription.includes("|")?hotel.RoomDetails.RoomDetail.RoomDescription.replaceAll("|","\n"):hotel.RoomDetails.RoomDetail.RoomDescription}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                      {"CancellationPolicy" in hotel.RoomDetails.RoomDetail && hotel.RoomDetails.RoomDetail.CancellationPolicy.Refundable == "Yes"
                                        ? "Refundable"
                                        : ""}
                                      {"CancellationPolicy" in hotel.RoomDetails.RoomDetail && "TillDate" in hotel.RoomDetails.RoomDetail.CancellationPolicy
                                        ? " till "+hotel.RoomDetails.RoomDetail.CancellationPolicy.TillDate
                                        : ""}
                                    </TableCell>
                                    {/* <TableCell width={width/10}>
        {hotel.RoomDetails.RoomDetail.ChildrenAges.map(cp=>
<div>
  {cp.name} {cp.value}
</div>
        )}
        </TableCell> */}
                                    <TableCell width={width / 8}>
                                      A:{hotel.RoomDetails.RoomDetail.Adults} C:{hotel.RoomDetails.RoomDetail.Children}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                    {/* <Link to={{pathname:"/hotelbook",state:{hotels:hotelData,hotel:hotel,hotel.RoomDetails.RoomDetail:hotel.RoomDetails.RoomDetail},}} target="_blank"> */}
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={e=>replacehotel(e, hotel.RoomDetails.RoomDetail, hotel)}
                                        className={classes.button2}
                                      >
                                        Replace
                                      </Button>
                                      </TableCell>
                                      <TableCell width={width / 12}> 
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={e=>usehotel(e, hotel.RoomDetails.RoomDetail, hotel)}
                                        className={classes.button2}
                                      >
                                        Use
                                      </Button>
                                      {/* </Link> */}
                                    </TableCell>
                                  </TableRow>
                              </div>
                            )}
                              
                            {/* </div>
                          ) : (
                            ""
                          )} */}
                        </Table>
                        <hr></hr>
                      </div>
                    ))}
            </div>):(<h1>Inventory not found</h1>)}
            
            </div>)}
            </div>
            )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={Open9} onClose={handleClose9}>
        {responseData3?(
          <div>
            {"CancellationInformations" in responseData3 && "CancellationInformation" in responseData3.CancellationInformations?(
              <div>
              {Array.isArray(responseData3.CancellationInformations.CancellationInformation)?(
                <div>
                {responseData3.CancellationInformations.CancellationInformation.map(ci=>
              <h3 className={classes.headertext}>From {ci.StartDate} to {ci.EndDate} - {ci.ChargeAmount} {ci.ChargeType} {ci.Currency}</h3>
              )}
              </div>
              ):(<div>
                <h3 className={classes.headertext}>From {responseData3.CancellationInformations.CancellationInformation.StartDate} to {responseData3.CancellationInformations.CancellationInformation.EndDate} -  {responseData3.CancellationInformations.CancellationInformation.ChargeAmount} {responseData3.CancellationInformations.CancellationInformation.ChargeType} {responseData3.CancellationInformations.CancellationInformation.Currency}</h3>
              </div>)}
              
              </div>
            ):("Cancellation Policy not found")}
          </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="xl" open={Open14} onClose={handleClose14}>
        <a
          href="https://docs.google.com/spreadsheets/d/19Wf3-D1hW-SILdEip0F6Gf9ypBlBIUxWQX2xFwYX1J8"
          rel="noopener noreferrer"
          target="_blank"
          variant="h6"
          align="center"
          className={classes.headertext}
        >
          {" "}
          Doc Link for Airport codes
        </a>
        <form onSubmit={handleSubmit2}>
        <FormGroup row className={classes.formgroup}>
                
        <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Adults"># Adults (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Adults (12+ years)"
                required
                variant="outlined"
                value={searchData.number_adults}
                onChange={(e) => setsearchData({...searchData, number_adults:e.target.value})}
              >
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Child"># Child (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Child (2-12 years)"
                required
                variant="outlined"
                value={searchData.number_child}
                onChange={(e) => setsearchData({...searchData, number_child:e.target.value})}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Infant"># Infant (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Infant (0-1 years)"
                required
                variant="outlined"
                value={searchData.number_infant}
                onChange={(e) => setsearchData({...searchData, number_infant:e.target.value})}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
                
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                
                
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Type</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="Journey Type"
                        required
                        variant="outlined"
                        value={searchData.type}
                        onChange={(e) => controlleg(e.target.value)}
                      >
                        <MenuItem value={"One-way"}>One-way</MenuItem>
                        <MenuItem value={"Return"}>Return</MenuItem>
                        <MenuItem value={"Multi-stop"}>Multi-stop</MenuItem>
                        <MenuItem value={"Advanced Search"}>Advanced Search</MenuItem>
                        <MenuItem value={"Special Return"}>Special Return</MenuItem>
                       
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="Stops"
                        required
                        variant="outlined"
                        value={searchData.stops}
                        onChange={(e) => setsearchData({...searchData, stops:e.target.value})}
                      >
                        <MenuItem value={0}>0 </MenuItem>
                        <MenuItem value={1}>1 </MenuItem>
                        <MenuItem value={"Any"}>Any </MenuItem>
                        
                      </Select>
                    </FormControl>
                        
                    </FormGroup>
                    <hr></hr>
                    {airportdata.length>0 && airportdata.map(leg => {
            return(
            <div>
            <FormGroup row className={classes.formgroup}>
            <Typography className={classes.textField6}>{"Leg "+(airportdata.indexOf(leg)+1)}</Typography>
            
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Source">From</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField6}
                labelId="Source"
                required
                name={airportdata.indexOf(leg)}
                variant="outlined"
                value={leg.source}
                onChange={(e) => sourcechange(e, e.target.name, leg.id)}
              >
                {airportlist2.map(data=>
                    <MenuItem value={data.city}>{data.city}</MenuItem>
                  )}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Destination">To</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField6}
                labelId="Destination"
                name={airportdata.indexOf(leg)}
                variant="outlined"
                value={leg.dest}
                onChange={(e) => destchange(e, e.target.name, leg.id)}
              >
                {airportlist2.map(data=>
                    <MenuItem value={data.city}>{data.city}</MenuItem>
                  )}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              type="date"
              name={airportdata.indexOf(leg)}
              inputProps={{ min: airportdata[airportdata.indexOf(leg)-1] && "date" in airportdata[airportdata.indexOf(leg)-1]?airportdata[airportdata.indexOf(leg)-1].date:fupfinalDate2 }}
              label="Date"
              required
              value={leg.date}
              className={classes.textField6}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => datechange(e, e.target.name, leg.id)
              }
            />
            
                    </FormGroup>
                    <FormGroup row className={classes.formgroup}>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Cabin Class</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Cabin Class"
                        required
                        variant="outlined"
                        value={leg.cabin_class}
                        onChange={(e) => classchange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        <MenuItem value={"Economy"}>Economy </MenuItem>
                        <MenuItem value={"Premium Economy"}>Premium Economy </MenuItem>
                        <MenuItem value={"Business"}>Business </MenuItem>
                        <MenuItem value={"Premium Business"}>Premium Business </MenuItem>
                        <MenuItem value={"First"}>First </MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Departure Time"
                        required
                        variant="outlined"
                        value={leg.departure_time}
                        onChange={(e) => departurechange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"Morning"}>Morning</MenuItem>
                        <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                        <MenuItem value={"Evening"}>Evening</MenuItem>
                        <MenuItem value={"Night"}>Night</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                        name={airportdata.indexOf(leg)}
                        classname={classes.textField}
                        labelId="Ariival Time"
                        required
                        variant="outlined"
                        value={leg.arrival_time}
                        onChange={(e) => arrivalchange(e, e.target.name, leg.id)}
                      >
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"Morning"}>Morning</MenuItem>
                        <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                        <MenuItem value={"Evening"}>Evening</MenuItem>
                        <MenuItem value={"Night"}>Night</MenuItem>
                      </Select>
                    </FormControl>
                    
          </FormGroup>
    
           
            </div>)
          })}
           <FormGroup row className={classes.formgroup}>
           {control?(<div>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addsp}
            >
              {" "}
              + Leg
            </Button>
            
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removesp}
              
            >
              {" "}
              - Leg
            </Button>
           </div>):("")}
             
                <Button variant="contained" color="primary" onClick={TCFlightSearch} className={classes.button}>Search</Button>
                
            </FormGroup>
            </form>
            <br></br>
            <hr></hr>
            <hr></hr>
            {status === "Normal" ? (
              ""
            ) : (
              <div>
                {status == "searching" ? (
                  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
            <LinearProgress color="secondary" />
            <LinearProgress color="primary" />
            <LinearProgress color="inherit" />
          </Stack>
                ) : (
                  <div>
                {tcresultpass && tcresultpass.length>0?(
                  <Typography variant="h4" className={classes.red}>Selected Flights</Typography>
                ):("")}  
                {tcresultpass && tcresultpass.length>0?(
                  <div>
                  {tcresultpass.map(result=>
                    <div>
                   
                   <Typography variant="h6" className={classes.black}>Result {tcresultpass.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                                    <br></br>
                                  
                                    {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+segment.gT+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                                  <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result.iR} || Remark: {result.ar} 
                                  </Typography>
                                  <FormGroup row className={classes.formgroup}>
                    {tcresultpass.indexOf(result)+1==tcresultpass.length?(
                                  <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCprebook()}
                    
                    className={classes.button}
                  >
                    Proceed
                  </Button>
                ):("")}            
                                 
                                 </FormGroup>
                                  
                                 <hr></hr>
                                  
                                  </div>
                  )}
                 
                  </div>
                ):("")}
                {searchResponse && "traceId" in searchResponse?(<div>
                  
                  
                
                  {"results" in searchResponse?(
                    <div>
                    <hr></hr>
                    {/* <h3>For return flights:</h3> */}
                    <FormGroup row className={classes.formgroup}>
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Departure Time</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Departure Time"
                    
                        variant="outlined"
                        value={filterData2.departure}
                        onChange={(e) => setfilterData2({...filterData2, departure:e.target.value})}
                      >
                     
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Arrival Time</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Arrival Time"
               
                        variant="outlined"
                        value={filterData2.arrival}
                        onChange={(e) => setfilterData2({...filterData2, arrival:e.target.value})}
                      >
                      
                        <MenuItem value={"All Day"}>All Day</MenuItem>
                        <MenuItem value={"00-08"}>00-08</MenuItem>
                        <MenuItem value={"08-14"}>08-14</MenuItem>
                        <MenuItem value={"14-19"}>14-19</MenuItem>
                        <MenuItem value={"19-23"}>19-23</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Duration</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Duration"
               
                        variant="outlined"
                        value={filterData2.duration}
                        onChange={(e) => setfilterData2({...filterData2, duration:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl>
                    
                  </FormGroup>
                  <FormGroup row className={classes.formgroup}> 
                  
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stops</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Stops"
               
                        variant="outlined"
                        value={filterData2.stops}
                        onChange={(e) => setfilterData2({...filterData2, stops:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Baggage</InputLabel>
                      <Select
                    
                        classname={classes.textField}
                        labelId="Baggage"
               
                        variant="outlined"
                        value={filterData2.baggage}
                        onChange={(e) => setfilterData2({...filterData2, baggage:e.target.value})}
                      >
                       <MenuItem value="">Clear</MenuItem>
                       <MenuItem value={"0"}>0</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                      </Select>
                    </FormControl>
                    {/* <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Stopover</InputLabel>
                      <Select
                     
                        classname={classes.textField}
                        labelId="Stopover"
                    
                        variant="outlined"
                        value={filterData2.stopover}
                        onChange={(e) => setfilterData2({...filterData2, stopover:e.target.value})}
                      >
                     
                     <MenuItem value="">Clear</MenuItem>
                        <MenuItem value={"0-4 hrs"}>0-4 hrs</MenuItem>
                        <MenuItem value={"4-8 hrs"}>4-8 hrs</MenuItem>
                        <MenuItem value={"8-12 hrs"}>8-12 hrs</MenuItem>
                        <MenuItem value={"12-16 hrs"}>12-16 hrs</MenuItem>
                        <MenuItem value={"16-20 hrs"}>16-20 hrs</MenuItem>
                        <MenuItem value={"20-24 hrs"}>20-24 hrs</MenuItem>
                        <MenuItem value={"24+ hrs"}>24+ hrs</MenuItem>
                      </Select>
                    </FormControl> */}
               
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Airline</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="airline"
                        variant="outlined"
                        value={filterData2.airline}
                        onChange={(e) => setfilterData2({...filterData2, airline:e.target.value})}
                      >
                      <MenuItem value="">Clear</MenuItem>
                       {airlinelist2.map((airline)=>
                       <MenuItem value={airline}>{airline}</MenuItem>
                        )}
                       
                      </Select>
                    </FormControl>
                    </FormGroup>
                  </div>
                  ):("")}
                
                  <FormGroup row className={classes.formgroup}>    
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={newtcfilterresults}
                    
                    className={classes.button}
                  >
                    Filter
                  </Button>
                   </FormGroup>
                 
              
              {"results" in searchResponse && "inboundFlights" in searchResponse.results && searchResponse.results.outboundFlights.length>0&& searchResponse.results.inboundFlights.length>0?(
                <div>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="basic tabs example"
      centered
    >
      <Tab label="Segment 1" {...a11yProps(0)} />
      <Tab label="Segment 2" {...a11yProps(1)} />
     </Tabs>
  </Box>
  <TabPanel value={value} index={0}>
  {searchResponse.results.outboundFlights.map(result=>
  <div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.results.outboundFlights.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                     <br></br>
                   
                     {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+Math.floor(segment.gT/60)+" hrs"+segment.gT%60+" mins"+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Refundable: {result.iR} || Remark: {result.ar} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCfarerule(result, "OB")}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                 
                  
                  </FormGroup>
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
  <TabPanel value={value} index={1}>
  {searchResponse.results.inboundFlights.map(result=>
  <div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.results.inboundFlights.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                     <br></br>
                   
                     {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+Math.floor(segment.gT/60)+" hrs"+segment.gT%60+" mins"+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Refundable: {result.iR} || Remark: {result.ar} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCfarerule(result, "IB")}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                 
                  
                  </FormGroup>
                  <hr></hr>
                   
                   </div>)}
  </TabPanel>
              </div>
              ):
              ( 
              <div>
           
 
              {searchResponse.results.outboundFlights.map(result=>
              <div>
               
              {"inboundFlights" in result?(
                <div>
   <Typography variant="h6" className={classes.black}>Result Set {searchResponse.results.outboundFlights.indexOf(result)+1} </Typography>
       
  
  {!inbound && result.outboundFlight.map(result2=>
                  
                <div>
               
                   <Typography variant="h6" className={classes.black}> (LCC: {result2.iL?"True":"False"} || Fare Type: {result2.pFC}) || Price: {result2.fF}</Typography>
                                    <br></br>
                                  
                                 
                                   
                                   
                                      <Typography variant="h6" className={classes.red}>
                                    {"GroundTime:"+Math.floor(result2.gT/60)+" hrs"+result2.gT%60+" mins"+ "|| Stop Point:"+result2.sP+" || Stop Duration: "+Math.floor(result2.sD/60)+" hrs"+result2.sD%60+" mins"+" || Seats Left: "+result2.nOSA}
                                  </Typography>
                                  <br></br>
                                      <Typography variant="h6" className={classes.orange}>
                                    Airline: {result2.al.alN} ({result2.al.alC}-{result2.al.fN}{result2.al.fC}) || Class: {getclass(result2.cC)} || Baggage: {result2.bg}  || CabinBaggage: {result2.cBg} || Flight Duration: {Math.floor(result2.dr/60)+" hrs"+result2.dr%60+" mins"}
                                  </Typography>
                                  
                                  <Typography variant="h6" className={classes.blue}>Origin-Destination: {result2.or.cN} ({result2.or.aC}) - Terminal {result2.or.tr} --------------------- {"> "+result2.ds.cN} ({result2.ds.aC}) - Terminal {result2.ds.tr} </Typography> 
                                  <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(result2.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(result2.ds.aT).toLocaleString("en-IN")}</Typography>
                                  <br></br>
                                 
                                  
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result2.iR} || Remark: {result2.ar} 
                                  </Typography>
                                 
                                  
                              
                                  
                                  </div>
              )}
              {inbound?(""):(
  <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>showinbound(searchResponse.results.outboundFlights.indexOf(result)+1)}
                    
                    className={classes.button}
                  >
                    Show Inbound
                  </Button>
   )}

   
   {inbound && inboundindex && searchResponse.results.outboundFlights.indexOf(result)+1==inboundindex && result.inboundFlights.map(result2=>
                <div>
                <Typography variant="h6" className={classes.black}>Inbound Flight</Typography>
                   <Typography variant="h6" className={classes.black}> Inbound result: {result.inboundFlights.indexOf(result2)} (LCC: {result2[0].iL?"True":"False"} || Fare Type: {result2[0].pFC}) || Price: {result2[0].fF}</Typography>
                                    <br></br>
                                  
                                 {result2[0].sg.map(segment => 
                                 <div>
                                   
                                   
                                      <Typography variant="h6" className={classes.red}>
                                    {"GroundTime:"+Math.floor(segment.gT/60)+" hrs"+segment.gT%60+" mins"+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                                  </Typography>
                                  <br></br>
                                      <Typography variant="h6" className={classes.orange}>
                                    Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                                  </Typography>
                                  
                                  <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                                  <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                                  <br></br>
                                  </div>)}
                                  <Typography variant="h6" className={classes.red}>Price: INR {result2[0].fF} </Typography>
                                    <br></br>
                                  <Typography variant="h6" className={classes.black}>
                                    Refundable: {result2[0].iR} || Remark: {result2[0].ar} 
                                  </Typography>

                                  <FormGroup row className={classes.formgroup}>
                                  <Button
                                   variant="contained"
                                   color="primary"
                                   onClick={()=>TCfarerule2(result,result2[0])}
                                   
                                   className={classes.button}
                                 >
                                   Select
                                 </Button>
                                 <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>showoutbound()}
                    
                    className={classes.button}
                  >
                    Show Outbound
                  </Button> 
                                 
                                 </FormGroup>
                                  
                                 <hr></hr>
                                  
                                  </div>
              )}
              {/* {inbound?(
 <FormGroup row className={classes.formgroup}>
              <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>showoutbound()}
                    
                    className={classes.button}
                  >
                    Show Outbound
                  </Button>  
                 
                </FormGroup>
               ):("")} */}

              
                </div>
              ):(
  <div>
                   
    <Typography variant="h6" className={classes.black}>Result {searchResponse.results.outboundFlights.indexOf(result)+1} (LCC: {result.iL?"True":"False"} || Fare Type: {result.pFC}) || Price: {result.fF}</Typography>
                     <br></br>
                   
                  {result.sg.map(segment => 
                  <div>
                    
                    
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime:"+Math.floor(segment.gT/60)+" hrs"+segment.gT%60+" mins"+ "|| Stop Point:"+segment.sP+" || Stop Duration: "+Math.floor(segment.sD/60)+" hrs"+segment.sD%60+" mins"+" || Seats Left: "+segment.nOSA}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {segment.al.alN} ({segment.al.alC}-{segment.al.fN}{segment.al.fC}) || Class: {getclass(segment.cC)} || Baggage: {segment.bg}  || CabinBaggage: {segment.cBg} || Flight Duration: {Math.floor(segment.dr/60)+" hrs"+segment.dr%60+" mins"}
                   </Typography>
                   
                   <Typography variant="h6" className={classes.blue}>Origin-Destination: {segment.or.cN} ({segment.or.aC}) - Terminal {segment.or.tr} --------------------- {"> "+segment.ds.cN} ({segment.ds.aC}) - Terminal {segment.ds.tr} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Departure-Arrival: {new Date(segment.or.dT).toLocaleString("en-IN")} -------------------- {"> "+new Date(segment.ds.aT).toLocaleString("en-IN")}</Typography>
                   <br></br>
                   </div>)}
                   <Typography variant="h6" className={classes.red}>Price: INR {result.fF} </Typography>
                     <br></br>
                   <Typography variant="h6" className={classes.black}>
                     Refundable: {result.iR} || Remark: {result.ar} 
                   </Typography>
                   <FormGroup row className={classes.formgroup}>
                   <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>TCfarerule(result, "OB")}
                    
                    className={classes.button}
                  >
                    Select
                  </Button>
                 
                  
                  </FormGroup>
                   
                  <hr></hr>
                   
                   </div>)}
                   </div>)}
   
              </div>
              )}
           
                </div>):(<div>
                  <h2>Waiting for response</h2>
                </div>)}

                </div>)} 
                </div>)}
      </Dialog>
        </div>
     );
}
 

 
export default Quotedataupdate;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}